module.exports = {
  BusinessNo: '取引番号',
  WarehouseNo: '入庫番号',
  MasterBillNo: 'MBL番号',
  HBL: 'HBL',
  FileNo: 'ファイル番号',
  BookingNo: 'BOOKING NO.',
  ItemNo: 'アイテム番号',
  BusinessReferenceNo: '参照番号',
  BillNo: '請求書番号',
  PreBookingNo: '事前ブッキング番号',
  CBANumber: 'CBA Number',
  CustomsStatus: 'Customs status',
  CustomsStatusUpdateTime: '税関の更新時間です',
  ReceiptDetails: '返送明細',
  CustomsBrokerStatus: 'Customs broker status',
  CustomsReceiptRecord: 'Customs receipt record',
  CustomsTime: 'Customs time',
  CustomsCode2: 'Customs code',
  UnifiedCoding: 'Unified coding',
  CustomsDescription: 'Customs Description',
  HBLSplitCombineNo: 'HBL分割番号',
  MBLSplitCombineNo: 'MBL分割番号',
  ConsignationCompany: '委託先コード／名称',
  BookingAgent: 'ブッキング代理店',
  BookingOrExchangeAgent: 'ブッキング代理店',
  CarrierAgent: '船社代理',
  ShippingCompany: '船会社',
  OperateCarrier: 'しゅせん会社',
  VSACarrier: 'コモンシップ会社',
  InternalVoy: '内部航路',
  CopyShip: 'メイン船東情報をコモン船東にコピー',
  ContainerNo: 'コンテナ番号',
  BoxController: 'コンテナ管理者',
  LFD: 'LFD',
  CarNumber: '車両番号',
  ContainerNoOutOfRange: 'コンテナ番号が制限を超えています',
  CurrentVehicleLocation: '現在の車両位置',
  TravelTrajectory: '旅行軌跡',
  DrivingState: '現在の運転状態',
  PortOfLoading: '積出港（POL）',
  PortOfLoadingPOR: '積み込み港（POR）',
  TransitPort: '中継港',
  PortOfDestination: '到着港',
  PortOfDestinationPod: '目的港',
  PortOfDischarge: '荷役港（POD）',
  PortOfDischargeSeaAndComprehensive: '陸揚げ港（海運/総合）',
  DischargingPortCountry: '陸揚げ港国',
  DestinationPortCountry: '対象港国',
  dischargingPort: '荷卸港',
  DeliveryCountry: '配送国',
  FirstPortOfDischarge: '第1荷卸港',
  branchLineDateOfDeparture: '支線出発日付',
  branchLineDateOfArrival: '支線到着日付',
  DateOfDeparture: '出発日付',
  DateOfDeparture2: 'ETD',
  BookingDate: 'ブッキング日付',
  BargeDateOfDeparture: '支線船出港日',
  BargeCYCutOffDate2: 'バージCYカットオフ日付',
  BargePortOfLoading: 'バーゲ積港（POL）',
  BargeVessel: 'バージ船名',
  BargeVoyage: 'バーゲ航次',
  BargePOL: 'バージPOL',
  SecondDateOfDeparture: '2次出発日',
  DeliveryCompletionDate: '配達完了日',
  DateOfArrival: '到着日',
  DateOfArrival2: '到着日（ETA）',
  DateOfArrival3: '到着日',
  DateOfCreation: '作成日',
  CYCutOffDate2: 'CYカットオフ日',
  DocCutOffDate: '書類締切日',
  DeclareCutOffDate: '申報カットオフ日',
  LoadingDate: '積み込み日',
  PreAuditTime: '事前確認時間',
  CallSignOfBookingShip: '予約船の呼出符号',
  MasterBLFreightTerm: 'MBL運賃条件',
  MasterBLFreightTermTootip: 'MBL運賃条件',
  MasterBLFreightTermT: 'MBL FRT Term',
  OrderChannels: '注文チャンネル',
  CargoType: '貨物分類コード',
  Shipper: '出荷人',
  ShipperCode: '出荷人 code',
  Consignee: '受取人',
  ConsigneeCode: '受取人 code',
  SONO: 'SO NO.',
  ShippingCompanyContractNo: '船会社契約番号',
  CargoInsuranceUnit: '貨物保険単位',
  ValidityStartDate: '有効期間開始日',
  ValidityEndDate: '有効期間終了日',
  PleaseEnterTheShippingCompanyContractNumber: '船会社の契約番号を入力してください',
  CargoInsuranceQuantity: '貨物保険数量',
  InnerContractNo: '内部契約番号',
  HBLRemarks: 'HBL備考',
  quotationNum: '見積番号',
  Vessel: '船名',
  Voyage: '航次',
  CarrierVoyage: 'キャリア番号',
  OperationDepartment: '業務部門',
  SalesDepartment: '営業部門',
  FLCLType: '混載種別',
  ExportControlledProducts: '輸出管製品',
  LocalService: '現地サービス',
  NotLocalService: '現地サービスはありません',
  SolicitationType: '積載タイプ',
  SO_NO1: 'S/O No.',
  MBL_NO: 'MB/L No.',
  ServiceProduct: 'さーびすせいひん',
  WoodOrNotWood: '木材/非木材',
  HazardousGoodsOption: '危険物オプション',
  ContractRateProperty: '契約レートの性質',
  IsNac: 'NACかどうか',
  ApplicableProductName: '適用品名',
  PleaseEnterNAC: 'NACを入力してください',
  CargoInsurance: '船内保険',
  ShutOut: '出港拒否',
  ShutOutDate: '出港拒否時間',
  handlingInformation: 'Handling Information',
  CancelShutOut: '出港拒否をキャンセルする',
  ABargeOrNot: 'バージがあるかどうか',
  yes: 'はい',
  no: 'いいえ',
  Operation: '操作',
  Sales: '販売',
  CustomerService: 'カスタマーサービス担当',
  Documents: '関連書類',
  Airline: '航空会社',
  PreAuditPerson: ' 事前確認者',
  Creator: '作成者',
  Code: 'コード',
  Accrued: '蓄積済み',
  AirlineCode: '航路コード',
  ShowRelevantBusiness: '関連注文表示',
  CustomsBroker: '通関業者名／通関担当者',
  AdvancePayment: '関税立替払い',
  HasPrintBooking: '是否打印托书',
  PaymentTime: '納税時間',
  CustomsDutyAmount: '関税金額',
  VatAmount: ' 消費税金額',
  TaxRemarks: '税金備考',
  Warehouse: '倉庫',
  HaulageCompany: '運送会社',
  CarryingCmpAdjustBlockedTip: '選択した注文にドア積込/集荷未チェックのものがあるため、运送会社を変更できません',
  AbnormalBusinessNo: '異常業務番号',
  TradeTerms2: '貿易条件',
  BusinessStatus: 'ビジネス処理状況',
  StatusTracking: 'ステータス追跡',
  AuditStatus: '審査処理状況',
  Display: '表示',
  Query: 'データ検索',
  Return: '戻る',
  Prompt1: 'ビジネス番号を入力して検索してください',
  ResetFilter: 'フィルターをリセット',
  Tip1: 'ダブルクリックでSOP処理状況を表示',
  TipCharge: 'クリックしてビジネスの基本情報を表示',
  MBLIssueBillLading: 'MBLサレンダー状態',
  HBLIssueBillLading: 'HBLサレンダー状態',
  ConsignationRelationNumber: '委託関連番号',
  BusinessCommissionedRelationNumber: '取引関連番号',
  ChannelNo: 'チャネル番号',
  Customer: '顧客',
  ConsignationStatus: '委託処理状況',
  ConsignationStatusTime: '委託処理状況時間',
  PlaceOfDelivery: '納品場所',
  FinalPlaceOfDelivery: '最終納入場所',
  AirlineArea: '航空路線（地域）',
  SequenceNumber: 'No.',
  Tip2: 'データプッシュ記録の検索',
  View: '表示',
  Edit: '編集',
  Cancel: 'キャンセル',
  SaveTheDefaultValues: 'デフォルト値を保存',
  NominatedAgent: '指名貨代理人',
  NominatedAgentCount: '指名貨代理人数',
  ActualQuantity: '実際数量',
  ActualWeight: '実際重量',
  ActualVolume: '実際の体積',
  ChargedWeight: '計算重量',
  VolumetricWeight: '容積重量',
  ChargedWeightRT: 'RT請求重量',
  BookingProperty: '予約の性質',
  IssueMethod: '発行方法',
  TradeMethod: 'トレード方式',
  HBLFreightClause: 'HBL運賃条件',
  HBLFreightClauseTootip: 'HBL運賃条件',
  MBLTransportationClause: 'MBL輸送条件',
  MBLTransportationClauseTootip: 'MBL輸送条件',
  HBLTransportationClause: 'HBL運送条件',
  HBLTransportationClauseTootip: 'HBL運送条件',
  ContainerDescription: 'コンテナサイズ・数量',
  FeeCreationDate: '料金作成日',
  MBLSplitNo: 'MBL分割番号',
  HBLSplitNo: 'HBL分割番号',
  HarborDistrict: '港区',
  SOPStatus: 'SOP処理状況',
  HDS: 'HDS',
  TEU: 'コンテナ容量（TEU）',
  AirlinePerson: '航空会社（担当者）',
  AirlinePerson2: '航空会社担当者',
  AirlineOffice: '航路会社',
  AirlineDepartment: '航路部門',
  BusinessCreator: '取引登録者',
  Status: '処理状況',
  HblNo: 'HBL NO',
  RelevanceSoNo: 'Relevance SO NO',
  DangerousGoodsClassification: '危険物品分類',
  DangerousGoodsUNNo: '危険物品国連番号',
  FinalDestination: '最終仕向地',
  HBLShipper: '分輸送書発送人',
  HBLConsignee: '分輸送書受取人',
  Add: '追加',
  Delete: '削除',
  AddHbl: 'HBL追加',
  SplitHbl: 'HBL分割',
  ExportToExcel: 'Excel導出',
  OverseasAgentEDI: '海外代理店EDI',
  EditSopStatus: '状態変更',
  BatchPrint: 'バッチ印刷',
  BatchVessel: 'バッチ転船',
  Statistics: '統計照会',
  BatchCommit: 'バッチ承認',
  AddCharges: '料金追加',
  EditCharges: '料金編集',
  DeleteCharges: '料金削除',
  print: 'プリント',
  PrintFclProfit: 'プリントFCL利益',
  PrintLclProfit: 'LCL利益印刷',
  PreSubmission: '事前提出',
  BatchPreSubmission: '一括事前提出',
  BatchCancellation: '大量廃棄です',
  Submission: '提出',
  SubmissionDateTime: '提出日／提出時刻',
  AuditDateTime: '監査実施日',
  Consignation: '委託',
  FreightStation: '貨物駅',
  SignBill: '請求書にサインする',
  ConsignationSI: '輸出から輸入への転換',
  CrossTenantSeToSiEtaMustNoNull: '必須入力フィールドである予想着港日を補完してください。 このフィールドは、イン   ポート側で必須です！',
  ReturnAction: '操作内容を返す',
  PrintReturn: '引き戻す',
  AssociationBusinessInformation: '関連業務情報',
  AssociationBusinessInformationSI: '関連輸入業務情報',
  ShowAssociationBusinessInformationSI: '関連海上輸入業務情報の表示',
  Basic: '基本',
  Booking: '予約',
  EnterTheCabin: 'Enter the cabin',
  DataTracking: 'データ追跡',
  AirDataTracking: 'Air Data Tracking',
  CustomsDeclaration: '通関手続き',
  InsureInfo: 'Insure',
  Mbl: 'MBL',
  Hbl: 'HBL',
  HouseBillOfLading: 'HB/L',
  FormalHbl: '分割伝票の形式',
  Vgm: 'VGM',
  AmsEns: 'AMS/ENS',
  Hds: 'HDS',
  CommodityInspection: '商検査',
  Fumigation: '燻蒸',
  ForeignTrade: '外国貿易',
  ConsignInfo: '委託情報',
  RequiredItem: '必須項目',
  CustomerProperty: '顧客属性',
  ContactPerson: '連絡先',
  CustomerContactPerson: '顧客連絡先',
  ContactPhone: '顧客電話番号',
  ContactMobile: '顧客携帯電話番号',
  Detail: '詳細',
  OperationDate: '処理日',
  PlaceOfDelivery2: '受け取り場所',
  Transit: 'トランジット',
  PleaseSelectShippingCompany: '船会社を選択してください',
  AdditionalInformation: '追加情報',
  WarehouseLoadingStorage: 'コンテナ内積み / 倉庫保管',
  DoorLoadingDelivery: 'ドア引き取り / 納品',
  NotResponsibleForTruckingAndLoading: '顧客トラック運転手配',
  AutoDistribution: '自動配送',
  ObtainTheWarehouseNo: '倉庫番号を取得する',
  MblNo3: 'マスターブルーノ',
  MasterBusinessNo: 'マスター業務番号',
  PleaseTickCustomsDeclarationOption: '【通関】オプションを選択してください',
  PleaseTickDoorLoadingDeliveryOption: '【ドア引き取り / 納品】オプションを選択してください',
  PleaseSelectWarehouse: '【コンテナ内積み / 倉庫保管】オプションを選択してください',
  PleaseCheckWarehouses: '【倉庫保管】オプションを選択してください',
  PlaceOfMblPayment: 'MBL支払い場所',
  PlaceOfHblPayment: 'ハウスブルー支払場所',
  CargoSize: '貨物サイズ',
  SpecialPriceInstructions: '特別価格説明',
  DirectBusiness: '直接業務',
  Transport: '輸送',
  InBatches: '分割',
  SpecialPrice: '特別価格',
  ContainerInfo: 'コンテナ情報',
  QuantityConsignActual: '実際の数量（委/実）',
  WeightConsignActual: '実際の重量（委/実）',
  WeightUnit: '総重量単位',
  CubageConsignActual: '実測体積',
  VolumetricWeightConsignActual: '材積量（実/委）',
  ChargeWeightConsignActual: '計量重量（委/実）',
  CubageUnit: '体積単位',
  Package: 'パッケージ',
  Pieces: '小口数',
  PiecesType: '小口パッケージ',
  Copy2: 'コピー',
  EnglishDescriptionOfGoods: '英語商品名',
  HblEnglishDescriptionOfGoods: 'HBL英語商品名',
  Marks: 'マーキング',
  NCReferenceNo: 'NC参照番号',
  SendProxyForecasts: 'Send proxy forecasts',
  SerialNumber: 'シリアル番号',
  Brand: 'ブランド',
  ProductiveYear: '生産年',
  CustomsValue: '税関価値',
  UnitType: '装置型式',
  DeviceType: '機器タイプカテゴリ',
  CountryOrigin1: '原産国',
  DeviceStatus: '設備状態（新旧）',
  HsCode: 'HSコード',
  ChineseDescriptionOfGoods: '貨物詳細',
  OperationInfo: '操作情報',
  SalesCompany: '販売会社',
  OperationCompany: '操作会社',
  OperationRequirements: '操作要件',
  DoubleClickToAddOperationRequirements: 'ダブルクリックして操作要件を追加',
  OperationTips: '操作ヒント',
  ExtraChargeClause: '付加料金条件',
  DoubleClickToAddExtraChargeClause: 'ダブルクリックして付加料金条件を追加',
  WarehousingInfo: '在庫情報',
  Remarks: '備考',
  BasicRemarks: 'メモ（基本）',
  manifestInformation: 'マニフェスト基本情報',
  manifestChannel: '予約マニフェストチャネル',
  CustomerDeliveryInfo: '顧客配送情報',
  CodeSearching: 'コード検索',
  CopyToSeller: '売り手にコピーします',
  CopyToBuyer: '買い手にコピーします',
  ExpandSellerBuyer: '売り手/買い手を展開します',
  NoHouseNumber: '番地はありません',
  NotifyParty: '通知先',
  NotifyPartyCode: '通知先 code',
  MblShipperLine1: 'マスタービル発送者',
  MblConsigneeLine1: 'MBL受取人',
  MblNotifyLine1: 'MBL通知先',
  DocDispatchingPlace: '提出書類発送場所',
  SecondNotifyParty: '第二通知先',
  PleaseSelect: '選択してください',
  Add2: '追加',
  WhetherDeclarations: '申告するかどうか',
  InBatchesOrNot: '分割するかどうか',
  BookingInfo: '予約情報',
  MultiJourneyAirline: 'たじゅうきこう司',
  NumberPasses: '行程数',
  MergingTickets: 'チケットのマージ',
  TicketsInfo: 'チケット情報',
  TotalTickets: '合計枚数',
  NewTickets: 'New House Shipment',
  EditTickets: 'チケットを編集する',
  AddTickets: 'チケットを追加する',
  RemoveTickets: 'チケットを削除する',
  DeleteTickets: 'チケットを削除する',
  Etd: 'ETD',
  SoNo: '通関番号',
  FunctionalOperation: '機能操作です',
  MblNo2: 'MB/L NO',
  BookingShipCallSign: '船名呼出符号',
  USAirlineInfo: '米国航空会社情報',
  PortInfo: '港湾情報',
  PolPortInfo: '出港港湾情報',
  AirPolPortInfo: 'Air POL Port Info',
  LocalTime: '（データが返されたのは現地時間）',
  TopLocalTime: 'お知らせ：時間は現地時間を示しています',
  PodPortInfo: '着港港湾情報',
  PodAirPortInfo: 'POD Air Port Info',
  PolPortInfoPrompt: 'オープンデータサービスが開始された後、オレンジ色のフィールドはデータ書き込みをサポートします',
  CYOpeningDate: 'オープン日',
  CYOpeningTime: 'ＣＹ　OPEN日',
  CYCutOffDate: 'カットオフ日',
  PortAreaCYCutOffTime: '港湾ゲート締切時間',
  PortAreaCYOpeningTime: '港域オープン時間',
  CarrierCyCutOffTime: '運送会社カットオフ時間',
  PlannedDateOfBerthing: '予定着岸日',
  PlannedDateOfLeavingBerth: '予定出港日',
  ActualDateOfBerthing: '実際接岸日',
  ActualDateOfLeavingBerth: '実際の出港日',
  PlannedDockingBerths: '予定着岸バース',
  EstimatedArrivalTime: '予定到着時間',
  EstimatedPortArrivalTime: '到港・到着予定時間',
  ArrivalTime: '実際の到着時間',
  CustomsClearance: '目的地の通関',
  ActualCustomsReleaseTime: '実際の解放時間',
  DeliveryTime: '配達予定時刻',
  ReturnTime: '返却時間',
  DeliveryTime2: '配達先倉庫への配達時間',
  DeliveryDate: '配達日',
  TheActualDockingBerths: '実際の着岸バース',
  ActualTimeOfArrivalThePort: '港到着実績時間',
  EquipmentEstimatedReturnTime: 'コンテナ返却予定日時',
  EquipmentEstimatedReturnTimeTootip: 'コンテナ返却予定日時',
  To: 'to',
  OtherInfo: 'その他情報',
  CyCode: 'コンテナヤードのコード',
  PortCodeOfDischarge: '荷卸し港のコード',
  EquipmentReceiptAddress: '書類受取り住所',
  EquipmentReceiptContactPerson: '書類受取り担当者',
  EquipmentReceiptContactWay: '書類受取り連絡先',
  CustomerCyCutOffDate: '顧客通関締切日',
  CustomerShutOutDate: '顧客退場日',
  AmsEnsCyCutOffDate: 'AMS / ENSカットオフ日',
  FreeDetension: 'コンテナ滞在無料期間',
  SecondVesselInfo: '海運二次情報',
  AirSecondVesselInfo: 'AirSecondVesselInfo',
  SecondVoyage: '二次航海',
  BargeInfo: '支線バージ情報',
  ServiceCode: '船会社航路コード',
  ModulesInfo: '配船情報',
  ShippingAdviceRemark: 'SHIPPINGADVICE備考',
  BookingConfirmationRemarks: '配船通知書備考',
  InviteToChecktheBL: 'HBLドラフト照合リンク',
  ConfirmChecking: '確認する',
  IdentificationList: 'Identification list',
  ChecktheBLBySmart: 'スマートで提出書類を確認する',
  ViewCheckingFile: '提出書類のファイルを表示する',
  CheckingHistory: '提出書類の履歴',
  UploadGuarantee: '保証書をアップロードします。',
  ReceiptHistory: '領収書の履歴',
  CopyTheDataBy: 'データをコピーする',
  CopyFromTheLastTime: '前回からコピーする',
  CopyFromOtherBill: '他の伝票からコピーする',
  CopyFromHbl: 'HBLからコピーする',
  CompleteTheDetails: '詳細を完成させる',
  Printed: '印刷済み',
  Locked: 'ロック済み',
  ShipperLocked: '発送人がロック済み',
  BlBeReleased: '異地にて提出書',
  BlEdi: 'ブッキングEDI',
  ManifestEdi: 'マニフェストEDI',
  ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS: 'シール番号後にパッケージ数、総重量、体積を表示する',
  PrintBargeVesselAndVoyage: 'バージ船名航次の印刷',
  ConsigneeShipperAndNotifyInfo: '荷受人・荷送人情報',
  Reset: 'リセット',
  CopyTheConsignee: '荷受人をコピーする',
  CargoInfo: '貨物情報',
  OnlyOriginalSend: 'オリジナルのみ送信可',
  OnlyAddAndDeleteSend: '修正・削除のみ送信可',
  NoSuccessAddAndDeleteNotSend: '送信失敗、修正または削除を再送信できません',
  NeedFillPortBeforeEnteringEU: 'EU入域前の港湾を記入必須',
  SyncContainerInfoTotal: 'キャビネット情報部品毛体を取ります',
  SyncContainerInfoContent: '情報の箱詰めの件をカバーして、毛体MBLをカバーしますか?',
  SyncContainerInfoQuantity: 'Qualtity（Container Info）: {0} -----> Qualtity（MBL）: {1}',
  SyncContainerInfoWeight: 'Weight（Container Info）: {0} -----> Weight（MBL）: {1}',
  SyncContainerInfoCubage: 'Cubage（Container Info）: {0} -----> Cubage（MBL）: {1}',
  NumberOfPackagesOnBl: 'ブッキング件数',
  Pieces2: '小口数',
  PiecesType2: '小口包装',
  Weight: '総重量',
  Cubage: '体積',
  CopyEnglishDescriptionOfGoodsFromReceipt: '荷受品名をコピー',
  CopyEnglishDescriptionOfGoodsFromHBL: 'HBL英語品名をコピー',
  CopyMarksFromHbl: 'HBL唛頭コピー',
  CapitalizedNumbersOfPackages: '件数を大文字で表示',
  TransportInfo: '輸送情報',
  VesselAndVoyage: '船名航海',
  PlaceOfReceipt: '発送地',
  PlaceOfReceiptOnBl: 'ブッキング発送地',
  PlaceOfReceiptCodeOnBl: '発送地（コード）',
  PlaceHolderPOR: 'ブッキング発送地コードを選択してください',
  PlaceOfReceiptOnBlTootip: 'ブッキング発送地',
  PortOfLoadingOnBl: 'ブッキング積み港',
  PortOfDischargeOnBl: 'ブッキング卸港',
  PlaceOfDeliveryOnBl: 'ブッキング配達地',
  BlFinalDestination: 'ブッキング最終目的地',
  MethodOfMblPayment: 'マスターB/L支払方法',
  PlaceOfMblPayment2: 'マスターB/L支払場所',
  TransportationClause: '輸送条件',
  NoOfOriginalBls: 'オリジナルB/L枚数',
  NoOfCopyBls: 'コピーB/L枚数',
  PlaceOfIssue: '発行場所',
  DateOfIssue: '発行日',
  HBLDateOfIssue: 'HBL発行日',
  BlRemarks: 'B/L備考',
  BlType: 'B/Lタイプ',
  HBLBlType: 'HBL B/Lタイプ',
  MBLBlType: 'MBL B/Lタイプ',
  MBLBlProperty: 'MBL B/L属性',
  HBLBlProperty: 'HBL B/L属性',
  LastEntryPort: '最後の入港港',
  BlProperty: 'B/L属性',
  CheckingStatus: 'B/Lチェック状態',
  BillLadingIssued: 'B/L発行状況',
  HBLCheckingStatus: 'HBL B/Lチェック状態',
  MBLCheckingStatus: 'MBL B/Lチェック状態',
  ReleasingStatus: '放出監査状況',
  HBLReleasingStatus: 'HBL放出状況',
  MBLReleasingStatus: 'MBL放出状況',
  ReleaseEligibleStatus: 'Release Eligibility',
  ReleaseEligibleYes: 'Releasable',
  ReleaseEligibleNo: 'Not Releasable',
  FormalHblReleaseType: '形式分单方式',
  FormalHblStatus: 'フォーム受注処理状況',
  FormalHblIssuedStatus: 'フォーム請求書発行処理状況',
  FormalHblType: 'フォーム請求タイプ',
  FormalHblCombineNo: 'フォーム分割と単番号',
  fields: 'フィールド',
  tab: 'タブ',
  hint: 'フィールドが一致しません、送信を確認しますか？',
  Audit: '監査',
  Payable: '支払い可能',
  CargoDetention: '貨物留置料',
  PaymentDate: '支払日',
  PaymentDate2: '支払い日',
  DateOfCargoDetention: '留置日',
  BlReleasingNo: 'ブッキングリリース番号',
  BlReleasingApplicationTime: 'ブッキングリリース申請時間',
  BlReleasingApplicationPerson: 'ブッキングリリース申請者',
  ParamRemark: '備考',
  ShippingCompanySCAC: '船社SCAC',
  OverseasAgentSCAC: '海外代理店SCAC',
  ShipperType: '発送人タイプ',
  ManifestDescriptionOfGoods: '船荷証明書の品名記述',
  ReasonOfCargoDetention: '留置の理由',
  HblNo2: 'HBL番号',
  MblNo: 'MBL番号',
  Quantity: '数量',
  WeightKg: '重量（KG）',
  CubageCbm: '体積（CBM）',
  ContainerAmount: 'コンテナ数量',
  CNTRNOSSEALNOS: 'コンテナシール情報',
  BillOfLadingPackingInfo: 'ブッキングパッキング情報',
  CopyMblConsignee: 'マスターB/L受取人をコピーする',
  CopyNominatedAgentInfo: '指定貨代情報をコピーする',
  PrintTheOriginalBl: '正本のブッキングリリース印刷',
  TelexRelease: 'テレックスリリース印刷',
  Unlock: 'ロック解除',
  AntiTerroristFormattedAddress: 'AHR関連情報',
  BlBeReleasedElsewhereOrNot: 'ブッキングリリースが他の場所で行われたかどうか',
  ClauseOfNoWoodPackingMaterial: '木材梱包以外の条件',
  AFRTheLastBill: 'AFR最後の請求書',
  CopyEnglishDescriptionOfGoodsFromMbl: 'MBLから英語品名をコピーする',
  CopyMarksFromMbl: 'MBL唛頭情報をコピーする',
  BillOfLadingNumber: 'ブッキング番号',
  HBLBillOfLadingNumber: 'HBLブッキング番号',
  MethodOfHblPayment: 'HBL支払方法',
  PlaceOfHblPayment2: 'HBL支払い場所',
  CheckingQuestions: 'チェック問題',
  BlType2: 'ブッキングリリースタイプ',
  HBLBlType2: 'HBLブッキングリリースタイプ',
  DataSent: 'データを送信しました',
  V3remind: 'まず、添付ファイルをコピーしてください',
  Completed: '完了しました',
  DateOfcompletion: '完了日時',
  paste: 'ファイルを貼り付ける',
  GenerationOfABillOfLading: 'ブッキングリリース生成',
  GenerationOfABillOfLading2: '代理人によるブッキングリリース生成',
  ShipperContactTelNo: '発送人連絡先電話番号',
  ConsigneeContactTelNo: '荷受人連絡先電話番号',
  NotifyPartyTelNo: '通知者の連絡先電話番号',
  ChargeClause: '支払条件',
  Amount: '金額',
  CopyCargoDescriptionAndMarks: '品名記述と唛頭をコピーする',
  CopyMbl: 'MBLコピー',
  RelatedMbl: 'マスターB/L関連付け',
  Add3: '追加',
  Copy: 'コピー',
  ImportOrder: '註文を導入します',
  ImportBusinessNo: '業務番号を導入します',
  SelectOrderNumber: '註文番号を選択します',
  Send: '送信',
  CheckStatus: '処理状況を確認',
  ImportButNotSend: 'インポートして未送信',
  CapitalizedNumbersOfEquipmentWeight: 'コンテナ重量大文字表記',
  AmsSplitNo: 'AMS分割番号',
  AmsNo: 'AMS番号',
  EManifestSplitNo: 'eManifest分割番号',
  EManifestNo: 'eManifest番号',
  BlSplitList: '提出書類リスト',
  sendStatusAMS: '送信処理状況(AMS)',
  sendStatusISF: '送信処理状況(ISF)',
  sendStatus: '送信処理状況',
  SealNoChangeAdfterInspection: '検査後にシール番号を変更する',
  AutoAllocation: '自動荷役',
  AutoAllocationContract: '自動荷役(委託)',
  CleanOutTheLoadingRecord: '積載記録をクリアする',
  DeleteTheLoadingRecord: '積載記録を削除する',
  CargoQuantityDescription: '貨物数量の説明',
  TotalNumberOfPackages: '総パッケージ数',
  ContainerSize: 'コンテナサイズ',
  ContainerType: 'コンテナ種別',
  ContainerWeight: 'コンテナ重量',
  SealNo: 'シール番号',
  GetContainerNo: 'コンテナ番号を取得する',
  TotalWeight: '総重量',
  TotalCubage: '総体積',
  Soc: '荷主コンテナ',
  Inspection: '検査',
  ApproachDate: '入場時間',
  PlayDate: '出場時間',
  LoadingPort: '積み込み港',
  TheArrivalOfPacketsSent: '到着報告書送信時間',
  CustomsClearanceInfo: '海关通関情報',
  DataTrackingBlHasNotContainer: '{0}のB/L番号は、データ比較機能を使用するために箱詳細情報ページに移動してから関連付けられます。このページにはコンテナの詳細情報が表示されます。',
  WharfReleaseInfo: '埠頭放行情報',
  ContainerAscription: 'コンテナ所属',
  PlateNumber: 'ナンバープレート',
  plateApproachDate: 'トラック入場時間',
  platePlayDate: 'トラック出場時間',
  PackageType: '包装タイプ',
  NumberOfVotes: '票数',
  EmptyContainerWeight: '空コンテナ重量',
  VgmWeight: 'VGM重量',
  VgmWeighingMethod: 'VGM計量方法',
  VgmWeighingTime: 'VGM計量時間',
  WeightTime: '計量時間',
  VgmWeighingPlace: 'VGM計量場所',
  StationStatus: 'ステーション状態',
  WeighingPartyAddress: '計量事業者住所',
  CargosGrossWeight: '貨物総重量',
  VgmContactPerson: 'VGM担当者',
  VgmContactEmailAddress: 'VGM連絡メールアドレス',
  VgmContactWay: 'VGM連絡方法',
  VgmResponsiblePerson: 'VGM責任者',
  ContactEmailAddress: '連絡先メールアドレス',
  ContactWay: '連絡先方法',
  ContactAddress: '連絡先住所',
  ResponsiblePerson: '責任者',
  Name: '名前',
  Warehouse2: '内部倉庫',
  WarehouseLoading: '倉庫内装',
  LoadingCharge: '積み込み料金',
  LoadingCharge2: '積み込み料金',
  RmbNumberOfDamagedAndDamp: '損傷した湿った件数',
  RmbNumberOfDamagedAndDamp2: '損傷した湿った件数',
  Tel: '電話',
  CargosExpectedArrivalDate: '予想到着日',
  WarehouseAddress: '倉庫住所',
  LoadingRemarks: '内部仕様書',
  DoorToDoorLoading: 'ドアツードアの積み込み',
  MultiDoors: '複数のドア',
  HaulageNo: 'トラック配送番号',
  HaulageCharge: 'トラック運賃',
  AuditMoney: '確認金額',
  AuditState: '費用状態',
  HaulageContactPerson: 'トラックチーム連絡担当者',
  Door: 'ドア',
  AddDoor: 'ドアを追加',
  DestinationGatewayCity: '目的地ゲートウェイ都市',
  DoorContactPerson: 'ドア連絡担当者',
  DoorAddress: 'ドア住所',
  DispatchVehiclesAtDestinationDoorAddress: '目的港発車ドア住所',
  DoorCity: 'ドア都市',
  Driver: '運転手',
  ComprehensiveLogisticsOrderType: '総合物流注文タイプ',
  ComprehensiveLogisticsTransportationType: '総合物流輸送タイプ',
  TransportType: '輸送タイプ',
  DestinationGatePoint: '目的地ゲートポイント',
  DepartureGatePoint: '出発地ゲートポイント',
  AddressOfDestinationGatePoint: '目的地ゲートポイント住所',
  DestinationGateCity: '目的地ゲートポイント都市',
  EstimatedPackingDate: '予定梱包（工場到着）日',
  ActualPackingDate: '実際の梱包（工場到着）日',
  EstPackingDate: '予定梱包（倉庫到着）日',
  ActPackingDate: '実際の梱包（倉庫到着）日',
  ExpectedArrivalDate2: '予定到着日',
  ActualArrivalDate: '実際の到着日',
  GatheringTrailer: 'コンテナ集配トレーラー',
  WholeVehicleLessThanCarload: 'トラック一車両単位で荷物を運ぶ',
  TruckCustomerService: 'トラックカスタマーサービス',
  DtdDTWWTD: 'ドアツードア/ドアツーウェアハウス/ウェアハウスツードア',
  DoorToDoor: 'ドアツードア',
  DoorToWarehouse: 'ドアツーウェアハウス',
  WarehouseToDoor: 'ウェアハウスツードア',
  AdditionalNotes: '追加情報',
  AssociatedPackingInfo: '関連するパッキング情報',
  RemoveAssociations: '関連を解除',
  DispatchTuckOrder: 'トラック配送依頼',
  ModifyTuckOrder: 'トラック配送依頼変更',
  TuckStatusDescription: 'トラック配送詳細',
  ManualDistribution: '手動配送',
  Unlock2: 'ロック解除',
  Size: 'サイズ',
  WhetherOrNotBroken: '破損の有無',
  BrokenDesc: '破損の説明',
  BangPic: '倉庫入り口写真',
  WareHouseName: '倉庫名',
  WarehouseSupplier: '倉庫業者',
  WareHouseMarks: '倉庫マーク',
  CustomsDeclarationInfo: '関税申告情報',
  OnwardInfo: '次の情報',
  TheActualFlight: 'フライト番号',
  NewCustomsDeclaration: '新しい関税申告書',
  EditCustomsDeclaration: '関税申告書を編集する',
  DeleteCustomsDeclaration: '関税申告書を削除する',
  BlNo: 'B/L番号',
  OperatingCompany: '運営会社',
  CustomsCode: '関税コード',
  DateOfCustomsDeclaration: '関税申告書提出日',
  StatusOfCustomsDeclaration: '関税申告処理状況',
  CommodityInspectionOrNot: '商検実施の有無',
  CustomsInspectionOrNot: '検査実施の有無',
  UploadFile: 'ファイルをアップロードする',
  CustomsFile: '関税ファイル',
  Chargeback: '返金',
  TemplateDownload: 'テンプレートダウンロード',
  ExcelImport: 'Excelインポート',
  ExcelExport: 'Excelエクスポート',
  OrderNo: 'ORDER NO_注文番号',
  CaseNo: 'CASE NO_シリアル番号',
  Item: 'ITEM_商品コード',
  Sub: 'SUB_バッチ番号',
  Size2: '規格',
  CommodityClassification: '分類品名',
  Qty: 'QTY_数量',
  BillingQTY: 'チャージ数',
  UnitOfMeasurement: '単位',
  NetWeight: '純重量',
  CustomsDutyRate: '関税税率',
  CustomsDuties: '関税',
  IncrementValueDutyRate: '付加価値税税率',
  IncrementValueDuty: '付加価値税',
  ConsumptionDutyRate: '消費税税率',
  ConsumptionDuty: '消費税',
  ConsolidatedTax: '総合税金',
  Currency: '通貨',
  ExchangeRate: '為替レート',
  CargoPrice: '商品価格',
  Tax: '税金',
  TaxRate: '税率',
  BigBagNo: '大ばんごう',
  BigBagWeight: '大包重量',
  BigBagWeightUnit: 'じゅうりょうたんい',
  BigBagLength: '大きな包みに長い包みを包む',
  BigBagWidth: '大包み幅',
  BigBagHeight: '大小包高',
  BigBagDimensionUnit: '大包長単位',
  BigBagGoodsType: '大規模貨物種別',
  FulfillmentLabel: '契約履行タイプ',
  LandingPort: '着地港',
  PackageQuantity: '小包装数量',
  ExpectPickupStartTime: '希望回収開始時間',
  ExpectPickupEndTime: '希望回収終了時間',
  PreviousCarrierCode: '前のサービスプロバイダcode',
  PreviousResourceCode: '前のリソースコード',
  NextCarrierCode: '次のサービスプロバイダcode',
  NextResourceCode: '次のリソースコード',
  SortCode: 'だいほうせんべつコード',
  BuyerRegion: '目的国',
  AddressL0: 'L 0レベルアドレス',
  AddressL1: 'L 1レベルアドレス',
  AddressL2: 'L 2レベルアドレス',
  AddressL3: 'L 3レベルアドレス',
  AddressL4: 'L 4レベルアドレス',
  DetailsAddressMore: '詳細アドレス2',
  PickupFirstName: '加工者姓',
  PickupLastName: '加工者名',
  PickupCompany: '包括地会社名',
  PickupZip: '一括郵便番号',
  PickupPhone: '包括地携帯番号',
  TtOrderCode: 'TTプレート番号',
  MwbNo: 'サービスプロバイダの船荷証券番号',
  Export9610File: '9610ファイルのエクスポート',
  BatchChangeCompany: '一括交換会社',
  OnlyCheckOneData: 'データのチェックのみを許可',
  NoteUseNumLast: '注意：会社を交換しても、単号は再生成されず、既存の単号が使用されます。',
  OrderNo2: '注文番号',
  SupportSales: 'セールスサポート',
  OrderAmount: '注文金額',
  ServiceFeeDiscountRate: 'サービス料割引率',
  OperatingInstructions: '操作説明',
  OrderCurrency: '注文通貨',
  TheAmountOfWriteOffs: '注文の相殺額',
  TheFirstBusinessOrNot: '初めての注文であるかどうか',
  Salesman: 'セールスマン',
  OrderExchangeRate: '注文為替レート',
  Difference: '差額',
  FrameContractNumber: 'フレーム契約番号',
  PaymentNo: '支払い番号',
  PaymentAmount: '支払い金額',
  ThePrePayment: '前払い金を支払う',
  PaymentExchangeRate: '支払い為替レート',
  ActualPaymentAmount: '実際の支払い金額',
  ServiceCharge: '手数料',
  PostalCharges: '郵便料金',
  AcceptanceFee: '払戻手数料',
  RetreatMoreFillLessAmount: '多く返品して少なく補充する金額',
  Total: '合計',
  UnpaidAmount: '未払い金額',
  No: 'いいえ',
  Yes: 'はい',
  New: '新規作成',
  Clone: '複製',
  Send2: '送信',
  Back: '返却',
  ExpressInfo: '宅配便情報',
  PrintReceipt: '領収書を印刷する',
  FileType: 'ファイルタイプ',
  FileType2: 'タイプ',
  FileCategory: 'ファイルカテゴリ',
  CustomsNo: '関税番号',
  SendingDate: '送信日付',
  SendingExpressNumber: '配送伝票番号',
  ReceivingDate: '回収日付',
  Receiver: '受取人',
  ReturnDate: '返品日付',
  ReturnExpressNumber: '返却配送番号',
  DateOfDeclaration: '申告日付',
  FileStatus: 'ファイル処理状況',
  TenBitCode: '10ビットコード',
  ReceiverCompanyName: '受取企業名',
  Receiver2: '受取人',
  CustomsDeclarationPages: '関税申告ページ数',
  CustomsTransitOrNot: '関税転送の有無',
  TakeByCustomsBroker: '通関業者が引き取り',
  ExpressAddress: '宅配便住所',
  PrintChargebackList: '（チャージバックリスト）を印刷する',
  ViewFile: 'ファイルを閲覧する',
  ChargebackFile: 'チャージバックファイル',
  CheckPreRecordedCustomsDeclaration: '予約関税申告書を確認する',
  CheckStatusOfCustomsDeclaration: '関税申告処理状況を確認する',
  All: '全て',
  GeneralTrade: '一般貿易',
  Processing: '入料加工',
  FeedingCounterparts: '原料対口',
  SamplesOfAdvertisingProducts: 'サンプル広告品',
  OtherImportsFree: 'その他の無料輸入',
  CustomerName: '顧客名',
  CustomerAddress: '顧客住所',
  Confirm: '確定',
  DangerousGoods: '危険物',
  DangerousGoodsRequired: '「危険物連絡先メールボックス」、「危険物連絡先FAX」は必須です',
  DangerousGoodsLabel: '危険物ラベル',
  MedicalEmergencyGuideNo: '医療救急ガイド番号',
  SetTemperature: '温度設定',
  MinimumTemperature: '最低温度',
  MaximumTemperature: '最高温度',
  PortForReturningContainer: 'コンテナを返却する港',
  NonStandardContainer: '非標準コンテナ',
  OverFront: '前部の超過',
  OverBack: '後部の超過',
  OverHeight: '高さの超過',
  OverLeft: '左側の超過',
  OverRight: '右側の超過',
  EditionStatus: '編集処理状況',
  UpdateExternalState: '外部処理状況を更新する',
  Refresh: 'リフレッシュ',
  Save: '保存',
  ShowAllPoints: 'すべてのポイントを表示する',
  SopStateNote: '*注意：閉じられたポイントは、もうポイント警告とSOP処理状況変更通知を送信しません。',
  PaymentInformationImport: '支払い情報のインポート',
  Invalid: '無効',
  QueryContainerInfo: 'コンテナ情報クエリ',
  Hbl2: '分割輸送書番号',
  Mbl2: 'マスタB/L番号',
  PortOfLoadingAgent: '出港代理',
  TheFirstVessel: '一次船名',
  CustomerReferenceNumber: '顧客参照番号',
  BusinessType: '業務種別',
  BillExchange: 'ブックスリップ交換有無',
  Storage: '保管',
  Devanning: '開梱',
  DeliveryToDoor: 'ドアツードア配達',
  MblNo4: 'マスターブッキング番号',
  InternationalTransport: '国際輸送',
  ActualNotifyParty: '実際の通知先',
  ActualNotifyPartyHeader: '実際の通知先見出し',
  ConsignationCompanyHeader: '委託会社見出し',
  Fax: 'FAX',
  BillExchangeAgent: '引換手続代理人',
  CustomsHblNo: '海関分割輸送書番号',
  SecondCheck: '二次検査',
  SecondVessel: '二次船名',
  AutoRetrieve: '自動取得',
  AccordingToVesselVoyageGets: '船名航行に基づいて取得',
  ActualDateOfArrival: '実際の到着日付',
  ActualDateOfArrival2: '実際到着日',
  AtaImport: 'ATA(輸入)',
  DateOfDelivery: '引き渡し日付',
  DateOfArrivalTheWarehouse: '倉庫到着日付',
  Code2: 'コード',
  Region: '地域コード',
  CountryOrigin: '原産地国',
  PartyIDType: 'ID種類',
  PartyID: 'ID番号',
  BillsOfLadingDoubleClickEject: 'ビル・オブ・レーディング-ダブルクリックで抜き出す',
  TradeTerms: '取引条件',
  PreCollection: '前払い金',
  HblCargoReleaseWay: '分割輸送書放出方法',
  MblCargoReleaseWay: 'マスタービル放出方法',
  VesselCode: '船舶コード',
  BillExchangeDate: 'ブックスリップ交換日付',
  Department: '部門',
  PolOperation: '出港操作',
  PodOperation: '着港操作',
  VesselOfChineseName: '中国語船名',
  TotalWeight2: '総重量',
  TotalWeightUnit: '総重量単位',
  NumberOfDamagedAndDamp: '損傷・湿気のある荷物数',
  EstimatedDateOfArrivalTheWarehouse: '倉庫到着予定日付',
  EstimatedDateOfPickingUpTheContainer: 'コンテナ引き取り予定日付',
  DateOfReturningTheContainer: 'コンテナ返却日',
  SanitaryAndPhytosanitaryStandard: '動検',
  PriceCalculation: '販売価格計算',
  Down: '下げる',
  Up: '上げる',
  Total2: '合計',
  PrintBooking: '予約を印刷する',
  FirstLegNo: '第一脚番号',
  FirstLegNoTips: '国際航空貨物物流において、国内輸送および輸出前作業を管理するための重要な識別子',
  OperateType: '操作モード',
  CustomsDeclarationWay: '通関方式',
  CustomsDeclarationType: '通関種別',
  AirlineCompany: '航空会社',
  Flight: 'フライト',
  FlightNo: 'フライト番号',
  PortOfHub: 'HUB港',
  CommissionedNumberOfPackages: '受託荷物数',
  CommissionedGrossWeight: '受託総重量',
  CommissionedVolume: '受託体積',
  ActualChargedWeight: '実際の課金重量',
  PrintingPlatePhotos: '板の写真を印刷する',
  ProtocolType: 'プロトコルタイプ',
  FieldOperation: '現場作業',
  OverseaOperation: '海外操作',
  Auditor: '監査人',
  preverifyDate: ' 監査日',
  OtherWarehouseNotes: 'その他の倉庫メモ',
  JobNo: 'ジョブ番号',
  NominatedAgent2: '指定代理',
  AirFreighMode: '航空輸送モード',
  WarehouseNo2: '倉庫番号',
  PleaseInputJobNo: 'ジョブ番号を入力してください',
  PrintProfitAnalysis: '利益分析の印刷',
  SendToBranchCompany: '支社に送信する',
  EnterTransitInfo: '中継情報を入力する',
  ArrivalForTheSecondJourney: 'Arrival for the second journey',
  LeaveForTheSecondJourney: 'Leave the second journey',
  PreAlertOperation: '事前通報操作',
  Actual: '実際の',
  Frontcabin: 'フロントキャビン',
  FrontCabinActual: 'フロントキャビン（実績）',
  Documentation: '書類作成',
  Select: '選択する',
  Join: '加える',
  Separate: '分ける',
  pbProportion: '顧客分割率',
  pbProportion2: 'サプライヤー分割率',
  SpaceRquirement: 'スペース要件',
  OnBoardRequirements: '積み込み要件',
  DocumentationRequirements: '書類作成要件',
  SellingPrice: '売価',
  BuyingPrice: '買い価格',
  SalesBranchCompany: '営業支社',
  CopyFromOtherBill2: '番号コピー',
  CodeSearching2: 'コード選択',
  ResetInitialValue: '初期値にリセットする',
  CopyTheMbl: 'マスタービルをコピーする',
  InputWarehouseData: '倉庫データを入力する',
  EditWarehouseData: '倉庫データを編集する',
  DeleteWarehouseData: '倉庫データを削除する',
  CancelInvalid: 'キャンセル',
  MblInfo: 'マスタービル情報',
  AirOperation: '航空輸送操作',
  CustomerSpecialRequirements: '顧客特別要件',
  AirportHandlingAgent: 'グランドハンドリング代理店',
  CustomsTenBitCode: '通関10桁コード',
  InspectionTenBitCode: '検査10桁コード',
  TradeDetail: '貨物明細',
  TradeCommission: '貿易',
  HblInfo: '分割輸送書情報',
  MBLInfo: 'マスター船荷証券（MBL）情報',
  Charge: '料金',
  InternalBillInfo: '国内請求書情報',
  OverseaBillInfo: '海外請求書情報',
  AdvanceChargeInfo: '代金先払い情報',
  DocumentCirculation: '書類流通',
  FileHistory: 'ファイル履歴',
  ImportToPDF: 'PDFインポート',
  Trucking: 'お客様の取引所',
  ImportOperation: '輸入操作',
  CustomsDeclarationOnward: '通関/継続',
  WarehouseDoorLoading: '倉庫内装/ドアローディング',
  GrossWeight: '総重量',
  CustomJobType: 'カスタム取引タイプ ',
  TaxNature: '税務上の性質です',
  ContainerInfo2: 'コンテナ情報',
  ContainerIdentification: 'コンテナ識別',
  CopyConsignationDescriptionAndMarks: '委託品名唛头からコピーする',
  SelecteAll: 'すべて選択',
  ConsigneeShipperAndNotifyAddress: '受取人/発送人/通知人住所',
  ShipperId: '出荷人ID',
  ConsigneeId: '受取人のID',
  NotifyId: '通知人ID',
  ShipperInfo: '出荷人情報',
  ConsigneeInfo: '受取人情報',
  NotifyInfo: '通知人情報',
  CopyShipper: '出荷人を選択する',
  CopyConsignee: '受取人を選択する',
  CopyNotify: '通知人を選択する',
  CopyManifestShipper: 'Copy Manifest Shipper',
  CopyManifestConsignee: 'Copy Manifest Consignee',
  CopyManifestNotify: 'Copy Manifest Notify',
  CopyAll: 'すべて選択',
  FillInQuantityOfVotes: '投票数を入力する',
  QueryLCLJobOrder: 'LCLジョブオーダー検索',
  QueryLCLJobOrder2: 'LCL分割オーダー検索',
  QuantityOfSelectedOrder: '選択されたオーダーの数量',
  NoDisplay: '非表示',
  Number: '番号',
  SelectSoNo: 'S/O No.を選択',
  MBLHBR: 'マスタービル/HBL統合番号',
  AgentInfo: '代理店情報',
  HBLHBR: 'HBL統合番号',
  ChargeItem: '費目名',
  Close: '閉じる',
  SearchJobNo: 'ジョブ番号検索',
  SerialNo: 'シリアル番号',
  Search: 'データ検索',
  VolumeOnBl: 'ビル・オブ・ラディング上のボリューム',
  MethodOfPayment: '支払方法',
  PortOfFinalDestination: '最終目的地港',
  SelectContainerInfo: 'コンテナ情報を選択',
  SearchTheWarehouseRecords: '倉庫レコードを検索',
  ReceiptNo: '受領書番号',
  warehouseOp: '倉庫作業者',
  deliveryCMP: '配送会社',
  inDate: '入庫日',
  DamagedAndDamp: '破損/水濡れ',
  EntryCustomsInformation: '通関情報入力',
  Recorded: '入力済み',
  ListPulled: '引き出し済み',
  AtReception: '受付中',
  CustomsDeclared: '通関済み',
  Undeclared: '未通関',
  CustomsExamination: '海関検査',
  InspectionExamination: '商検査',
  ExamedWithoutReleasing: '検査済み未解放',
  AmendDeclaration: '改正申告',
  NotifyToDeclare: '通報待ちで申告',
  CustomsExamed: '海関検査に問題あり',
  PreNumber: '入力番号',
  ContainerNo2: 'コンテナ型式/番号',
  UnknownState: '不明な状態',
  ProductName: 'プラン名称',
  Carrier: 'キャリア',
  RecordCount: 'レコード数',
  Autowire: '自動マッチング',
  SchemaName: 'プラン/費用名',
  Receivable: '支払区分',
  PartnerType: '決済単位種別',
  Account: '固定決済単位',
  MeasureCurrency: '課金単位',
  MeasureUnit: '課金単位名',
  UnitRate: '単価',
  MiniMum: '最低請求額',
  FCLFreightTariff: 'フルコンテナ貨物運賃表',
  PleaseInputTariffSheet: '運賃表番号を入力してください。',
  CostLeave: '費用区分:',
  ValidFrom: '有効期間開始日',
  ValidTo: '有効期限',
  MON: '月曜日',
  TUE: '火曜日',
  WED: '水曜日',
  THU: '木曜日',
  FRI: '金曜日',
  SAT: '土曜日',
  SUN: '日曜日',
  GetCostsByTheCabinet: 'コンテナ型式別に費用を表示する',
  ShippingFeesAreALLINTHEWAYImport: '海運料金はALL IN方式でインポートされますか？',
  PriceNo: '価格番号',
  BranchCMP: '支社',
  IsDirect: '直接',
  PriceState: '船室状態',
  Trend: '傾向',
  Share: '船室性質',
  ContractNo: '契約番号',
  PriceFrom: '価格の出典',
  SailingDate: 'Frequency',
  Voyage2: '航程',
  Cargo: '貨物',
  Box: 'コンテナ',
  Dock: '係留する港',
  LCLFreightTariff: 'フルコンテナ運賃表',
  ImportCostsByPeers: '同業者価格による費用のインポート',
  PriceState2: '運賃状態',
  CostValue: '原価',
  PeerPrice: '同業者価格',
  DirectPrice: '直接客価格',
  MarketPrice: '市場価格',
  ClosingDay: 'クロージング日',
  ShareCarrier: '共有船会社',
  VerificationSchedule: '検証明細表',
  Cash: '現金',
  Check: '小切手',
  Transfer: '振込',
  ClearingDate: '決済日',
  PayReceiveDate: '支払/受取日',
  VerificationBy: '検証者',
  ClearCurrency: '決済通貨',
  ClearRate: '決済レート',
  ClearAmount: '決済金額',
  VoucherNo: 'バウチャー番号',
  OurBank: '当社銀行',
  AddBillCharge: '費用を追加する',
  RemoveBillCharge: '費用を削除する',
  ShowBillDetail: '請求書詳細を表示する',
  OverseasBillingMaintenance: '海外請求書のメンテナンス',
  MainOffice: '請求書のヘッダーに表示する企業名',
  BillType: '請求書の種類',
  BillAmount: '税金額',
  AccountObject: '決算対象',
  Bank: '口座開設銀行',
  BankAccount: '口座番号',
  CounterPartyBillingNo: '相手方請求書番号',
  InputDate: '請求書入力日',
  RevenueTotalGroup: '通貨合計',
  IncludingTaxAmount: '税込価格',
  ExcludingTaxAmount: '税抜価格',
  WhetherCollectingAdvance: '前払い代金を代收するかどうか',
  Unit: '単位',
  Quantity2: '数量',
  ShowLcl: 'LCL料金を表示する',
  AgentIntoBills: '代理店分配請求書',
  Office: '請求書のヘッダー支社',
  Percentage: '分配比率',
  IsPercentage: '分配',
  ChargeEnglishName: '費用英語名',
  ChangeSchema: '費用プラン',
  SendEMail: 'メール送信',
  LocalAgent: '地元代理',
  placeholderVal: 'メールテンプレートを選択する前にチェックしてください。',
  UpDestAgent: '発令/目的地エージェント',
  Haulage: '運送会社',
  CompanyName: '会社名',
  GroupCode: 'グループコード',
  CompanyAddress: '会社住所',
  Contact: '連絡先',
  OtherInformation: 'その他の情報',
  BlTitle: 'ビル・オブ・ラディング（提出書類）企業名',
  BlAddress: 'ビル・オブ・ラディング（提出書類）住所',
  BlContact: 'ビル・オブ・ラディング（提出書類）連絡先',
  MscBlAddress: 'Mscビル・オブ・ラディング住所',
  PleaseChooseItem: '操作する項目を選択してください。',
  WhetherDelete: '本当に削除しますか？',
  IsEmptyPleaseEnter: 'が空です。入力してください。',
  Cc: 'CC',
  MailContent: 'メール内容',
  SystemEmail: 'システムメール',
  CompanyMail: '会社の電子メールアドレス',
  PersonalMailbox: '個人用のメールボックス',
  emailSubject: 'メールの件名',
  mailTemplate: 'メールテンプレート',
  SaveTheDefaultCC: 'デフォルトのCCを保存',
  Title: 'タイトル',
  Content: '内容',
  operationalMotion: '操作操作内容',
  operationTime: '操作時間',
  receiptStatus: 'Customs receipt status',
  returnTime: '返却時間',
  source: 'ソース',
  PreCommitUser: '提出者',
  PreCommitDate: '事前提出時間',
  SubmissionDate: '提交时间',
  CommitUser: '登録者',
  RelatedSubmissionDate: '往来关联业务提交时间',
  RelatedCommitUser: '往来关联业务提交人',
  RelatedPreCommitUser: '往来关联业务预提交人',
  RelatedPreCommitDate: '往来关联业务预提交时间',
  FcAuditDate: '审核时间',
  FcAuditUser: '審査者',
  LockJobDate: '記録登録時間',
  LockJobUser: '施錠実行者',
  FileUpload: 'ファイルアップロード',
  FileName: 'ファイル名',
  FileSize: 'ファイルサイズ',
  UploadProgress: 'アップロード進捗状況',
  DocumentType: '文書の種類',
  SelectFile: 'ファイルを選択',
  DeleteFile: 'ファイルを削除する',
  Upload: 'アップロードする',
  Transit2: '中継',
  AuditDate: '日付を調整する',
  PlsSeeEIR: '装置引き渡し書を参照してください',
  SelectCopyContent: 'コピーする内容を選択',
  DuplicateContent: '複製されたコンテンツ',
  BasicInfo: '基本情報',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAsk: '今後、この選択に従って複製する必要はありません。条件を再設定する場合は、右上隅の「設定とツール」-「ページのカスタマイズ」で設定ボタンをクリックします。',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskLeft: '今回選択した内容をデフォルトのコピー内容として設定し、次回から通知しない',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskRight: 'コピーする内容を再設定する場合は、右上隅のメニューアイコン-「設定とツール」-「ページのカスタマイズ」で設定ボタンをクリックしてください。',
  Slaves: 'LCL 票数',
  Master: 'FCL 票数',
  CustomerCount: '顧客数',
  SingleWeight: 'シングルウェイト',
  Weight2: '重量',
  ReceivableType: '受取タイプ',
  AccountType: '決算単位の種類',
  Account2: '会計単位',
  Oversea: '国内/国外',
  Remove: '削除する',
  SourceAmount: '元金額',
  NewAmount: '新しい金額',
  IsUpdate: '更新するかどうか',
  ExportLog: 'ログをエクスポートする',
  Role: '役割',
  Mobile: '携帯電話',
  Email: 'メールアドレス',
  SOPOperatingState: 'SOP操作状態',
  KG: 'キログラム',
  CBM: '立方メートル',
  Tons: 'トン',
  SelectOpRequirement: '操作要求を選択',
  PleaseInputAKeyword: 'キーワードを入力して検索してください',
  contentDescription: 'コンテンツの説明',
  chargeItem: '費用項目',
  LCLLastBillOfLading: 'LCL最終提出書類',
  Addr: '住所',
  HouseNumber: '番地です',
  Country: '国',
  Province: '県',
  City: '市',
  ZIP: '郵便番号',
  SelectCharge: '料金を選択',
  First: '第一ページ',
  Pre: '前のページ',
  Page: 'ページ',
  AllPage1: '合計',
  Next: '次のページ',
  Last: '最後のページ',
  ShowFromTo1: 'から表示',
  ShowFromTo2: 'to',
  AllRecord1: '合計',
  Convert: '換算',
  Received: '実受け取り',
  Paid: '実払い',
  AllPositions: '全てのポジション',
  DestinationAgent: '仕向代理店',
  Accessible: 'アクセス可能',
  IsDisplay: '表示するかどうか',
  Uncertain: '未確定',
  DestinationAgent1: '海外代理店',
  PassAudit: '審査通過',
  Refuse: '拒否',
  Bl: '提出書類',
  Original: 'オリジナル',
  LateOriginal: '遅申',
  Correct: '修正',
  Message: 'メッセージ',
  DeleteCustoms: '削除（税関削除、企泰保留）',
  DeleteAll: '削除（企泰税関はすべて削除）',
  send: '送信',
  change: '変更',
  deleteSingle: '単一削除',
  cancelBill: '伝票をキャンセル',
  OverseasAgeFore: '海外予報',
  JclForecast: 'JCL予報',
  AnnPackingList: '梱包リスト',
  PreShippingBill: '予約船積みリスト',
  PreShippingBillPperation: '予約船積みリストの操作',
  ShippingBill: '船積みリスト',
  Anti_terrorismShipping: '反テロ船積みリスト',
  CleanShipping: '清掃船積みリスト',
  Suitcase: '提箱',
  DelSuitcase: '提箱を削除する',
  ViewHistory: '履歴を表示する',
  ElectronicPackingList: '99電子パッキングリスト',
  SendHistory: '送信履歴記録',
  ShippingSchedule: '船期表',
  PortOfLoadingArea: '出発地港区',
  PortOfDestinationArea: '目的地港区',
  ShipsCallSign: 'EDI船舶呼び出し符号',
  ImportTheVoyage: '航行日程をインポート',
  IncreaseThePort: '港を追加する',
  DeletePorts: '港を削除する',
  AutomaticallyImportVoyage: '自動的に航行日程をインポートする',
  CountryOfRegistration: '船名登録国',
  AddShippingCompany: '船会社を追加する',
  DelShippingCompany: '船会社を削除する',
  DepartureTime: '出発時刻',
  DateOfOrder: '注文日付',
  ProjectReceivedBy: '受注者',
  dateOfFiling: 'ファイリング日付',
  ArchivePeople: 'アーカイブの人',
  ReturnOrderExpressNumber: '返品伝票番号',
  StateOfTheWithdrawal: '撤回状態',
  EmptyTheList: 'リストを空にする',
  BatchStateTransition: 'バッチ',
  CollectFormation: '收款情報',
  RetreatASingle: '退単リスト',
  BatchSaving: '一括保存',
  AppendQueryRecord: '検索レコードを追加',
  StateHisCase: 'コンテナ状態',
  BoxStatus: 'コンテナ処理状況（上海港のみ）',
  StatusOfAnti_TerrorismManifest: 'テロ防止マニフェストEDI処理状況',
  ManifestStatus: 'マニフェストEDI処理状況',
  AdvanceManifestStatus: '事前マニフェストEDI処理状況',
  InstallPackingListStatus: '安全宣言書EDI処理状況',
  StateOfTheBillOfLading: '提出通知書EDI処理状況',
  BookingStatus: '予約EDI処理状況',
  reset: 'リセット',
  PrintStatus: '印刷処理状況',
  TeamContact: 'チーム連絡先',
  ContactNumber: '連絡先電話番号',
  DoorContact: 'ドア連絡先',
  DoorContactNumber: 'ドア連絡先電話番号',
  PleaseScanTheBarcodeOrInputDirectly: 'バーコードをスキャンするか直接入力してください',
  CollectionSituation: '集金状況',
  DocumentDate: '書類日付',
  checkbox: '【チェックボックス】',
  RefundDate: '返金日付',
  RefundPerson: '返金責任者',
  AutomaticallyRefresh: '自動更新',
  Piece: '個',
  Volume: '体積',
  CartonQuantity: '箱型数量',
  ClientsRequirement: '顧客要求',
  LandCarriage: '陸運',
  BatchUpdateType: 'バッチ整拼タイプ変更',
  ShippingCmp: '船会',
  CarrierSpecificCode: '船社固有コード',
  PortOfLoadingAI: '出発港',
  Synchronization: '同期',
  RiverCarrier: '江運業者',
  BatchShutOut: '一括退関',
  OverseaCustomerService: '海外顧客サービス',
  CargoFeature: '貨物の性質',
  CustomerLevel: ' 顧客ランク',
  ContractStatus: '契約ステータス',
  HBLNotifier: '分割通知人',
  ExportWithSOPToExcel: 'Excelエクスポート（SOP詳細を含む）',
  ManagerSubmission: 'マネージャーが提出',
  CustomerSelfRelease: 'カスタマーセルフリリース',
  CompanySelfRelease: '会社のセルフリリース',
  ManageAuditStatus: '利益検査処理状況',
  QuantitySize: '数量とサイズ',
  isShutOut: '通関取消の有無',
  EquipmentEstimatedReturnTimeFrom: 'コンテナの返却予定日（FROM）',
  EquipmentEstimatedReturnTimeTo: 'コンテナ返却予定日',
  copyDGStuffing: 'コピー',
  pasteDGStuffing: '貼り付け',
  viewDGStuffing: '表示',
  copyAndAddPoItems: '複製して新しいアイテムを追加',
  SynchroHBLInfo: 'HBL情報を同期',
  Cubage2: '体積M³',
  AMSLog: 'ログ',
  AMSReceiptInfo: '受領書を見る',
  ViewAssociatedBusiness: '関連するビジネスを表示する',
  RevokeTuckOrder: 'キャンセルする',
  SearchTuckOrder: 'データ検索',
  ShowTuckOrderLog: 'ログ',
  TuckStatus: '車両派遣の状況',
  DriverNameHL: '互联司机',
  DriverPhoneHL: '互联电话番号',
  TruckNoHL: '互联ナンバー',
  TmsNoHL: 'ディスパッチ番号',
  ContainerSerialNo: 'コンテナシリアル番号',
  ContainerNoDiff: '差異を表示する',
  isRelated: '関連するかどうか',
  CommissionedChargedWeight: '委託された計量重量',
  CustomsHasCheck: '税関で確認済み',
  CustomsOneRelease: '一回だけリリース',
  CustomsRelease2: 'リリース',
  PartnerShortType: 'タイプ',
  DgconsignParty: 'DGCONSIGN',
  ElseInvoiceParty: 'ELSEINVOICE',
  ShowPODAgency: 'PODエージェンシーを表示する',
  FnlTm: '内陸点渡し方式',
  InvokeLocalMailClient: 'ローカルメールクライアントを呼び出す',
  preview: '添付ファイルを生成する',
  attachment: '添付：',
  AddPackingInfo: '積み荷情報を追加する',
  RemovePackingInfo: '積み荷情報を削除する',
  sendJdy: 'シンプルクラウドの送信',
  sendFailInfo: '送信成功{0}バー、失敗{1}バー：',
  batchSendJdy: '一括送信のためのシンプルなクラウド',
  batchUnlockGoodsDetails: '一括ロック解除貨物詳細',
  IdentifyPackingList: '梱包伝票の識別',
  BoxListRecognition: 'AI-ケースシート識別',
  SupportingUploadFormat: 'アップロードをサポートする形式pdf/xls/xlsx/doc/docx/jpg/gif/png、1ファイルあたり4MB以下',
  UploadedFile: 'アップロードされたファイル',
  Parsing: '解析しています',
  SpecialCharactersNotAllow: 'ファイル名に特殊文字は使用できません',
  MaterialInformation: '品目情報',
  MaterialNumber: '品目番号',
  HsCode2: 'HS CODE',
  NetWeightKg: '正味重量（KG）です',
  PONumber: 'PO番号',
  FilePreview: 'ファイルのプレビュー',
  MultiCabinets: '複数のコンテナ',
  CopyDoorPoint: 'ドアポイントのトレーラー情報をコピーする',
  SelectCabinetData: 'コンテナ情報を選択する',
  ExportPackingInfo: 'コンテナ情報をエクスポートする',
  ImportPackingInfo: 'コンテナ情報をインポートする',
  ContainerId: 'コンテナID',
  ContainerSeqNo: 'ボックス番号',
  TrailerRemark: 'トレーラー備考',
  RemarkItems: '備考事項',
  DriverId: '身分証明書番号',
  DriverName: 'ドライバー名',
  DriverPhone: '携帯電話番号',
  TruckNo: 'ナンバープレート',
  EstimatArrivalTime: '予定ダブつく厂時間',
  DownloadImportResults: 'インポート結果をダウンロードする',
  ImportSuccess: 'インポート成功',
  ImportFaildAndDownFile: 'インポートに失敗したデータがあります。インポート結果をダウンロードして確認してください。',
  SendBack: '返送する',
  MSC: 'MSC',
  CompanyInfo: '会社情報',
  LadingBillInfo: 'ビル・オブ・レーディング情報',
  HV: 'HV',
  RefNo: '参照番号',
  DgStuffing: 'DG Stuffing',
  HSCODE: 'HSコード',
  bookingNotes: 'Booking note',
  DangerousGoodsRemarks: 'Dangerous goods remarks',
  BootHelperPage: 'Boot helper page',
  CustomsCommodity: '申告品目',
  TradeShortName: '貨物略称',
  Code3: 'コード',
  TradeDescription: '貨物描写',
  ShippingMark: 'マーキング',
  ZipCode: '郵便番号',
  EmailAddress: 'メールアドレス',
  VipCode: 'VIPコード',
  InttraCode: 'INTTRAコード',
  MscCode: 'MSCコード',
  CompanyCode: '会社コード',
  LadingBillTitle: 'ビル・オブ・レーディングのタイトル',
  LadingBillAddress: 'ビル・オブ・レーディングの住所',
  LadingBillContactInfo: 'ビル・オブ・レーディングの連絡先情報',
  MstBooking: 'MST BOOKING',
  SplitType: '分割タイプ',
  RelatedOrderNo: '関連する注文番号',
  SignedType: '契約タイプ',
  FreightTerm: '運賃条件',
  PlaceOfPayment: '支払い場所',
  ProductionInstallationPlace: '製造・設置地',
  ProductionInstallationPlaceStation: '製造・設置地駅',
  ProductionInstallationModeOfTransportation: '製造・設置地輸送方法',
  PortOfLoadingWharf: '出発港コード',
  PortOfDischargeWharf: '目的港コード',
  PortOfDischargeRequire: '目的港要求事項',
  Destination: '目的地',
  DestinationStation: '到着駅',
  DestinationTransportWay: '目的地輸送方法',
  TransferCountry: '中間輸送国',
  BlNumber: 'B/L番号',
  FreightBL: 'Freight B/L',
  PODAgency: 'PODエージェンシー',
  MscServiceCode: 'サービスコード',
  ToOrderType: 'TO ORDER TYPE',
  DestinationZipCode: '目的地郵便番号',
  CopyCompany: '会社情報をコピーする',
  ChargeImport: '費用インポート',
  customerLevel: ' 顧客ランク',
  isSignContract: '契約に署名したかどうか',
  RemovePacking: 'コンテナから荷物を出す',
  LastContainerDescription: '最後の貨物描写',
  SelectLocation: '場所を選択する',
  BillingOfLadingRecordManager: 'ビル・オブ・レーディングの記録',
  ApplyForARelease: 'Apply for a release',
  RequestReleaseBy: 'Placing a single applicant',
  TicketHasSplit: 'このチケットはすでに解体されているので、解体請求書に申請を提出してください',
  TicketHasMerged: 'このチケットはすでに併合されているので、併合書に申請を提出してください',
  RequestReleaseDate: 'Date of application',
  RequestReleaseState: 'The status of the request for issuance',
  MblRequestReleaseState: 'MBL リリース依頼ステータス',
  HblRequestReleaseState: 'HBL リリース依頼ステータス',
  NotApplying: 'Not Applying',
  NoGuarantee: '無手紙です。',
  InEffect: '発効中です',
  Expired: '期限切れです',
  Uploaded: 'アップロードしました',
  NotUploaded: '未アップロードです',
  NoUploadRequired: 'アップロードは不要です',
  NotUploadedYetPlease: 'まだアップロードしていません,どうぞ',
  LongTermGuaranteeState: '長期保証書状態です',
  SingleTicketGuaranteeState: '単票保証書の状態です',
  Requested: 'Requested',
  WithdrawTheRequestForRelease: 'Withdraw the request for release',
  NoRequestReleaseData: 'There is no data that needs to be applied for',
  NoCancelRequestReleaseData: 'There is no data that needs to be withdrawn from the request for release',
  GetBack: '回収する',
  CancelGetBack: '回収をキャンセルする',
  Releasing: 'リリース',
  CancelReleasing: 'リリースをキャンセルする',
  StatusModefySuccessfully: '状態の変更に成功しました',
  ReleasingDate: 'リリース日',
  mblReleasingDate: 'MBLリリース日',
  receiptDate: '時間',
  receiptContent: '内容',
  receiptCode: 'レシートコード',
  createdDate: '時間',
  createdBy: '操作者',
  content: '内容',
  consignorCode: '発送人企業コード',
  codeAbbreviation: 'コード略称',
  enterpriseCode: '企業コード',
  consignorName: '発送人企業名',
  consignorDetailAddress: '発送人詳細住所',
  consignorPhone: '発送人電話番号',
  consignorEmail: '発送人メールアドレス',
  consignorRelexNumber: '発送人テレックス番号',
  cityName: '市区町村名',
  consignorCityName: '積荷都市名',
  provinceCode: '都道府県コード',
  provinceName: '都道府県名',
  postalCode: '郵便番号',
  countryCode: '国コード',
  aeoEnterpriseCode: 'AEO企業コード',
  formatSynchronizeToOrder: 'フォーマット情報を注文に同期する',
  ladingBill: 'ビル・オブ・レーディング',
  consigneeCode: '受取人企業コード',
  consigneeCodeAbbreviation: 'コード略称',
  consigneeEnterpriseCode: '企業コード',
  consigneeName: '受取人企業名',
  consigneeDetailAddress: '受取人詳細住所',
  consigneePhone: '受取人電話番号',
  consigneeEmail: '受取人メールアドレス',
  consigneeRelexNumber: '受取人テレックス番号',
  consigneeCityName: '市区町村名',
  consigneeProvinceCode: '都道府県コード',
  consigneeProvinceName: '都道府県名',
  consigneePostalCode: '郵便番号',
  consigneeCountryCode: '国コード',
  consigneeAeoEnterpriseCode: 'AEO企業コード',
  specificContactName: '連絡先の名前',
  specificContactPhone: '連絡先の電話番号',
  specificContactAddress: '連絡先のメールアドレス',
  specificContactRelexNumber: '連絡先のテレックス番号',
  notifyingCode: '通知人企業コード',
  notifyingCodeAbbreviation: 'コード略称',
  notifyingEnterpriseCode: '企業コード',
  notifyingName: '通知人企業名',
  notifyingDetailAddress: '通知人詳細住所',
  notifyingPhone: '通知人電話番号',
  notifyingEmail: '通知人メールアドレス',
  notifyingRelexNumber: '通知人テレックス番号',
  notifyingCityName: '市区町村名',
  notifyingProvinceCode: '都道府県コード',
  notifyingProvinceName: '都道府県名',
  notifyingPostalCode: '郵便番号',
  notifyingCountryCode: '国コード',
  notifyingAeoEnterpriseCode: 'AEO企業コード',
  formatManifestInformation: '船荷証券情報をフォーマットする',
  copyManifestLink: 'Copy Manifest Link',
  inviteSupplementManifest: 'Invite Supplement Manifest',
  freightChargesInfo: '費用情報',
  freightChargesUSDTotal: 'USD総費用:',
  tips: 'ヒント!',
  checkNominatedAgent: '指定代理人は必須です！',
  checkActualNotifyParty: '実際の通知人は必須です！',
  checkConsignationCompany: '委託会社は必須です！',
  checkLoadingPort: '積み港は必須です！',
  checkLoadingPort2: '出発港は必須です！',
  checkPortOfDischarge: '揚げ港は必須です！',
  checkPlaceOfDelivery: '配送地は必須です！',
  checkFinalDestination: '最終目的地は必須です！',
  checkDateOfDepartureAndDateOfArrival: '出発日は到着日より前である必要があります！',
  checkSales: '販売は必須です！',
  checkDept: '部門は必須です！',
  searchInfo: '検索情報が入力されていません！',
  checkVslVoy: '船名または航海番号を入力してください。',
  prePlanBooking: 'プレプラン情報',
  VgmInfo: 'VGM情報',
  ChooseSoNoInfoToCopy: 'Please select the customs clearance information to copy~',
  ChooseContainerInfoToCopy: 'Please select box information for copying~',
  manifestLinkCopy: '船荷証券リンクをコピーする',
  manifestInviteSupplement: '補足の書類を招待する',
  manifestQueryLog: '船荷証券ログ',
  manifestCfmStateLog: '船荷証券状態',
  manifestByPreShipping: 'プレプラン船荷証券',
  manifestByClearBooking: '清算船荷証券',
  manifestCfmButton: '確認',
  manifestUnLockButton: '一時ロック解除',
  HBLWeight: 'ハウスB/L 総重量',
  HBLQuantity: 'ハウスB/L 梱数',
  BillPortOfLoading: 'B/L 出発港',
  BillPortOfDischarge: 'B/L 到着港',
  BillPlaceOfDelivery: 'B/L 陸揚港',
  UserDefinedField1: '備考欄１',
  UserDefinedField2: '備考欄②',
  UserDefinedField3: '備考欄③',
  UserDefinedArea: 'カスタム情報',
  PleaseAddConsigneeFirst: 'CONSIGNEEを先に追加してください',
  CopyConsigneeToNotify1: 'CONSIGNEEをコピーする',
  OnlyOne: '1つだけ選択してください',
  CopyPoItemInfo: 'ボックス情報をコピーする',
  CopySuccess: 'コピーに成功しました',
  CopyFaild: 'コピーに失敗しました',
  PaseteSuccess: '貼り付けに成功しました',
  NoPasetePoItemInfo: '箱貨情報がコピーされていません。先にコピーしてください。',
  IsOrNotSpelling: 'スペルを追加しますか？',
  Insure: '保険',
  billPaymentNo: '支払申請番号',
  confirmUser: '費用確認者',
  ediFeedBackState: 'EDIフィードバックログ',
  receiptPrompt: '注意：船荷証券の送信から20日以内のデータは、システムが自動的に回収します。',
  loadingManifestReceipt: '積み込み船荷証券回収',
  customsReceipt: '海関総合船荷証明書',
  receiving: '回収中',
  receiptSucceeded: '回収成功',
  receiptFailed: '返信に失敗しました',
  customCode: '関区コード',
  transportation: '輸送方法',
  receiptBillType: 'B/Lタイプ',
  transportationName: '輸送ツール名',
  receiptVoyage: 'フライト/フライトナンバー',
  importArrivalSignal: '輸入到着確報マーク',
  receiptBillNumber: '船荷証券番号',
  entryDepatureDate: '入境日付',
  itemCount: '個数',
  kilogram: 'キログラムです',
  receiptWeight: '数量',
  tallyStatus: '荷役処理状況',
  exportArrivalStatus: '輸出到着処理状況',
  sendLog: '送信ログ',
  ediStatus: 'EDI処理状況',
  ManifestDeliveryStatus: 'Manifest delivery status',
  chooseShipper: '出荷人を選択してください',
  chooseConsignee: '受取人を選択してください',
  chooseNotify: '通知人を選択してください',
  bulkReplication: '一括複製',
  PlannedDepartureTime: '計画出発時間',
  ActualDepartureTime: '実際の出発時間',
  PlannedArrivalTimeAtTheFactory: '計画工場到着時間',
  RealTimeOfArrivalAtTheFactory: '実際の工場到着時間',
  PlannedTimeToLeaveTheFactory: '計画工場出発時間',
  ActualTimeToLeaveTheFactory: '実際の工場出発時間',
  PlannedArrivalTime: '計画到着時間',
  ActualArrivalTime: '実際の到着時間',
  currentLocation: '現在地',
  ViewExceptions: '例外を表示',
  travelTime: '移動時間',
  Hour: '時間',
  Minute: '分',
  salesOffice: '営業本部',
  opOffice: '業務本部',
  BookingAgentIsNull: 'ブッキングエージェントは空です',
  PortOfDepartureAgentSOPReceiver: '出発港代理店SOP受信者',
  DesignatedFreightAgentSOPReceiver: '指定貨物代理店SOP受信者',
  PortOfDestinationAgency: '目的港代理店SOP受信者',
  PrincipalUnitSOPReceiver: '委託会社SOP受信者',
  Collectioninformation: '集金情報',
  Appendqueryrecord: 'クエリレコードを追加',
  SalesOfGoods: '販売商品',
  BatchProcessing: 'バッチ処理',
  ClickSpaceToDropDownOptions: 'スペースキーを打つとドロップダウンオプションが表示されます',
  PleaseMaintainTheCorrespondingSalesInThePartner: '合作伙伴で対応する販売を維持してください。',
  CheckRecordedCustomsDeclaration: '通関書の放行通知クエリ',
  ClearPacking: '梱包をクリアする',
  CopyMarksFromReceipt: '小切手の印字を取る',
  PODCountry: '仕向国',
  Details: '詳細',
  import: '導入',
  DangerousClass: '危険品クラス',
  DangerousGoodsContact: '危険物連絡先',
  DangerousGoodsContactPhoneNumber: '危険物連絡先電話番号',
  emptyBox: '空のコンテナ',
  Email2: 'メールアドレス',
  PreverifyStatus: '事前検証処理状況',
  ShipperByCompany: '出荷人（企業情報）',
  ConsigneeByCompany: '受取人（企業）',
  ChangeCommit: '変更費用を送信する',
  ConfirmChangeCommit: '変更費用を送信しますか？',
  UserDefinedField4: '備考欄４',
  BoardSales: 'パンチングシステム販売',
  BoardCsr: 'パンチングシステムカスタマーサービス',
  BoardSite: 'タブレットシステムサイト',
  ArrivalMethod: '到着方法',
  FlightLabel: 'エアラベル',
  bargePOL: 'バージPOL',
  SalesRequire: 'セールス要件',
  OnlyDisplayTicket: '条件を満たすチケットのみ表示',
  batchImportCharge: '料金を一括インポートする',
  importCharge: '料金をインポートする',
  historyLogQuery: '履歴ログクエリ',
  noRule: '番号規則',
  MBLNO: 'MBL NO',
  importSetting: 'インポート設定',
  receivable: '徴収可能額',
  payable: '支払う必要がある額',
  importFile: 'ファイルをインポートする',
  confirmImport: 'インポートを確認する',
  checkLines: '行数は1000行を超えることはできません',
  checkLines200: '行数は200行を超えることはできません',
  checkChargeInfo: 'インポート操作を行う前に、料金に関する情報を入力してください！',
  internal: '国内',
  overseas: '海外',
  batchOperate: '一括操作',
  batchImport: '一括インポート',
  activity: 'フロー',
  JobInfo: '業務情報',
  Service: 'サービス',
  Supplier: 'サプライヤー',
  InnerInfo: '内部情報',
  Defined: 'ユーザー定義',
  MoreInfo: 'その他の情報',
  unDisplayInfo: '非表示情報',
  GeneralInfo: 'チケット情報',
  BatchModifiedState: '一括状態変更',
  SplitTicketsInfo: '分割チケット情報',
  destinationStation: '到着駅',
  departureStation: '出発駅',
  transitStation: '経由駅',
  destinationStationRailport: '仕向地（鉄道）',
  departureStationRailport: '出発地（鉄道）',
  transitStationRailPort: '経由鉄道駅',
  CommonInfo: '共通情報',
  settlementAgent: '決済代行業者',
  Dimension: '寸法CM（長さ×幅×高さ）',
  PaymentType: '前払い/後払い',
  ToPay: '着払い',
  PrePay: '前払い',
  PickUpGoods: '荷物の引き取り',
  DocumentationNumberOfPackages: '書類件数',
  DocumentationGrossWeight: '書類重量',
  DocumentationVolume: '書類体積',
  DocumentationChargedWeight: '書類請求重量',
  CustomerQuantity: '顧客件数',
  CustomerGrossWeight: '顧客重量',
  CustomerVolume: '顧客体積',
  CustomerChargedWeight: '顧客請求重量',
  ImportTime: 'インポート時間',
  descr: 'コメント',
  logFile: 'ログファイル',
  VerifyReviewThrough: '承認する',
  VerifyReviewRefusal: '拒否する',
  ChargeBranchId: '所属支店',
  DateCreated: '作成日時',
  ProfitOwner: '利益所有者',
  ScfiDeclare: 'SCFI宣言',
  ScfiPrice: 'SCFI運賃',
  Copy: 'コピー',
  needInvoice: '請求書が必要',
  InvoiceNo: '請求書番号',
  ArrivalTime2: '目的地到着日',
  ProjectName: 'プロジェクト名',
  ProjectBatch: 'プロジェクトバッチ',
  CargosExpectedArrivalDateByTrucking: '予想着荷日（貨主ドア）',
  CargosExpectedArrivalDateWarehouseLoading: '予想着荷日（倉庫内装）',
  CargosExpectedArrivalDatePacking: '予想梱包日',
  EstimatedPackTheCabinetTime: '予想コンテナパッキング時間',
  MaintainJobNoRule: '作業番号のコード規則を維持してください！',
  SelectCodeRule: 'コード規則を選択してください',
  CodeRuleDesc: 'コード規則の説明',
  SpecifyAgentNumber: '指定された貨代理数',
  CustomsClearanceChargeRelatedEdit: '料金退関連の編集のみ可能です',
  CustomsClearanceNoChargeNoChange: '無償退関は、何も変更できません（すべての料金が削除されます）',
  ClearFeeNoChargeCustomsClearance: '無料退関をクリアしない場合、確認済みのすべての料金は無効になります。',
  VotesPreSubmission: '予備審査票を実行しますか？',
  AllNotPositiveOperationStatus: '選択したレコードはすべて【正オペレーション】処理状況ではありません。',
  AllNotToVerifyStatus: '選択したレコードはすべて【承認待ち】処理状況ではありません。',
  ContainerLoadTypeNotCorrect: 'このチケットのビジネス整理タイプは、自己貼り、バイヤーconsol、委託貼り付け箱ではありません。',
  RecordNotPositiveOperationStatus: 'このチケットの業務は「正オペレーション」処理状況ではありません。',
  RailwayCheckLob: '選択したJobには異なる取引タイプ があります。同じ取引タイプ を選択して再試行してください。',
  TheTicketIsMain: 'このチケットのビジネスは主要なものです',
  TheTicketAssociatedMain: 'このチケットのビジネスには関連する主要なものがあります。',
  TheTicketAssociatedContainerInfo: 'このチケットの業務には紐付けされたコンテナ情報があります。',
  ContainerLoadTypeIs: '集積タイプは既に',
  NoneModified: '変更不要',
  ContainerLoadTypeBatchModifySuccess: '一括での集積タイプの修正が成功しました：',
  NoDataProcessed: '処理済みのデータがありません',
  CustomsInformation: '税関情報',
  AddFile: 'ファイルを追加する',
  CustomsReceiptFile: '税関受領書ファイル',
  CustomsReceiptState: '税関受領状態',
  CloneCabinBerth: '船室を複製する',
  BackFillCabinBerth: 'キャビン回収',
  GenerateBusiness: 'ビジネスを生成する',
  ReturnCabin: '船室を返す',
  CheckBeforeEntrust: 'あなたの依頼{0}は、相手がSCACコードなどの関連情報をメンテナンスしていないため、相手に確認した後に依頼してください！',
  CheckPortBeforeEntrust: 'あなたの【{0}】の発注先には、【{1}】のポートがありません。相手に確認した後に委託してください！',
  CheckPackBeforeEntrust: 'The [{0}] you entrusted does not maintain the [{1}] pack, please check with the other party before entrusting!',
  PortDataPushLog: 'Port data push log',
  EdiStatusChangeLog: 'Edi status change log ',
  BookingReceiptLog: 'Booking receipt operation log',
  MergeAndSingle: 'Merge and single',
  OuJianDeclaration: 'Ou Jian declaration',
  AirportPort: 'Port of the airport',
  Airport: 'airport',
  GoodsStoragePlace: 'Place where goods are stored',
  ExchangeServiceAi: 'Do I need to draw an order',
  DataPushChangeLog: 'Data push change record',
  SendBookingData: 'Send booking data',
  SelectAction: 'Select Action',
  IsGroupBranch: 'Group branch or not',
  SmtpServerError: 'Smtp server error ',
  NotConnectSmtpServer: 'Unable to connect to SMTP server',
  NotFindFile: 'The system cannot find the specified file',
  SendFileError: 'Error sending file',
  AttachTemplateError: 'Attachment template error',
  MailSentSuccess: 'Mail sent successfully',
  PleaseSelectAction: 'Please select an action',
  PleaseSelectCategory: 'Please select the category of goods',
  PleaseSelectOpDep: 'Please select the operating department',
  SeaExportLetter: 'Letter of authorization for ocean export freight',
  DataPush: 'Data push',
  MasterTicketSync: 'Master ticket synchronization',
  BookingDataSentSuccess: 'Booking data sent successfully!',
  CostSettlementObjectBlocked: 'The settlement object [{0}] of the expense has been blocked and may be at risk. Do you want to continue saving?',
  ConsigneeRequired: 'Please input the send and receive information of Hb / L interface!',
  OverseaCustomerUpdate: 'The original overseas customer service [{0}] is invalid. Update to new overseas customer service [{1}]',
  ConatainerNoRemoveRelation: 'All data with case number {0} will be removed. Do you want to continue',
  EDIContainers: '梱包情報エディ',
  ContainersLog: '梱包情報受領ログ',
  PleaseSelect2: '送信するビジネスを選択してください！',
  MingShen: '民生',
  MingShenCompany: '民生国際船務代理有限公司',
  EDIBooking: 'EDI Booking',
  EDIDoc: 'EDI Doc',
  RoundPaymentAmountExchangeRate: 'Round (payment amount * payment exchange rate)',
  VGMIsEmpty: 'VGM is empty!',
  VGMRaw: 'VGM raw',
  VGMCorrection: 'VGM修正',
  FileOnlyXlsXlsx: 'ファイルはxls、xlsx形式のみアップロードできます！',
  FileOnlyXlsx: 'ファイルはxlsx形式のみアップロードできます！',
  UploadImageFormatWrong: 'アップロードされた画像の形式が正しくありません。現時点では、PNG、JPG、JPEGの画像形式のみサポートしています。変換するか、画像を変更してください。',
  ItIsEmpty: '空です',
  AdvancePayment_ActualAmount_HandlingCharge_PostTelecommunicationCharge_AcceptanceHandlingCharge: '支払い予定額（RMB）-実際の支払い金額（RMB）-手数料（RMB）-郵便料金（RMB）-受入手数料（RMB）',
  RelatedBusinessNoSpecial: '関連ビジネスに特別な貨物情報がありません',
  ReceiptImportFailed: '受領書のインポートに失敗しました！',
  ReceiptImportedSuccessfully: '受領書が正常にインポートされました！',
  ReceiptImport: '受領書のインポート',
  CopyLinkPublic: 'リンクをコピー（公共）',
  CopyLinkPromissoryNote: 'リンクをコピー（本票）',
  RepeatBoxType: '同じ箱型/箱種のレコードが2つあります',
  RepeatUldType: '既に同じULDコードのレコードが存在します！',
  RealDepartureTime: '実際の出発時間',
  RealDeparture: '実際の出発',
  ActualBerthingTime: '実際の入港時間',
  ImportFailedContactAdministrator: 'インポートが失敗しました。管理者に連絡してください。',
  ContractPeriod: 'パートナー：${0}は、有効期間内の契約があります。対応する信用請求書を調整するには【契約管理】に移動してください。',
  HasBeenSelected: '選択された',
  HasExceeded: '超過しました！',
  HasExceededCannotEDI: '超過しました。EDIできません！',
  UnloadingPortNotMaintain: '現在の "委託先" の "降ろし港" は、対応する代理店がメンテナンスされていません。既存の指定貨物代理および販売情報をクリアしてもよろしいですか？',
  EnYuanHuaXiaKu: '恩原華夏倉庫',
  EnyuanYangyuanKu: '恩原揚園倉庫',
  EnyuanGaoxiangku: '恩原高祥倉庫',
  NotInsuranceOperationPermission: '保険を掛ける操作の権限がありません！',
  CorrectionBillOfLading: '正式なビルを訂正する',
  ConfirmationBillOfLading: '提出書類の確認',
  Tips: 'ヒント！',
  PickUpTypeDifferentSmallTicket: '提取タイプが小切手と異なります。保存してもよろしいですか？',
  OperationDepartmentCannotBeEmpty: '操作部門は空にできません。',
  FileContentIsEmpty: 'ファイルの内容が空です',
  FileContentWrong: 'ファイルの内容が間違っています',
  FileSizeCannotLargerThan2MB: 'ファイルサイズは2MBを超えることはできません',
  NoData: 'データがありません',
  NoBusinessSelected: 'ビジネスが選択されていません。',
  OriginalNormal: '本物の正常性',
  NoImportEDI: 'この注文にはインポートできるEDIがありません',
  PackingDataNotCconsistent: 'この作業の箱詰めデータは実際のデータと一致しません。箱詰め情報を確認してください！',
  CreditControlTheClient: 'このチケットの委託先のクレジット管理',
  SaveBusinessBeforeEnterMultiGate: '注意：複数のゲートを入力する場合は、先にビジネスを保存してください',
  SaveBusinessBeforeEnterMultiGate2: '注：複数のゲートまたはコンテナを入力する場合は、先にビジネスを保存してください',
  BookingWorkspace_PrePlan_ImportExcel: '海運予約ブリッツ版-事前計画情報-Excelのインポート',
  SpecialCargoNumber: '特殊貨物番号',
  RelevantTicketsResetAndUpdated: '確認後、関連する小切手がリセットおよび更新されます。同期しますか？',
  ManifestConfirmed: '船荷証明書が確認されました！',
  ManifestDataIsEmpty: '船荷書類のデータが空です！',
  ManifestConfirmationFailed: '船荷書類の確認に失敗しました！',
  NodeTriggerFailed: 'ノードトリガーに失敗しました！',
  LoadingOfPackingInformationFailed: '荷造り情報のロードに失敗しました。',
  PlanDepartureTime: '予定出発時間',
  PlannedBerthingTime: '計画入港時間',
  OriginalPlanDepartureTime: '当初計画の離泊時間',
  OriginalPlannedBerthingTime: '当初計画の滞留時間',
  NowPlanDepartureTime: '現在の計画離泊時間',
  NowPlannedBerthingTime: '現在の計画寄港時間',
  CurrentETA: '現在の入港予定時刻',
  OriginalETA: '当初計画到着時刻',
  CurrentETA1: '現在の入港予定時刻（Current ETA）',
  OriginalETA1: '当初計画到着時刻（Original ETA）',
  ShippingScheduleNew: '船期導入テンプレート(新版)',
  ShippingScheduleold: '船期導入テンプレート(旧版)',
  ImportNew: 'インポート（新版）',
  ImportOld: 'インポート（旧版）',
  PlannedBerthing: '計画入港',
  PlanDeparture: '計画出発',
  BookingEDI: '予約EDI',
  BookingCorrection: '予約修正',
  PortMaintainedDesignatedFreightForwarder: '該当港は、指定貨代理が維持されています。この港で維持されている指定貨代理を使用しますか？',
  MBLStatusNotIsUnStart: 'この票のMBL対象処理状況は未開始ではありません。取り込むことができません。',
  PrimaryOrderNotSameReceipt: 'この票のビジネスマスター番号と回収書マスター番号が一致していません。取り込みを続けますか？',
  RequestSuccessful: '要求が成功しました！',
  SpecialCharacters: '港区や船会社のデータの購読を開始できない特殊文字が存在します',
  EnterReleaseNumber: 'リリース番号を入力してください',
  SelectAPieceOfData: 'データを選択してください！',
  SelectARecord: 'レコードを選択してください！',
  ChooseDesignatedAgent: '指定貨代理を選択してください！',
  ChooseSpecialGoods: '特殊品を選択してください！',
  CargoInformationIsEmpty: '貨物情報がありません。',
  InviteSupplementaryLinksPublic: 'サプリメントリンク（公共）を招待する',
  InviteSupplementaryLinkPromissoryNote: 'サプリメントリンク（本票）を招待する',
  DownloadCWTemplate: 'CargoWare テンプレートをダウンロード',
  DownloadCWTemplateJC: 'CargoWare テンプレートをダウンロード (JC)',
  DownloadSeaHouseTemplate: '海の家のテンプレートをダウンロードする',
  DownloadWseTemplate: 'CargoWare テンプレートをダウンロード (QingDao)',
  DownloadWseTemplateSh: 'CargoWare テンプレートをダウンロード (ShangHai)',
  ExportSinO56TemplateNb: 'SINO56テンプレートを導出します(NingBo)',
  DownloadWseTemplateVgm: 'Weiss テンプレートをダウンロード',
  SendingChannelVgm: 'そうしんチャネル',
  MailSendingFailed: 'メール送信に失敗しました！',
  DistributionFailed: '配布に失敗しました',
  SalesAndOperationAreSame: '販売と操作が同じです。保存してもよろしいですか？',
  PreConfiguredManifestAPI: '予め構成されたマニフェストAPI',
  PreConfiguredManifestDeletion: '予め構成されたマニフェスト削除',
  PreConfiguredManifestIsEmpty: '予め構成されたマニフェストの削除対象が空です。ページを更新してから再試行してください。',
  CorrectionOfPreAllocatedManifest: '予め割り当てられたマニフェストの修正',
  OperationFailed: '操作に失敗しました！',
  RedOffsetCannotModified: '赤字オフセット料金または赤字オフセット料金は、再度変更できません。調整を追加してください。',
  RedOffsetCannotDeleted: '赤字オフセット料金または赤字補填料金は削除できません。もう一度選択してください。',
  MaintainNodeDetailCode: 'ノード詳細コードを維持してください',
  DeleteNumRecord: 'これら{0}レコードを削除してもよろしいですか？',
  DeleteNumFile: 'これら{0}ファイルを一括削除してもよろしいですか？',
  ClickYesRetrievedToReturnedStatus: '"はい"をクリックすると、印刷ページにジャンプし、"取り戻された"ドキュメントが"返還済み"の状態に変更されます。',
  ClickYesToReturnedStatus: '"はい"をクリックすると、印刷ページにジャンプし、文書が"已退还"処理状況に変更されます。',
  FileNotAllowedView: '{0}ファイルを誰も見たりダウンロードしたりすることはできません。',
  NoPermissionToView: 'あなたは[{0}]ファイルを表示またはダウンロードするための権限を持っていません',
  UploadFailed: 'アップロードに失敗しました！',
  UploadSuccess: 'アップロードが成功しました！',
  UploadSuccessNoOrder: 'アップロードは成功しましたが、関連する注文が見つかりませんでした。',
  UploadedFileNotMatch: 'アップロードされたファイルの種類が一致しません。確認してください！',
  UploadType: 'アップロードタイプ',
  FileSource: 'ファイルソース',
  ReceiptType: '領収書タイプ',
  SendAisle: 'EDI Aisle',
  BusinessNotSubmitted: 'ビジネスが提出されていないため、注文を返すことができません。',
  BusinessNotBeenApproved: 'ビジネスがまだ承認されていません。返品しますか？',
  NoPermissionToViewOrprinted: '他の人がアップロードまたは印刷したファイルを表示またはダウンロードする権限がありません。',
  DocumentDelivery: '書類配達',
  SameStatusCanBePrinted: '同じ処理状況のドキュメントのみ印刷できます！',
  ReceiptContent: '受領内容',
  ReceiptTime: '受領時間',
  PrintCommonControls: '共通コントロールを印刷する',
  CustomsBrokerOthers: '通関業者/その他',
  ReceiveReceiptTime: '受領時間',
  ReceivingAddress: 'お届け先住所',
  bookingParty: '予約パーティー',
  BusinessIsLocked: 'このビジネスはロックされており、返品できません。',
  ConfirmUploadFileType: 'アップロードファイルタイプを確認して、アップロードを続行しますか？',
  InputCustomerName: '顧客名を入力してください！',
  InputExpressNumber: '迅速な番号を入力してください！',
  InputExpressAddress: 'エクスプレスアドレスを入力してください！',
  InputRecipient: '受取人を入力してください！',
  InputRecipientName: '受取人名を入力してください！',
  InputReceivingcompany: '受領会社を入力してください！',
  InputReceivingAddress: 'お届け先住所を入力してください！',
  InputContactNumber: '連絡先電話番号を入力してください！',
  InputContactNumberMark: '連絡先電話番号を入力してください！',
  InputReturnExpressNumber: '返品快速番号を入力してください！',
  ReturnInformation: '返品情報',
  ReturnDateGreaterThanRetrieveDate: '返品日は回収日よりも後でなければなりません！',
  dateModified: '更新日時',
  OperationCannotBeEmpty: '操作を空白にすることはできません。',
  OperationCompanyCannotBeEmpty: '操作会社を空白にすることはできません。',
  BookingAudit: '予約審査',
  UseThisNo: 'この番号を使用する',
  WarehousingFee: '保管料金',
  BookingSuccess: '予約成功',
  ToBeConfirmed: '確認待ち',
  BookingFail: '予約失敗',
  CabinState: 'キャビン状態',
  CostGenerationMethod: 'コスト生成方法',
  SettlementInPriginalCurrency: '元の通貨での決済',
  SettlementInBillCurrency: '請求書通貨での決済',
  ShowDetails: '詳細を表示する',
  ImportResultLog: 'インポート結果ログ',
  ImportComplete: 'インポート完了',
  SuccessItemFailedItem: '成功【{0}】項目、失敗【{1}】項目。',
  ContinueImporting: 'インポートを続ける',
  DownloadResultLog: '結果ログをダウンロードする',
  PONo: 'PO番号',
  VoyageOnlyNum: '航行回のみ数字または文字を入力してください。',
  UpdateSuccess: '変更に成功しました。',
  ShippingSpace: '船室',
  RejectTips: ' {0} を審査で拒否しますか？ 拒否理由を入力してください。',
  GenerateBusinessTips: 'ビジネスを生成してもよろしいですか？ （生成後、取り消すことはできません）',
  ReturnedShipping: 'すでに船室から出てきたことを確認しますか？ （記録が退去した後、取り消すことはできません）',
  ReturnedShippingSuccess: '出荷成功',
  ShippingCompanyAndBookingAgent: '対応する船会社とブッキングエージェントを入力してください',
  CabinCopySuccess: '部屋のコピーに成功しました。 新しいビジネス番号：',
  CheckShippingCompanyAndBookingAgent: '船会社とブッキングエージェントを1つだけ入力できません',
  ReviewRejectedSuccess: 'レビューが拒否されました',
  ReviewSuccess: 'レビューに成功しました',
  BatchReviewSuccess: 'バッチレビューに成功しました',
  CheckBatchReview: 'バッチレビュービジネスは50件を超えることはできません！',
  RefuseSuccess: '拒否に成功しました',
  BatchAuditSuccess: 'バッチ審査に成功しました',
  AuditSuccess: '審査に成功しました',
  CheckCreditTipOne: '委託企業は信用管理を超えているため、承認できません。',
  CheckCreditTipTwo: '以下のビジネスは信用管理を超過しています。 承認しますか？',
  BatchAuditBusinessTip: 'バッチ審査ビジネスは50件を超えることはできません！',
  CheckCreditSaveTip: '信用管理が超過したため、この票はロックされており、印刷またはEDIができなくなります。 必要な場合は、上位のレベルに連絡してロックを解除してください。',
  CabinCopy: '部屋のコピー',
  EnterShippingCompany: '【船室 {0}】に船会社を入力してください',
  EnterBookingAgent: '【船室 {0}】にブッキングエージェントを入力してください',
  EnterEtd: '【船室 {0}】で出港日を入力してください',
  CheckEnterShippingCompanyBookingAgentEtd: '船会社、ブッキングエージェント、および出港日を入力してください。',
  UnreviewedBusinessNumber: '審査されていないビジネス番号：{0}',
  UnreviewedBusinessNumber2: '審査されていない委託番号',
  DateOfCreation2: '作成日',
  plateNumberAndMblCannotBeEmpty: 'ナンバープレートとビル・オブ・ラディング番号は空にできません',
  ActualDateOfDeparture: '実際の出発日',
  ActualDateOfDeparture2: '実際出航日',
  nameOfVesselCannotBeEmpty: '船名は空にできません。',
  voyageNumberCannotBeEmpty: '航海回は空にできません。',
  shippingCompanyCannotBeEmpty: '船会社は空にできません。',
  MasterShippingCompanyCannotBeEmpty: 'マスター船会社は必須です',
  hasBeanSend: '送信されました',
  notSend: '送信されていません',
  UpdateTime: '更新時間',
  CategoryOfGoods: '商品カテゴリー',
  ShipperLine1: '発送人1行目',
  ConsigneeLine1: '受取人の1行目',
  NotifyPartyLine1: '通知先の1行目',
  CargoDocShipperLine1: '提出書類発送人の1行目',
  CargoDocConsigneeLine1: '提出書類受取人の1行目',
  CargoDocShipper: 'BL Shipper',
  CargoDocConsignee: 'BL Consignee',
  CargoDocNotify: 'BL Notify',
  CargoDocNotifyPartyLine1: '提出書類通知先の1行目',
  MBLBillOfLadingNum: 'マスターブールの連番',
  HBLBillOfLadingNum: 'ハウスブールの連番',
  RegularBusiness: '正式業務への転換',
  InputDate2: '入力日付',
  ExpectedArrivalDate: '予想着港日',
  ExportAllToExcel: '全てをExcelにエクスポート',
  FlightAndTime: 'フライト/回数',
  PleaseChooseEtdStartDate: 'ETD開始日を選択してください。',
  PleaseChooseEtdEndDate: 'ETD終了日を選択してください。',
  VOYAGE_NUMBER_ALERT: '航海番号を入力してください。',
  voyageNumberRepeat: '航海番号は重複できません。',
  DirectOrderOrNot: '直接注文かどうか',
  EDICode: 'EDIコード',
  MSCVesselImport: 'MSCインポート',
  MSCEDIExport: 'MSC Vessel CODE',
  pleaseDelEmptyCarrierRecord: '船会社の記録を空にすることはできません。',
  CannotBeTheSame: 'Co owned shipping companies cannot be the same as the main shipping company',
  PortNotNull: 'There is data with empty ports, and all ports for all voyages cannot be empty',
  PortDuplication: 'Ports cannot be duplicated',
  EtdAndEtaNotNull: 'Original ETA と Original ETD の両方が空にすることはできません',
  shipNameCannotBeEmpty: '船名は中国語または英語で入力してください。',
  alreadyExistsShipNameAndContinueToSave: '同じ船名が既に存在しています。保存を続行しますか？',
  exportThisPageEdi: 'このページのEDIをエクスポート',
  ExportAgentList: '代理店リストをエクスポート',
  ContinueToExport: 'エクスポートを続ける',
  OnlyMainTicketAndFCLServicesCanBeExported: 'メインチケットとFCLサービスだけがエクスポート可能です。選択したサービスはエクスポートできません。',
  IgnoresNonExportableServices: 'メインチケットとFCLサービスだけがエクスポート可能です。使用不可のサービスは自動的に無視されます。エクスポートを続けますか？',
  ExportSuccess: 'エクスポート成功しました。',
  voyageShippingCompanyCanNotNull: '航海番号の船会社は空欄にできません。',
  PleaseSelectShippingName: '船名を選択してください。',
  DownloadTemplate: 'テンプレートをダウンロード',
  BLForm: 'ビル・オブ・レーディング形式',
  FreeDetention: 'ディテンション日数',
  FreeDemurrage: 'デマレージ日数',
  CustomsAreaApplication: '税関申請',
  SettlementCompanyNotEmpty: '決済部門は空欄にできません。',
  StartMbl: 'マスターブールのプレフィックス',
  EndMbl: 'マスターブールの終了番号',
  BillOfLading: '積荷伝票番号',
  CartonQuantityCannotBeZero: 'カートン数量は0にできません。',
  DistributionNo: 'ディストリビューション番号',
  DistributionWarehouse: 'ディストリビューション倉庫',
  PreDateOfCustomsDeclaration: '通関予定日',
  sendFailed: '送信失敗しました。',
  SelfDeclaration: '自己申告',
  ExchangeService: '通関業者の交換サービスが必要かどうか',
  SpecialRelationshipOfBuyer: '買い手と売り手に特殊な関係があるかどうか',
  IncludeRoyalty: '特許使用料が含まれているかどうか',
  AffectPrice: '価格に影響を与えるかどうか',
  WoodPacking: '木製パッケージの有無',
  FilingType: '申告タイプ',
  emailAccount: '申告アカウント',
  secondGeneration: '2世代 注：2世代では、必ずカナダ税関記録番号を入力してください。',
  CanadianCustomsRecordNumber: 'カナダ税関記録番号',
  Combination: '組み合わせ',
  Split: '分割',
  FinalStepSync: 'ラストマイル同期',
  FinalStepSyncBtn: 'ラストマイル同期',
  Synced: '同期済み',
  NotSynced: '未同期',
  PleaseSelectSyncOrder: '同期する注文を選択してください',
  PleaseFillLastMilePlanner: 'ラストマイルビジネスリーダーを入力してください',
  PleaseSelectNotSyncedOrder: '未同期の注文を選択してください',
  CombinationJob: '組み合わせビジネス',
  ReceivableChargeLockedStatus: ' 受取可能料金ロック状態',
  PayableChargeLockedStatus: ' 支払可能料金ロック状態',
  NotLocked: 'ロックされていない',
  ChargeLocked: '受け取り可能な料金または支払い可能な料金がロックされているため、この操作はできません！',
  ArChargeLocked: '受取費用は固定されています!',
  ApChargeLocked: '支払費用は固定されています!',
  LockedStatus: 'ロック状態',
  LockedDate: 'ロック日時',
  LockAr: '売掛金ロック',
  UnLockAr: '受け取り可能な料金のロックを解除する',
  LockAp: '支払い可能な料金をロックする',
  UnLockAp: '支払い可能な料金のロックを解除する',
  importExpenseStatus: '輸入後の費用の状態',
  accountingDate: '輸入後の会計処理日',
  BatchReturnSubmit: '一括キャンセルを提出する',
  BatchReturnPreSubmission: '一括戻り予約を提出する',
  BatchUnlockReceivableExpenses: '受取可能な費用を一括解除する',
  BatchUnlockPayableFees: '支払い可能な料金を一括解除する',
  UnlockApplyBtn: 'ロック解除を申請',
  UnlockApplyTitle: '費用ロック解除申請',
  UnlockApplyJobCount: '今回の申請件数：{0}',
  UnlockApplyCountLimitTip: '1回最大200件',
  UnlockApplyReason: 'ロック解除申請理由',
  UnlockApplyReasonPlaceholder: 'ロック解除理由を入力してください',
  UnlockApplyReasonRequired: 'ロック解除理由を入力してください',
  UnlockApplyReasonOverLength: 'ロック解除理由は500字以内で入力してください',
  DeclaredProfitImpact: '申告粗利影響額',
  UnlockApplyAmountRequired: '申告粗利影響額を入力してください',
  UnlockApplySubmit: '申請を提出',
  UnlockApplyPrecheckFailed: '検証未通過、以下の業務は申請できません。調整後に再試行してください：',
  UnlockApplyFailureReason: '失敗理由',
  UnlockApplyOnlySeaExport: '海運輸出業務のみ申請できます',
  UnlockApplyOverLimit: '1回の操作は200件を超えることはできません',
  UnlockApplyChargeNotLocked: '売掛金・買掛金費用ともにロックされていないため、解除申請は不要です',
  UnlockApplyJobNotLocked: '現在の注文はロックされていないため、解除申請はできません!',
  UnlockApplyJobStateInvalid: '選択した注文に承認済み以外のステータスが含まれています。ご確認ください!',
  UnlockApplySubmitted: '申請が提出されました。バッチ番号：{0}',
  UnlockApplyApproving: 'ロック解除承認中',
  UnlockApplyUnlocking: 'ロック解除中',
  UnlockApplyUnlockedBanner: '当該注文の費用はロック解除され編集可能です。3日後の01:00に自動的に再ロックされます',
  BatchLockingReceivableExpenses: '受取可能な費用を一括ロックする',
  BatchLockingPayableFees: '支払い可能な料金を一括ロックする',
  ReplaceSOPTemplatesInBatches: 'Replace SOP Templates In Batches',
  BatchUpdateScNo: '一括で約束番号を変更する',
  BatchUpdateScNoSuccess: '一括で約束番号を変更しました：{0}',
  BatchUpdateScNoCheck: '正常に操作されたデータのみ一括変更できます。',
  BatchReturnSubmitCheck: '提出済みのビジネス処理状況のみキャンセルできます。',
  MasterChargeIsShare: 'マスターチケット料金が共有されているかどうか',
  PackageDisplayName: 'パッケージ表示名',
  ChargeSource: 'データ取得元',
  AddressOfContact: '連絡先住所',
  FinancialExamineDate: '財務審査日',
  ReceiptStatus: 'レシート状態',
  TransitInformation: 'トランジット情報',
  ThreeWay: '3ウェイ',
  BatchUpdateCustomJobType: 'カスタム取引タイプ を一括で変更する',
  CustomJobTypeBatchModifySuccess: 'カスタム取引タイプ を一括で変更しました:',
  BatchManagerSubmission: 'マネージャー提出を一括処理する',
  BatchManagerSubmissionTips: 'マネージャーは、正常操作と予備予約のみを一括で送信できます！',
  BatchManagerSubmissionSuccessfully: 'マネージャー提出が成功しました：',
  VotesManagerSubmission: '票を主管に提出しますか？',
  CopyEnglishDescriptionOfGoodsFromMergeJob: '英語品名をマージジョブからコピーする',
  CopyMarkFromMergeJob: 'マージジョブから唛头をコピーする',
  SyncToSmallTicket: '小切手に同期する',
  externalBusinessStatus: '注文処理状況',
  SoNo1: 'S/O No.',
  NaturalPerson: '自然人',
  LegalPerson: '法人',
  IndividualAssociation: '個人協会',
  TelSeparate: '電話番号は"-"で区切ってください',
  EnsNo: 'ENS番号',
  ShippingCompanyEORI: '船会社のEORI',
  DeclarantEORI: '申告者のEORI',
  Memberstate: 'EUに最初に入国した国',
  ENumber: 'ENS番号',
  EnsHsCodeNotMatch: '梱包情報関連貨物情報番号と箱情報不一致情報番号は空にできません',
  EnsCorrelativeNoRepeat: '貨物情報番号は重複しています',
  LinkedCargoInformationNoNotNull: '梱包情報関連貨物情報連番は空にできません',
  maxLength: '長さは{0}文字を超えてはならない',
  PleaseEnterLength: '{0}文字を入力してください',
  FreightTermConflict: 'の選択と陸揚げ港の納品先情報の選択には矛盾がある',
  FreightTermConflict2: 'の選択と積港受入地情報の選択には矛盾がある',
  NeedPrefix: '接頭辞付き申告が必要、単番接頭辞：{0}',
  RemoveThePrefix: '接頭辞を削除する必要があります:{0}',
  PhoneTooLong: '市外局番は4文字を超えてはならず、電話番号は20文字を超えてはならない',
  SaveOnly: '保存のみ',
  Only6: '6桁の数字のみをサポート',
  ChargesPaymentMethod: '料金支払い方法',
  CopyConsignor: '発送人のコピー',
  CopConsignee: '受取人のコピー',
  BuyerAndSellerInformation: '購買情報',
  StreetNumber: '通り番号',
  WaitingForReceipt: '最後に送信されましたが、まだ受信されていません。再度送信するまで待ってください',
  DirectlyRepresenting: '直接代表',
  IndirectRepresentation: '間接代表',
  NeedOne: 'データを追加するだけ',
  ContainShutOutJob: '退关業務を含む',
  BatchEditJobNo: '一括で業務番号を編集する',
  IncludingSCFIFreightRate: 'SCFI運賃を含む',
  SCFIDesignatedBoxType: 'SCFI指定箱型',
  JingyiSystemForecast: '荊艺システム予報',
  OriginalAHR: 'オリジナルAHR',
  AddChr: 'CHRを追加',
  CorrectAFR: 'AFRを修正する',
  NonRepeatingNumbers: '重複しない数値',
  AddressFormatting: 'アドレスフォーマット',
  SendToGoFreight: 'GO FREIGHTに送信',
  ViewSendLog: '送信ログを表示',
  BookingFreightRate: '予約運賃',
  SelectedDataDeclaration: '選択したデータ宣言',
  EmptySubmissionDeclaration: '空の提出宣言',
  SettlementFreightRate: '決済運賃',
  DeclarationRecord: '宣言記録',
  ImNotHavePermissionDetails: '申し訳ありません！詳細情報を表示する権限がありません。',
  ActionOptionsNotCaptured: '操作内容オプションはキャプチャされていません！',
  BatchNotSupportedPleaseAgain: 'バッチ送信はサポートされていません。もう一度選択してください！',
  ItFreightAndRepeatedAllowed: 'すでにGO FREIGHTに送信されており、繰り返し送信は許可されていません',
  SentSuccessfully: '正常に送信されました',
  CheckTheSendingLog: '送信ログを確認しますか？',
  OnlyToViewTheSelect: '送信ログを見るには、1つのビジネスのみ選択できます。もう一度選択してください！',
  ItUpTo50Businesses: '最大50ビジネスを処理できます。',
  Business: '業務：',
  NonIntegralType: '非整合タイプ',
  SendComplete: '送信完了',
  PackingList: 'パッキングリスト',
  PleaseContainerBusinessForOperation: 'コンテナビジネスを操作してください！',
  EmptyInterfaceSendingPleaseWait: '空の箱データ送信インターフェース、お待ちください......',
  VerificationOfDeclarationData: '宣言データの検証',
  DataCheckTheDataAgain: 'データ検証に失敗しました。データを確認してから再試行してください。',
  PleaseWhetherToSubmitThis: 'この',
  TicketData: 'チケットデータを送信しますか？',
  DataDeclarationSucceeded: 'データ宣言に成功しました。',
  EmptySubmittedSuccessfully: '空の提出が成功しました。',
  NotData: 'データはありません。',
  ThereElectronicPackingListData: '電子パッキングリストデータはありません。',
  SendFailed: '送信に失敗しました：',
  Empty: '空',
  PleaseOfDepartureMustPort: '出発港が上海港であることを確認してください。',
  PleaseMustBeTheExchange: '卸売港は航交所で指定された港である必要があります。',
  PleaseOfGoodsMustGoods: '貨物種類は一般貨物でなければなりません。',
  PleaseOfTheMainCY: 'マスター運送条件は「CY-CY」でなければなりません。',
  PleaseTradeTermsMustCIF: '貿易条件は「CIF」でなければなりません。',
  PleaseBoxQuantityInformationCorrect: '箱量情報が正しいことを確認してください。',
  TheAmountReceivableIncludesUSD: '請求 - 受領可能料金にUSD指定料金を含めることを確認してください。',
  NoBillOfLadingInformation: 'HBL提出情報がありません。',
  ResponseDataIsEmpty: 'レスポンスデータが空です。',
  PleaseToViewTheLog: '送信ログを表示するビジネスを選択してください。',
  ExportEDI: 'EDIをエクスポートしますか？',
  LandTransportationDetailsEditing: '陸上輸送詳細情報の編集',
  PreviewOfBookingFileParsing: '予約ファイルの解析プレビュー',
  GenerateOrder: '注文書を生成する',
  HangInTheAir: '未完了',
  Completed: '完了しました',
  Dustbin: 'ごみ箱',
  PictureLoadingFailed: '画像の読み込みに失敗しました',
  ResolutionCompletionTime: '解像度完了時間',
  ViewParsingResults: '解析結果を表示する',
  ViewOrder: '注文書を閲覧する',
  AreYouWantToDelete: '削除しますか？',
  BusinessNumber: '取引番号',
  LCL: 'フルコンテナロード/荷物の積み合わせ',
  NearlyAWeek: '1週間以内',
  NearlyAMonth: '1ヶ月以内',
  NearlyThreeMonths: '3ヶ月以内',
  DragUploadTheFileIdentified: '識別するファイルをここにドラッグアンドドロップしてアップロードしてください',
  SupportUploadFormat: 'アップロード可能な形式',
  ParsingFailed: '解析に失敗しました',
  ParsingComplete: '解析が完了しました',
  OrderGenerated: '注文書が生成されました',
  UploadCompletedParsing: 'アップロードが完了し、解析中です...',
  Second: '秒',
  ReviewRejectedBusinessNumber: '拒否された業務番号を再確認する',
  RejectedBusinessNumber: '拒否された業務番号',
  TheNotExceed5Lines: '最大5行まで！',
  Interface: 'インターフェース',
  Sinotrans: '中外運',
  SinotransEastChinaCoLtd: '中国外運華東有限公司',
  NingboEPort: '寧波電子口岸',
  SeaHousekeeper: '海の管理人',
  Wse: 'Wse',
  CargoWare: 'Cargoware 送信',
  EDISend: 'EDI 送信',
  OtherChannel: 'その他のチャネル',
  Ningbo99Road: '寧波99ロード',
  DeclarationHistory: '申告履歴',
  CredentialNumber: 'クレデンシャル番号',
  ResponseCode: 'レスポンスコード',
  ElectronicBoxListSendingHistory: '電子箱リスト送信履歴',
  PrintTime: '印刷時間',
  PrintingTimes: '印刷回数',
  BookingDataFeedback: '予約データのフィードバック',
  QuerySendingLog: '送信ログの問い合わせ',
  SendDataInformation: 'データ情報を送信する',
  ExportAllEDI: 'すべてのEDIをエクスポートする',
  UploadThisPageEDI: 'このページのEDIをアップロードする',
  UploadAllEDI: 'すべてのEDIをアップロードする',
  EmailUploadEDI: 'EメールでEDIをアップロードする',
  IsExportEDI: 'EDIをエクスポートしますか？',
  UploadEDI: 'EDIをアップロードしますか？',
  IsUploadAllEDI: 'すべてのEDIをアップロードしますか？',
  MailSending: 'メール送信',
  UploadEDISucceeded: 'EDIのアップロードに成功しました',
  FailedToUploadEDI: 'EDIのアップロードに失敗しました',
  CurrentNetworkChannelUnstable: 'チャネルは現在ネットワークが不安定なため、バックグラウンド送信キューに移動しますか？',
  EdiTips: 'EDI送信プロンプト',
  HasBillExist: '【｛0｝】システム送信キューにすでに船荷証券番号があります。再送する必要はありませんので、お待ちください。\'、',
  MultiSegmentNumberRuleConfiguration: '複数セグメント番号規則の設定',
  StartNumber: '開始番号',
  IncrementalRule: '増分規則',
  DirectExport: '直接エクスポート',
  Plus1: '1を追加',
  Plus10: '10を追加',
  TheNumberCannotBeEmpty: '起始番号を入力してください。',
  IllegalNumberEntry: '番号の入力が正しくありません。',
  TheMustBeGreaterZero: '数量は0より大きくなければなりません。',
  IncrementRuleIsNotSelected: '増分ルールが選択されていません。',
  PleaseBusinessNumberSearchCriteria: 'ビジネス番号の検索条件を入力してください。',
  UploadCompletedProcessing: 'アップロードが完了し、処理中です。',
  SuccessfulProcessing: '処理が成功しました。',
  ProcessingFailed: '処理に失敗しました。',
  ExportTime: 'エクスポート時間',
  UnitPriceCannotBe0: '単価は0にできません。',
  ExchangeRateCannotBe0: '為替レートは0にできません。',
  CustomsNoCannotBeBlank: '通関番号は空白にできません。',
  ShipperCityCannotBeBlank: 'Please enter the shipper’s city name',
  PrimaryCustomsNo: '主関税番号かどうか',
  GetPackingInformation: 'パッキング情報の取得',
  GetGoodsInformation: 'Obtain cargo information',
  GetGoodsInformationTip: 'Obtain the size of the warehouse entry record associated with the [Goods Information] tab',
  SynchronizeMainTicketPackingInformation: 'メインチケットパッキング情報の同期',
  CaseNumberCannotBeEmpty: '箱番号は空白にできません。',
  InvalidCaseNumber: '無効なケース番号です。',
  TheSealNumberCannotBeEmpty: 'シール番号は空白にできません。',
  BoxTypeCannotBeEmpty: 'ボックスタイプは空白にできません。',
  EnglishNameCannotBeEmpty: '英語名を入力してください。',
  TheMarkCannotBeEmpty: 'マークを入力してください。',
  HscodeCannotBeEmpty: 'HSCODEは空白にできません。',
  EqCodeMatchError: '箱型箱種が一致しません,選び直してください',
  ThePackageCannotBeEmpty: 'パッケージは空白にできません。',
  ThePiecesCannotBeEmpty: '数量は空白にできません。',
  GrossWeightCannotBeEmpty: '総重量は空白にできません。',
  VolumeCannotBeEmpty: '容積は空白にできません。',
  DanUNNoCannotBeEmpty: '【UNコード】危険物は必須です。範囲は0001-9999です。',
  DanClassNoCannotBeEmpty: '【危険物等級】危険物は必須です。範囲：1-9.9',
  DangerousGoodsContactCannotBeEmpty: '危険物連絡先は空白にできません。',
  DangerousGoodsContactPhoneNumberCannotBeEmpty: '危険物連絡先の電話番号は空白にできません。',
  TherePleaseEnterItTab: 'インポート可能な情報がありません。「パッキング情報」タブに移動して入力してください。',
  NoMasterTicketInformationYet: 'まだメインチケット情報がありません！',
  WeighingMethod: '測定方法',
  VGMLLC: 'VGM責任法人',
  VGMWeightAddress: 'VGM重量アドレス',
  VGMSignature: 'VGM署名',
  TareWeight: 'タレの重さ',
  TareWeightUnit: 'タレの重さ単位',
  WeighingAddress: '測定場所',
  WeighingMethodCannotBeEmpty: '測定方法は空白にできません。',
  TheWeightCannotBeEmpty: '総重量は空白にできません。',
  VGMCompanyCannotBeEmpty: 'VGM責任会社は空白にできません。',
  VGMSignatureCannotBeEmpty: 'VGM署名は空白にできません。',
  MailboxCannotBeEmpty: 'メールボックスは空白にできません。',
  PhoneNumberCannotBeEmpty: '電話番号は必須です。',
  WeighingAddressCannotBeEmpty: '計量住所は必須です。',
  NotifierCodeCannotBeEmpty: '通知者の企業コードは必須です。',
  ContactNotifierCannotBeBlank: '連絡する通知者は空白にできません。',
  ImportTallyInformation: '貨物情報導入',
  PTImport: 'PTインポート',
  SelectTime: '時間を選択してください',
  CaseNoSealNo: '箱番号-シール番号',
  CopySmallTicketCost: '小切手コストのコピー',
  PleaseCostToBeCopied: 'コピーするコスト料金を選択してください。',
  CrossTenantDelegationHistory: 'テナント間委任履歴処理状況レコード',
  Operator: 'オペレーター',
  OperationTime: '作業時間',
  DelegationStatusHistory: '委任処理状況履歴レコード',
  GeneratePrimaryDocNo: '主要書類番号を生成する',
  PleasePrimaryOrderNumberRule: '主要書類番号ルールを選択してください。',
  PleaseCodeOfTheNo: '主要書類番号のサービスコードを選択してください。',
  SendOnlineManifestInvitationEmail: 'オンラインマニフェスト招待メールを送信する',
  PleaseConfirmEmailAddress: 'メールアドレスを確認してください：',
  ShippingPreConfigurationInformationManifest: '海上予約スピードバージョン-事前構成情報-オンラインマニフェストを招待する',
  TheSentToTheIt: '招待リンクはメールに送信されました。受信トレイを確認してください！',
  TotalCustomsNo: '総関税番号',
  TotalNumberOfPieces: '合計ピース数',
  TotalGrossWeight: '合計重量',
  TotalVolume: '合計体積',
  CustomsNoNotImported: 'インポートされていない関税番号：',
  ImportDate: 'インポート日',
  ImportUser: 'インポートユーザー',
  SendUser: '送信ユーザー',
  ManifestImportUser: 'マニフェストインポートユーザー',
  SendTag: '送信タグ',
  SubtotalOfCustomsOrderNo: '関税番号の小計',
  ConfirmToVoid: '作废を確認しますか？',
  MBNOCannotBeEmpty: 'MB/L Noは必須項目です。',
  ShipNameCannotBeEmpty: '船名は必須項目です。',
  EnglishShipNameCannotBeEmpty: '英語の船名は空にできません',
  VoyageCannotBeEmpty: '航海は必須項目です。',
  ShippingCompanyCannotBeEmpty: '船会社は必須項目です。',
  ShippingAgentCannotBeEmpty: '船代は必須項目です。',
  DestinationPortCannotBeEmpty: '目的港は必須項目です。',
  GoodsTypeCannotBeEmpty: '貨物種別は必須項目です。',
  TransportationTermsCannotBeBlank: '運送料金条件は空白にできません。',
  FreightTermsCannotBeBlank: '運賃条件は空白にできません。',
  BillTypeCannotBeEmpty: 'B/Lタイプは必須項目です。',
  PaymentPlaceCannotBeEmpty: '支払い場所は必須項目です。',
  MattersNeedingAttention: '注目すべき点',
  DontRemindMeAgain: '再度リマインダーを表示しない',
  CloseSpace: '閉じる',
  TheBeenSentToSending: 'このマニフェスト内の関税番号【{0}】がEDIに送信されました。引き続き送信しますか？',
  SelectToSendPreManifest: '予約マニフェストチャンネルの送信先を選択する',
  SelectCorrectConfiguredManifestChannel: '正しい予約マニフェストチャンネルを選択してください。',
  SelectDeleteConfiguredManifestChannel: 'プリセット船荷証明書チャネルを削除する',
  ThePleaseRefreshTheAgain: 'クリーンな船荷進度オブジェクトがありません。ページを更新してから再試行してください。',
  CustomsClearanceNo: '分関番号',
  ShippingCompanyOperation: '海運会社操作',
  CustomsRestAssured: '海関放心',
  PlanType: '計画タイプ',
  AcceptanceTime: '受付時間',
  ScheduledStartTime: '予定開始時間',
  PlannedEndTime: '予定終了時間',
  DepartureTime2: '港湾開始時刻：',
  PortCutOffTime: '港湾締め切り時間：',
  ActualBerthingTimeColon: '実際のバース時間：',
  ActualDepartureTimeColon: '実際の出港時間：',
  ClickToViewTheTrailer: 'トレーラーを表示するにはクリックしてください',
  DisplayPortArea: '以下のデータは港区/船会社のデータを示しています',
  DetailedData: '詳細データ',
  manualPrompt: 'オレンジ色のデータ：データサービス',
  thirdPartyPrompt: '浅い青色のデータ：手動入力',
  promptNo: 'グレーのデータ：データなし',
  promptNoData: 'No data is available',
  ArrivalReportStatus: '到着報告の状態',
  CustomsClearanceSheetStatus: '分関伝票の状態',
  PlanDetails: '計画の詳細',
  PutInTheBox: '箱に入れました',
  EmptyBox: '空の箱',
  Arrival: '到着',
  EstimatedCYOpening: '予想開港日',
  PortDocCutOff: '港湾でカットオフされた書類',
  ActualBerthing: '実際のバース',
  ActualDeparture: '実際の出港',
  customsClearance: '海関の許可',
  DockRelease: 'ドックリリース',
  CancelCustomsClearance: 'Cancel Customs Clearance',
  CancelDockRelease: 'Cancel Dock Release',
  AllocateVehiclesToTransportSth: '配車',
  Sail: 'セーリング',
  Departure: '出港',
  Pickup: 'ピックアップ',
  BusinessFunction: '業務機能',
  ClickTheButton: 'ボタンをクリックしてください',
  ReturnAddress: '返却先住所',
  DepartureTime3: '出発時刻',
  ArrivalWharf: '到着港湾',
  departureTime: '出港時間',
  StowageTime: '積載時間',
  AbnormalCause: '異常原因',
  StackingTime: 'スタッキング時間',
  StackingState: 'スタッキング状態',
  SeaReleaseTime: '海放時間',
  SeaReleaseDescription: 'Sea release instructions',
  SeaReleaseState: '海放状態',
  arrivalTime: '到着時間',
  TrailerFollow: 'トレーラーが後ろについてくる',
  SuitcaseLocation: 'スーツケースの場所',
  BoxReleaseTime: '箱の解放時間',
  EstimatedPickUpPoint: '予想ピックアップポイント',
  Wharf: '港湾',
  NameNumberOfImportedVessels: '輸入船名船番号',
  FieldBoxPosition: 'フィールドボックス位置',
  NameNumberOfExportVessel: '輸出船名船番号',
  containerWeight: 'コンテナ重量',
  VGMWharfWeighing: 'VGM港湾計量',
  ContainerHolder: 'コンテナホルダー（上海港のみ）',
  LeadSeal: 'リードシール番号',
  TransshipmentPort: '転送港',
  VGMMessageReceiving: 'VGMメッセージ受信',
  ApproachMode: 'アプローチモード',
  ArrivalMessageTime: '到着メッセージ時間',
  AppearanceMode: '外観モード',
  ReeferTemperatureRequired: '冷蔵温度が必要です',
  ReceivedTheReleaseTime: 'Received the release time',
  NationalInspectionRelease: 'National inspection release',
  OverrunCode: 'Overrun code',
  WharfStowage: 'Wharf stowage',
  EmptyContainerRelease: 'Empty container release',
  Front: 'front',
  After: 'after',
  SuperLong: 'Super long',
  FlowTo: 'flow to',
  Left: 'Left',
  Right: 'right',
  UltraWide: 'Ultra wide',
  MaritimeReleaseException: 'Maritime release exception',
  SuperHigh: 'super high',
  QuantityOfBoxesAndPieces: 'Quantity of boxes and pieces:',
  GreaterActualNumberOfPieces: 'Greater than the actual number of pieces:',
  BoxWeight: 'Box weight:',
  GreaterThanActualWeight: 'Greater than actual weight:',
  BoxVolume: 'Box volume:',
  LargerThanActualVolume: 'Larger than actual volume:',
  JobNoColon: 'Job No:',
  AddSpellCustomsOrderNo: 'Add S/O No.',
  PleaseForAddingAndForm: 'Please select the number rule for adding and spelling customs clearance form',
  PleaseSelectSuffixSeparator: 'Please select suffix separator',
  PleaseCustomsDeclarationNoSpelled: 'Please enter the quantity of customs declaration No. to be spelled',
  DirectToCanada: 'Direct to Canada',
  ToInlandWarehouse: 'To inland warehouse',
  TransitClearancePullToStates: 'Transit in Canada, no customs clearance, pull to the United States',
  TheThroughTheUnitedStates: 'The goods pass through the United States',
  PleaseSelectAnAccount: 'Please select an account',
  PleaseOfYourCurrentFirst: 'Please maintain the code of your current department first!',
  ItServiceProviderOfHouse: 'It has become a service provider of "wolian house"',
  YouHisPartnerAndService: 'You can apply online to become his partner and enjoy the online ordering service.',
  PleaseSelectTheEntrustingCompany: 'Please select the entrusting company!',
  PleaseSelectDestinationAgent: 'Please select destination agent!',
  UncheckedSmallTicket: 'Unchecked small ticket',
  CustomerInformation: 'Customer information',
  CodeCannotBeEmpty: 'Code cannot be empty',
  TheNameCannotBeEmpty: 'The name cannot be empty',
  CertificateTypeCannotBeBlank: 'Certificate type cannot be blank',
  IDNumberCannotBeEmpty: 'ID number cannot be empty',
  AddressCannotBeEmpty: 'Address cannot be empty',
  CityCannotBeEmpty: 'City cannot be empty',
  CountryCannotBeEmpty: 'Country cannot be empty',
  ThisSuccessfullyInsuredRepeatedAllowed: 'This ticket business has been successfully insured. Repeated insurance is not allowed',
  Seller: 'seller',
  Manufacturer: 'Manufacturer ',
  Consolidator: 'consolidator ',
  OriginalBookingParty: 'Original booking party',
  GoodsReceiver: 'Goods receiver',
  PackingPoint: 'Packing point',
  Importer: 'importer',
  AMSNoCannotBeBlank: 'AMS sub doc No. cannot be blank',
  SCACCompanyCannotBeEmpty: 'SCAC of shipping company cannot be empty',
  TheDischargeCannotBeEmpty: 'The port of discharge cannot be empty',
  TheDeliveryCountryCannotBeEmpty: 'The country of delivery cannot be empty',
  TheDeliveryCannotBeEmpty: 'The place of delivery cannot be empty',
  CorrectionOfBillOfLading: 'Correction of bill of lading',
  OriginalBillOfLading: 'Original bill of lading',
  TheBillOfLadingEmpty: 'The place of shipment of bill of lading cannot be empty',
  SailingDateEmpty: 'Sailing date cannot be empty',
  TransceiverSelection: 'Transceiver selection',
  YouServiceOfTheManifest: 'You can click the icon to consult the customer service of the sea housekeeper for the pre configured manifest.',
  OriginalCleaningManifest: 'Original cleaning manifest',
  Correction1: 'Correction 1',
  CorrectCleaningManifest: 'Correct cleaning manifest',
  SendPreConfiguredManifest: 'Send pre configured manifest',
  CorrectionOfPreAllocationManifest: 'Correction of pre allocation manifest',
  DeletePreConfiguredManifest: 'Delete pre configured manifest',
  CancelPreConfiguredManifest: 'Cancel Pre Configured Manifest',
  OriginalPreAllocatedManifest: 'Original pre allocated manifest',
  CleanManifestAPI: 'Clean manifest API',
  OriginalVGM: 'Original VGM',
  HscodeConfigurationInformationCannotEmpty: 'Hscode of pre configuration information cannot be empty',
  HscodeInformationMustBeDigits: 'Hscode of pre configuration information must be 6 digits',
  PleaseTickTheBoxForTheCargoInformationYouWantToAmendTheManifest: 'Please tick the box for the cargo information you want to amend the manifest',
  PleaseConfirmThatTheCustomsInformationYouSelectedHasNotBeenModified: 'Please confirm that the customs information you selected has not been modified',
  PleaseSelectAllSeaHouseUpdateData: 'If you modify the content of the [Basic Manifest Information] & [Customer Shipping Information] module, you need to select all the customs order information that has been sent and send it together',
  SendingSucceeded: 'Sending succeeded!',
  TheTheReceiptLogInformation: 'The original manifest has been sent. Click the receipt log to view the manifest receipt information.',
  UpdateSucceeded: 'Update succeeded!',
  PleaseSuccessfullyIfNotFirst: 'Please confirm whether the original manifest is sent successfully. If not, please send the original manifest first.',
  DeleteSucceeded: 'Delete succeeded!',
  WseModifyReasonNotEmpty: 'Please select the reason for order change',
  WseModifyRemarkNotEmpty: 'Please add instructions for changing the order',
  WseDeleteReasonNotEmpty: 'Please select the reason for deleting the order',
  WseDeleteRemarkNotEmpty: 'Please add instructions for deleting orders',
  BrandNew: 'brand new',
  SecondHand: 'second-hand',
  Unknown: 'Unknown',
  ReImportAfterModification: 'Re import after modification',
  FailedToDownloadData: 'Failed to download data',
  ClickVehiclePositioningAndTrack: 'Click the button to query vehicle positioning and vehicle driving track.',
  VehiclePositioningTrack: 'Vehicle positioning track',
  IfToTheCurrentIt: 'If the expense status of the changed company is not synchronized to the current payable tab, do you want to continue to delete it?',
  VehicleTrajectory: 'Vehicle trajectory',
  DistributionCustomsNo: 'Distribution customs No',
  BookingReceipt: 'Booking receipt',
  InMailOfThePrevail: 'In the internal survey stage, the mail of the ship owner shall prevail',
  CorrectBooking: 'Correct Booking',
  OriginalBooking: 'Original booking',
  TheBeVoidedAndThis: 'The primary doc No. has been generated. If it is generated again, the original doc No. will be voided and a new doc No. will be generated. Are you sure you want to do this?',
  BasicTab: 'Basic tab',
  TheHairBodyCannotEmpty: 'The actual part hair body cannot be empty',
  PackageCannotBeEmpty: 'Package cannot be empty',
  MBLTab: 'MBL tab',
  ShipperCannotBeBlank: 'Shipper cannot be blank',
  ConsigneeCannotBeEmpty: 'Consignee cannot be empty',
  NotifierCannotBeBlank: 'Notifier cannot be blank',
  TheEmptyPleaseRefreshAgain: 'The pre configured manifest object is empty. Please refresh the page and try again',
  TheIsEmptyPleaseAgain: 'The object of pre configured manifest correction is empty. Please refresh the page and try again',
  VGMRefreshThePageAgain: 'VGM object is empty, please refresh the page and try again',
  TheCleaningIsEmptyPleaseAgain: 'The object of pre configured cleaning manifest is empty. Please refresh the page and try again',
  TheNoCannotBeBlank: 'The customs clearance No. cannot be blank',
  MBLNoCannotEmpty: 'MB / L NO cannot be empty',
  NewGoods: 'Add Cargo',
  DeleteGoods: 'Delete Cargo',
  TotalOfThisBox: 'Total of this box:',
  DataComparison: 'Data comparison',
  UpdatePortAreaData: 'Update Port Data',
  NoPortDataHasBeenObtained: 'No port data has been obtained',
  SynchronizePortData: 'Synchronize port data',
  NotVerified: 'Not verified',
  SystemVerification: 'System verification',
  ManualVerification: 'Manual verification',
  ToBeConfirmed2: 'To be confirmed',
  TheInThePortOpened: 'The push service of container cargo data in the port area has not been opened',
  TheDirectlyImportTheCall: 'The port container data service can help you verify whether the container information is correct, or directly import the port container data into the business. To open, please contact online customer service or call:',
  HarbourNotInServiceNoOpen: 'The corresponding port has not opened the data comparison service yet, so the data comparison function cannot be provided. At present, it supports data comparison in other ports. If you need to open it, please contact online customer service or call the contact number：',
  HarbourInServiceNoOpen: 'The container data service in the port area can help you check whether the container information is correct or not. It can also directly import the container data in the port area to realize easy data entry. If you need to call customer service online：',
  HarbourNotInServiceOpen: 'Currently, push and comparison of data in this port area are not supported.',
  ThisActionCannotBeUndone: 'This action cannot be undone',
  DoYouWantToContinue: 'Do you want to continue?',
  ItPortDataAndVerified: 'It does not match the port data and cannot be verified',
  TheNotContainTheData: 'The current data does not contain the following port data',
  PortInformationVerification: 'Port information verification',
  SIsMissingAndVerified: 'S / O no is missing and cannot be verified',
  PleaseNoForTheFirst: 'Please fill in S / O no for the current small ticket first',
  TheOverwriteTheCurrentData: '功能会覆盖当前数据',
  OperationSucceeded: '操作成功！',
  OrderNumber: '订单数',
  TotalPacking: '总包装数',
  ContainerList: '集装箱列表',
  UpdateStatus: '更新状态',
  ClearThePackingInformation: '清除装箱信息',
  ExportThePackingPlan: '导出装箱计划',
  checkGoods: '查看商品',
  checkPackages: '查看包装',
  NumberOfPackages: '包装数量',
  AskForPositionTime: '要求进仓时间',
  EstimatedPositionTime: '预计进仓时间',
  CheckTheDetailsOfTheGoods: '查看货物详情',
  UnableToRemove: '无法移除，集装箱已锁定或已装箱',
  removeOrderTips: '是否确定移除此订单？',
  removeOrder: '移除订单',
  NO: '号',
  PackageNo: '包装号',
  NumberOfPackagesAnticipateOrReality: '包装数(预/实)',
  Code4: '编码',
  LengthAnticipateOrReality: '长(预/实)',
  WidthAnticipateOrReality: '宽(预/实)',
  HighAnticipateOrReality: '高(预/实)',
  UnitVolumeAnticipateOrReality: '单位体积(预/实)',
  GrossWeightAnticipateOrReality: '单件毛重(预/实)',
  Considerations: '注意事项',
  Anufacturer: '生产商',
  EstimateLoadingTime: '预计货好时间',
  ActualWarehousingTime: '实际进仓时间',
  NoCorrespondingFile: '没有取到对应的文件！',
  ChooseState: '选择状态',
  ActualPackingTime: '实际装箱时间',
  ChooseActualPackingTime: '请选择实际装箱时间',
  updateContainerStateTip: '更新失败，该箱子存在未入仓的订单',
  firstCleanedContainer: '请先选择需要清除的集装箱',
  containerBeCleared: '的集装箱无法清除',
  removeSelectedContainer: '是否确定移除所选集装箱下的全部订单？',
  ClearContainerInformation: '清除集装箱信息',
  goodsOperateTips: '请先保存该单号信息，再进行货物操作',
  removeGoodsTips: '请选择要移除的货物',
  NumberOfCartons: '纸箱数',
  importGoodsTips: '请选择要导入的货物',
  ChooseGoods: '选择货物',
  RemoveTheGoods: '移除订单',
  Source: '来源',
  PrintListTip: '请选择一个您要打印的单子',
  CargoActArrivalDatePacking: '实际装箱日期',
  releaseStowageState: '放行配载状态',
  ChangeHistory: '变更历史记录',
  SynchronizationInformation: '同步信息',
  SyncChargeToEas: 'EAS同步',
  NoEasCharge: '没有需要同步到EAS的费用。',
  CheckEasChargeState: '没有需要同步到EAS的费用，请检查EAS费用状态。',
  CheckBusinessUuid: '业务UUID不能为空！',
  KingDeeChargePush: '金蝶费用推送',
  ExternalSerialNumber: '单据号',
  EmptyCabinetDate: '空柜进厂时间',
  RealArrivalsDate: '实际进港时间',
  ActualLiftingDate: '实际提重时间',
  DeliveryDoneDate: '送货完成时间',
  CleaningDate: '清柜时间',
  ReturnBoxDate: '还箱时间',
  DestinationDeliveryTime: '目的港送仓时间',
  DestinationReturnTime: '目的港还空时间',
  PortDischargeTime: '实际卸船时间',
  UnloadingTime: 'Unloading time',
  LiftingTime: 'Lifting time',
  EstimatedPortDischargeTime: '予想荷卸し時間',
  RailwayDepartureTime: '実際の鉄道輸送時間',
  RailwayDischargeTime: '実際の鉄道荷卸し時間',
  EstimatedRailwayDepartureTime: '予想鉄道輸送時間',
  EstimatedRailwayDischargeTime: '予想鉄道荷卸し時間',
  EstimatedTimeOfArrivalAtThePlaceOfDelivery: '目的地到着予想時刻',
  Arrived: 'Arrived',
  Acquire: 'Acquire',
  TheActualTimeOfArrivalAtThePlaceOfDelivery: '実際の目的地到着時刻',
  EstimatedCustomsReleaseTime: '予想通関解除時間',
  EstimatedPickupTime: '予想ピックアップ時間',
  ActualPickUpTime: '実際のピックアップ時間',
  EstimatedDeliveryToWarehouseTime: '予想倉庫入り納品時間',
  EstimatedReturnTime: '予想返却時間',
  ActualReturnTime: ' 実際返却時間',
  PODDeliveryInformation: '目的港配達情報',
  ActualDeliveryToWarehouseTime: '実際の倉庫入り納品時間',
  EstimatedDeliveryToCustomersWarehouseTime: '顧客倉庫への配達予定時刻',
  ActualDeliveryToCustomersWarehouseTime: '実際の顧客倉庫への配達時間',
  PickupMessage: 'CY-DOOR、港からコンテナヤード/荷物のある倉庫への搬入',
  DeliveryToWarehouseMessage: 'ピックアップ後、目的地港の倉庫に配送された時間',
  EstimatedDeliveryToCustomersWarehouseMessage: '拼箱倉庫から顧客の倉庫（B2B）/出荷元から最後の1マイル配送（B2C）までの移動時間',
  ActualDeliveryToCustomersWarehouseMessage: '拼箱倉庫から顧客の倉庫/出荷元から最後の1マイル配送までの時間',
  CargoReadyDate: '貨物準備完了日',
  BackUpWarehouse: '予備倉庫',
  PleaseSelectBackUpWarehouse: '【予備倉庫】オプションを選択してください',
  HeavyContainerMobilization: '重箱入場',
  checkLines100: '選択された行数が100行を超えています！',
  estimatedDeliveryTime: '出庫予定時刻',
  estimatedArrivalTime: '入港予定時刻',
  EmailGroup: 'メールグループ',
  EmailTemplate: 'メールテンプレート',
  CargoAllocationList: '配船リスト',
  CheckApproved: '審査する業務を選択してください！',
  StateVerifyingReview: '審査済（再確認待ち）',
  VotesSubmission: '票を提出しますか？',
  BatchSubmitCheckOperate: '正式な操作のみを一括提出できます！',
  BatchSubmitCheckPre: '予備提出のみを一括提出できます！',
  CancelFormalHblTips: '形式分票が既に存在するため、チェックを解除する前に削除してください！',
  BatchSend: '一括送信',
  BatchSendCheck: '送信するEAS料金を選択してください',
  BatchSendTip: '審査前の料金のみ同期できます。料金処理状況を確認してください。',
  PleaseSelectRemovedContainer: '削除するコンテナ情報を選択してください！',
  PleaseRemovedSplitOrder: 'Please first remove the form of splitting associated with the current splitting order!',
  ThereAreTheFollowingExceptionsInTheImportDataPleaseCheckTheDataInTheForm: 'インポートデータに以下の例外があります。フォームでデータを確認してください。',
  NoPrimaryTicketIsAssociatedSoTheContainerDataCannotBeImported: 'プライマリチケットが関連付けられていないため、コンテナデータをインポートできません。',
  ImportContainerInformation: 'コンテナ情報をインポートしますか？',
  SecondLoadingTime: 'トランジット船積み',
  SecondDepartureTime: 'トランジット出発',
  SecondArrivalTime: 'トランジット到着',
  SecondUnloadingTime: 'トランジット荷卸し',
  TransferModeAtTransferPoint: '転送地点の転送モード',
  DispatchVehiclesAtDestination: '目的地港の配車',
  PortOfDestinationServices: '目的地港のサービス',
  Manifest: 'Manifest',
  Other: 'Other',
  Temperature: 'temperature',
  OpenVentilation: 'Open ventilation',
  VentilationQuantity: 'ventilation quantity',
  VentilationUnit: '換気量の単位',
  FlashPointUnit: 'Flashpoint単位',
  HazardForm: '危険物の形態',
  AutoSpecialGoods: '特殊貨物の箱詰め情報を自動的に取得する',
  HaveMaintainedSpecialInfo: 'あなたが特別な貨物情報を維持していることを検出して、英語の品名とHSコードに基づいて自動的に箱詰め情報を取得しますか？',
  PackingInformation: '梱包情報の取得に成功しました。',
  NoPackingInformation: '梱包情報を取得できませんでした。',
  Humidity: 'humidity%',
  OverSize: 'over size',
  ZYQHG: 'Left/right/front/back/superb(CM)',
  PortOfDestinationCustomsClearance: '目的地港の通関手続き',
  DestPortCustomsClearanceInfo: '通関情報',
  PleaseSelectData: '指定されたデータを選択してください',
  PlateNumberAndBillLadingNumberCannotEmpty: 'ナンバープレートとビル・レーディング番号を入力してください',
  LineXQuantityMustGreaterThanZero: '行{rowNum}の数量は0より大きくなければなりません',
  LineXQuantityExceedsMaxValue: '行{rowNum}の数量{quantity}は最大値{maxValue}を超えます',
  LineXWeightMustGreaterThanZero: '行{rowNum}の重量は0より大きくなければなりません',
  LineXWeightExceedsMaxValue: '行{rowNum}の重量{weight}は最大値{maxValue}を超えます',
  LineXCubageMustGreaterThanZero: '行{rowNum}の体積は0より大きくなければなりません',
  LineXCubageExceedsMaxValue: '行{rowNum}の体積{cubage}が最大値{maxValue}を超えます',
  HasExport: 'エクスポート済み',
  DelegatedAssociatedBusinessStatus: '委託関連ビジネス処理状況',
  TransactionRelatedBusinessStatus: '取引関連業務名処理状況',
  SecondarySynchronization: 'セカンダリ同期',
  NumberOfCustomsOrders: '通関手続き数',
  CustomerClosingTime: '顧客クロージングタイム',
  AddToMainTicket: '主チケットに追加しますか？',
  CustomsDeclarationRemark: '税関宣言の備考',
  OperationGuide: '操作ガイド',
  ServiceInformation: 'サービス情報',
  ScopeServices: 'サービス範囲',
  DeletionGuide: '上海港削除ガイド',
  BusinessData: '上海港ビジネスデータ',
  SecondVesselInformation: '2次船情報',
  vesselText: '港埠のコンテナデータから船名：${1}、航海：${2}が取得され、ブッキングタブの船名：${3}、航海：${4}と一致しません。提出された船名航海を書き込んで、取得した船期データをクリアしますか？',
  importEmpty: 'インポートして空にする',
  importNotEmpty: 'インポートしてからクリアしない',
  ignore: '無視する',
  empty: '空',
  salveNoDcToKeepMaster: 'この委託事業所には、該当する文書担当者が登録されていません。マスターチケット文書担当者を保持しますか？',
  CustomersCollectByBubble: 'バブルでのお客様集め',
  CollectionBySupplier: 'サプライヤによる分別収集',
  Slac: '小物品の数',
  BookingShutOut: 'ブッキングシャットアウト',
  tip: 'ヒント',
  ShippingCompanyDialogModifyText: '船会社を変更しました。既存の目的港/エリア情報をクリアしますか？船会社の貨物追跡サービスを開通している場合、予約ページの目的港/エリア情報が再度購読されます。',
  ShippingCompanyDialogDeleteText: '船会社を削除しました。既存の目的港/エリア情報をクリアしますか？',
  emptyDestinationInformation: '空にする',
  noEmptyDestinationInformation: '空にしない',
  BatchModifyBusiness: 'ビジネスを一括修正',
  DataAdjustment: 'データ調整',
  OriginalData: '元データ：',
  AfterAdjustment: '修正後のデータ：',
  inputContainerNo: 'コンテナ番号を入力してください',
  inputSealNo: 'シール番号を入力してください',
  BoxType: 'コンテナタイプ',
  BusinessPeopleType: 'ビジネス担当者',
  clearConfirm: '{1}「{0}」ビジネスデータが消去されます。よろしいですか？',
  clearCategoryConfirm: '{0}ビジネスデータが消去されます。よろしいですか？',
  changeTwoConfirm: '{1}「{0}」ビジネスデータが置換されます。よろしいですか？',
  changeOneConfirm: '{0}ビジネスデータが置換されます。よろしいですか？',
  hasRefreshCharge: 'ブッキングエージェントは既に費用が存在します、費用を更新しますか？',
  SuccessTip: '成功 {0} 件',
  successTipAlreadyNotEditCharge: '成功 {0} 件、<br/>説明: <br/> {1} は既に編集不可の費用が存在します。至急対応してください！',
  hasOneAtleast: '最低でも1つのオプションを選択してからやり直してください！',
  hasOneNoAtleast: '少なくとも1つのフィールドを入力してからやり直してください！',
  maxSelectBusiness: '選択したビジネスが{0}件を超えています。選択しなおしてください！',
  requireAllSelect: '{0}と{1}を修正してからやり直してください',
  hasOneCategoryAtleast: '書き込むデータを選択してください！',
  adjustedDestinationAgent: '調整後の仕向港代理を入力!',
  whetherCoverMBLReceiver: '選択した仕向港代理データが置換されます。MBL荷受人を新しい代理情報で上書きしますか？',
  lclSlavesJobCannotModify: '伝票はこのフィールドを修正できません。！',
  BusinessNotSameOpAndSalesOffice: 'ビジネス{0}の操作支社と販売支社が一致しません',
  SuccessfullyClearXPieces: '{0}件の{1}データを正常にクリアしました',
  PartSuccessClearXPieces: '成功：{0}件の{1}データを正常にクリア、失敗：{2}件、理由：',
  DataAdjustmentSame: '{0}の修正前と修正後のデータが同じです。何も変更されていません。',
  DataAdjustmentAgainConfirm: 'ビジネス{0}のデータが置換されます。よろしいですか？',
  SuccessfullyReplacedXPieces: '{0}件の{1}データを正常に置換しました',
  NotReplacedXPieces: '条件に合致する{0}が見つかりませんでした。0件の置換です。',
  PartSuccessReplacedXPieces: '成功：{0}件の{1}データを正常に置換、失敗：{2}件、理由：',
  BusinessisNotPositiveOperation: 'ビジネス{0}は正の操作ではありません',
  BusinessisBlocked: 'ビジネス{0}はロックされています',
  BusinessisHblLock: 'ビジネス{0} HBLは既にロックされています',
  BusinessisInvalidLoadType: 'ビジネス{0}整拼タイプは委託拼箱ではありません',
  BusinessisContainerExist: 'Business {0} already has an adjusted box type',
  BusinessPicecNotMatch: 'The business {0} is no box type corresponding to the original data',
  BusinessisMblHblContainerExist: 'Business {0} has joined MBL split/HBL split/formal split',
  BusinessisContainerSealNoExist: 'Business {0} has filled in the box seal number',
  BusinessisTruckingContainerExist: 'Service {0} has been associated with gateway information',
  BusinessisDischarginTruckingExist: 'Business {0} has been associated with destination delivery',
  BusinessisAmsContainerExist: 'Business {0} has been associated with anti-terrorism manifest',
  CopyFailedBusinessNumber: 'One-click copy failed business number',
  HLID: 'ハイパーリンクID',
  truckingPlaceDep: 'ピックアップヤード',
  truckingPlaceDest: 'ドロップオフヤード',
  PackagingCategoryOfDangerousGoods: 'Packaging category of dangerous goods',
  CargoReleaseWay: 'Cargo release way',
  WarehouseLoadingRemarks: 'Warehouse loading remarks',
  CheckStatuses: 'Check status:',
  ClearStatuses: 'Clear status:',
  SelectAtLeastOneAdjustment: 'Please select at least one adjustment content and try again!',
  ClearStateComfirm: 'The checked status of the selected business\' {0} \'will be cleared. Are you sure?',
  CheckStateComfirm: 'The checked status of the selected business\' {0} \'will be selected. Are you sure?',
  SuccessfullyCancelXPieces: 'Successfully cancelled {0} pieces of data',
  SuccessfullyCheckXPieces: 'Successfully checked {0} pieces of data',
  PartSuccessClearXThePieces: 'Successfully clear {0} pieces of data, failed {1} pieces, failure reason:',
  PartSuccessCheckXThePieces: 'Successfully check {0} pieces of data, failed {1} pieces, failure reason:',
  BusinessisCargoDocLock: 'Business {0} Locked Doc',
  DataCategoryProcessingFailed: 'Data category processing failed',
  PleaseSelectATemplate: 'Please select a template',
  PleaseSelectANode: 'Please select a node',
  PleaseSelectAState: 'Please select a state',
  SuccessModifiedXBusinessState: 'Successfully modified {0} business statuses',
  SuccessWithdraw: '{0}条を撤回しました',
  PleaseSpecificTemplateFilePreview: 'Please select a specific template file for preview !!!',
  CopyLast: 'Copy last',
  WaybillNumberCopy: 'Waybill number copy',
  CargoInformation: 'Cargo information',
  BillOfLadingQuantity: 'Bill of lading quantity',
  Packing: 'Packing',
  PleaseChoose: '--Please choose--',
  CustomerType: 'Customer type',
  HTSCode: 'HTS code',
  EnglishCommodityName: 'English commodity name',
  TransportationInformation: 'Transportation information',
  MBLNumber: 'MB/L number',
  CCNNumber: 'CCN number',
  ShipName: 'Ship name',
  ShipNumber: 'Ship number',
  PortArrivalDate: 'Port arrival date',
  CountryOfOrigin: 'Country of origin',
  BillLadingPlaceOfDispatch: 'Bill of lading place of dispatch',
  BillLadingPortOfDeparture: 'Bill of lading port of departure',
  BillLadingPortOfDischarge: 'Bill of lading port of discharge',
  BillLadingPlaceOfDelivery: 'Bill of lading place of delivery',
  LastOverseasPort: 'Last overseas port',
  HtsCode: 'HTS CODE',
  FirstPortOfCall: 'First port of call',
  SynchronizeHBLInformation: 'Synchronize HBL information',
  addHbl: '点数を増やします。',
  NonVesselCarrierSCAC: 'Non-vessel carrier SCAC',
  DeclarationAccount: 'Declaration account',
  DeclarationType: 'Declaration type',
  DirectToTheUnitedStates: 'Direct to the United States',
  ToTheInlandWarehouse: 'To the inland warehouse',
  TransferClearancePullToStates: 'Transfer in Canada without customs clearance, pull to the United States',
  CargoThroughTheUnitedStates: 'Cargo passing through the United States',
  ContainerInformation: 'Container information',
  AddContainerInformation: 'Add container information',
  RemoveContainerInformation: 'Remove container information',
  BoxSpecies: 'Box species',
  BoxHeight: 'タンク高さ',
  ContainerNumber: 'Container number',
  SealNumber: 'Seal number',
  CommodityName: 'Commodity name',
  PleaseEnterTheCommodityNameOrHSCode: '商品名またはHSコードを入力してください',
  ShippingCompanyContractNoRequired: '船会社契約番号は必須です',
  ApplicableRoutesNoRequired: '適用航路は必須です',
  ShippingCompanyNoRequired: '船会社は必須です',
  ValidityNoRequired: '有効期間は必須です',
  ShippingCompanyAndBaseDifferent: 'この契約番号の船会社は基本タブの入力情報と一致しません。上書きしますか？',
  GiveUp: '放棄',
  BackFillToRoute: 'この契約番号には複数の適用航路が登録されています。基本タブに反映する航路を選択してください。',
  MultipleApplicableRoutesDifferent: 'この契約番号には複数の適用航路が登録されており、基本タブの入力内容とすべて異なります。基本タブに反映する航路を選択してください。',
  ApplicableRoutesDifferent: 'この契約番号の適用航路はすべて基本タブの入力内容と異なります。上書きしますか？',
  ShippingCompanyDifferent: '選択した船会社は選択済み契約の適用船会社と一致しません。上書きしますか？<br/><span style=\'color:red\'>{0}</span>',
  AirlineDifferent: '選択した港の所属航路は選択済み契約の適用航路と一致しません。上書きしますか？<br/><span style=\'color:red\'>{0}</span>',
  EtdDifferentValidityPeriod: '選択したETDは契約の有効期間に準拠していません。上書きしますか？<br/><span style=\'color:red\'>{0}</span>',
  ValidityPeriodCannotCoverETD: '選択した契約の有効期間はETDをカバーできません。上書きしますか？<br/><span style=\'color:red\'>{0}</span>',
  DoNotBackFill: 'バックフィルしない',
  ValidPeriodMessage: '契約有効期間：{0}',
  ValidPeriodEtdMessage: '契約有効期間：{0}、ETD：{1}',
  NumberApplicableToShippingCompany: '契約適用船会社：{0}',
  NumberApplicableToAirline: '契約適用航路：{0}',
  PleaseToDeleteTheContract: '選択した{0}件の契約番号を削除しますか？この操作は取り消せません。',
  ScNoIsUsed: 'この予約番号は既に使用されているため、削除できません',
  BeginDateNotLessThanEndDate: '有効期間の開始日は終了日より後の日付にできません',
  ConfirmEnableTips: '有効にすると、ユーザーは注文詳細ページでこの契約番号を選択できるようになります。有効にしますか？',
  EnableTips: '選択したすべての契約番号が無効状態の場合のみ、有効化操作が可能です',
  DisEnableTips: '無効にすると、この契約番号は注文詳細で選択できなくなります。無効にしますか？',
  ConfirmDisEnableTips: '選択したすべての契約番号が有効状態の場合のみ、無効化操作が可能です',
  ContractRatePropertyRequired: '契約料金性質は必須です',
  NACRequired: 'NACは必須です',
  CommodityNameRequired: '品名は必須です',
  ContractNumberRequired: '船会社の契約番号は既に存在します',
  PleaseSelectAirLine: '航路を選択してください（複数選択可）',
  PleaseInputNumber: '数字を入力してください',
  CargoInsuranceQuantityRequired: '貨物保険数量は必須です',
  CargoInsuranceUnitRequired: '貨物保険単位は必須です',
  SendingStatus: 'Sending status',
  SendingStatusUpdateTime: '送信処理状況更新時間です',
  CancellationStatus: 'Cancellation status',
  Notifier: 'Notifier',
  SecondNotifier: 'Second notifier',
  ShippingAndReceivingInformation: 'Shipping and receiving information',
  ShipperName: '発送人名',
  CompanyTitle: '頭を上げます',
  Address: '住所',
  Phone: '電話',
  Optional: '必須でない',
  ConsigneeName: '受取人名',
  NotifierName: '通知人名',
  SecondNotifierName: '第二通知人名',
  BatchModifyDestinationPortInformation: '目的地港情報を一括修正',
  OverseasWarehouseNonAmazonWarehouse: '海外倉庫(アマゾン以外)',
  SelectedBePositivePleaseSelect: '選択されたビジネスは正の操作である必要があります。再度選択してください！',
  DomesticWarehouse: '国内の倉庫',
  OverseasWarehouse: '海外の倉庫',
  ContainerNumber2: 'コンテナ番号：',
  ContainerNumberContainerNoNull: 'コンテナ番号：containerNoNull',
  Exceeded: '超過しました',
  CancelCustomsReturn: '税関の返品をキャンセルする',
  AttachmentContentTooLarge: '添付ファイルの内容が大きすぎます',
  LockedPleaseContactSupervisorUnlock: 'ロックされています、印刷できません、上司に連絡して解除してください！',
  FCLProfitPrinting: 'フルコンテナ費用益印刷',
  LCLProfitPrinting: 'グループエージェージ費用益印刷',
  DueToPrintOrUnlock: '信用制限を超えたため、このポリシーはロックされており、印刷またはEDIできません。必要な場合は上司に連絡して解除してください。',
  FeeName: '料金名',
  BatchFeeScheme: '一括費用計画',
  NoCostCanBeTranscribed: '抄録可能なコストはありません。',
  ThisBeenSentEDIAllowed: 'この船荷証明情報はEDIで送信されました。削除することはできません。',
  TheVoidedAndCannotAgain: 'この船荷証明書は無効になり、再度無効にすることはできません。',
  ShanghaiManifestShippingCompany: '上海マニフェスト 船会社：',
  NoResultsFound: '結果が見つかりませんでした',
  ExportClearanceNewRegulation: '輸出クリアランス新規則',
  ShanghaiAfterClearanceManifestContinuing: '上海海関172号令がクリアランス条件を切り替えたため、「積載マニフェスト」の受領証をもとにコンテナ貨物放出情報を港湾に伝達します。顧客が申告を完了した後、自分で積載マニフェストの状態を確認してください。余分なマニフェストが削除されずに残されている場合、配載の遅延、装置後に追加されたもの、船荷証明書データの修正など、2年以内に提出されたものはすべて船の装置に影響を与えます。次に、良好なレセプトを受け取ったら、予定フリートが変更、削除、または新しいマニフェスト追加が必要な場合、前もってコンテナエージェントに連絡して「積載マニフェスト」を削除してから操作を続行する必要があります。',
  YangshanDistrictNovember152021: '洋山グアン区：2021年11月15日',
  WaigaoqiaoDistrictNovember222021: '外港グアン区：2021年11月22日',
  GarbageManifest: 'ごみマニフェスト',
  N1YourGoodsAreManifest: '1.ゴミマニフェストは税関によって禁止されています！税関規則に従い、各出荷ごとに空のマニフェストを送信することはできません。貨物が輸送されなかった場合（船に間に合わなかった、出荷計画が変更されたなど）、マニフェストは無効とみなされます。',
  N2StowManifestMustSent: '2.ゴミマニフェストの例：船が変更された場合、古い予定マニフェストを削除し、新しいマニフェストを送信する前に必ず削除してください。',
  N3OnTheFreightManifest: '3. ゴミマニフェストを削除しなかった場合の結果：船舶の搭載に影響するだけでなく、最高で50000元の罰金が科され、通関資格が失われることもあります。ゴミマニフェストが発生した場合は、すぐにカスタマーサポートに連絡し、削除を依頼してください。',
  BusinessNotSelected: 'ビジネスが選択されていません。',
  DoNotImportAndSend: 'インポートしても自動的に送信されません。',
  ViewReceipt: '領収書を表示',
  ImportEXCEL: 'Excelからインポート',
  Receipt: '領収書',
  ReceiptNumber: '領収書番号',
  Time: '時間',
  PleaseSelectAccount: 'アカウントを選択してください',
  AfrEfreightDgTip: '危険物はダイレクト便でのお取り扱いができません。間接便モードに切り替えてください。また、一飛で危険物情報を追加登録してください。',
  CustomerNumberCannotBeEmpty: '【顧客情報】AMS分割番号は必須です。',
  CustomerNOCannotBeEmpty: '【顧客情報】MB/L NOは必須です。',
  CustomerPortCannotBeEmpty: '【顧客情報】卸港は必須です。',
  CustomerDeliveryCannotBeEmpty: '【顧客情報】納品先は必須です。',
  AMSNumber: 'AMS番号',
  ACINumber: 'ACI番号',
  EManifestNumber: 'eManifest番号',
  SendSucceeded: '送信に成功しました。',
  NotSent: '送信されていません。',
  ServiceChannel: 'サービスチャネル',
  ExpectedAmazonWarehouseEntryTime: '予定されたAmazon倉庫入荷時間',
  DestinationDeliveryMethod: '目的地配送方法',
  CourierCompany: '宅配業者',
  TrackingNumber: '追跡番号',
  POoriginalNumber: 'PO（元の注文番号）',
  CustomsDeclarationMethod: '報関方式',
  CustomsClearanceMethod: '通関方式',
  EORIEnterpriseNumber: 'EORI企業番号',
  VATTaxNumber: 'VAT/税番号',
  VATRegistrationCountry: 'VAT登録国',
  VATRegistrationAddress: 'VAT登録住所',
  VATCompanyEnglishName: 'VAT会社英語名',
  WithPower: '電気付き',
  WithMagnet: '磁力付き',
  Powder: 'パウダー',
  Liquid: '液体',
  EstimatedWarehouseEntrygoodArrivalTime: '入庫/貨物到着予定時間',
  RemoteWarehouse: '遠隔地倉庫',
  OceanFreight: '海上輸送費',
  ServiceChannel2: 'サービスチャネル：',
  FeeType: '費用タイプ：',
  EstimatedAmount: '見積り金額：',
  Equivalent: '同等',
  FreightRateLevel: '運賃レベル：',
  BillingWeight: '課金重量：',
  CalculationMethod: '計算方法：',
  EstimatedTimeCannotBeEmpty: '入庫/貨物到着予定時間を入力してください。',
  DestinationCannotBeEmpty: '目的地を入力してください。',
  DestinationCountryCannotBeEmpty: '目的地の国を入力してください。',
  ZipCodeCannotBeEmpty: '郵便番号を入力してください。',
  CannotBeEmpty: '必須です。',
  PleaseTheConsignorUnitFirst: '委託元の単位を選択してください。',
  DearAndThenCarryOperation: '保存後、自動配車操作を行ってください。',
  ClearanceMethod: '通関方式',
  EstimatedStorageReadyGoodsTime: '入庫/貨物到着予定時間',
  ForeignWarehouse: '海外倉庫',
  WithElectricity: '電気付き',
  WithMagnetism: '磁力付き',
  YourPieceWeightAndTo: 'お客様の商品はデータ比較に参加しました。自動的にパッキングされると、この票とマスタービルに関する件数、重量、体積情報が更新されます。',
  Prompt: 'プロンプト',
  GotIt: '了解',
  DocumentNumber: '証明書番号',
  Origin: '原産地',
  AreaCode: 'エリアコード',
  BoxAndCargoInformationFunction: '箱と商品情報が不一致のため、情報が正しいかどうか確認してください。箱と商品情報を一致させるために、基本ページで修正するか、データ比較機能で箱と商品情報を一致させてください。',
  InconsistencyBetweenPortAreaDataAndPackingInformationTips: '注意：港区のデータと梱包情報が一致しない場合、プッシュしないアラートアラーム、SOP設定に関するアラームが発生する可能性がある',
  TheComparisonFunctionToPossible: '最新の港区箱物情報を入手しました。できるだけ早く【港区データの更新】を使用して、ご希望の箱物データを選択してください',
  DetectionOfBasicTab: '基本タブが検出されました。',
  InconsistentThePortAreaReturn: '港のエリアから返されたものと',
  PleaseTheOperationIsCorrect: '不一致',
  BoxNum: '個の箱',
  YouBoxAndCargoTab: 'すぐに【箱詰め情報】をご覧ください。',
  GoCheck: '確認する。',
  BoxQuantity: '箱量',
  BoxModel: 'コンテナ型',
  CutOffDate: 'カットオフ日',
  PortOpeningTime: '開港時間',
  PortOpeningDate: '開港日',
  ScheduledBerthingTime: '計画着岸時間',
  ScheduledDepartureTime: '計画出港時間',
  ActualUnloadingTime: '実際の荷卸し時間',
  ActualHeavyLiftingTime: '実際の重量の提供時間',
  ActualEmptyReturnTime: '実際の空返却時間',
  PleasePackingInformationToRemoved: '削除するパッキング情報を選択してください！',
  BillOfLadingType: 'ブール・オブ・レーディングのタイプ',
  ArrivalDate: '到着日',
  ShippingType: '出荷タイプ',
  DischargingPort: '揚げ港',
  DeliveryPlace: '配達場所',
  CustomerShippingInformation: '顧客の出荷情報',
  CargoReceiver: '貨物受取人',
  Buyer: '買い手',
  Modify: '変更',
  PleaseSelectABox: 'ボックスを1つ選択してください',
  ReleaseOrderNumber: 'リリース注文番号：',
  ExportReleaseNewRegulation: '輸出リリース新規則',
  WechatPrompt: '設定とツール-個人情報にアクセスする必要があるユーザーごとに、微信メッセージのプッシュ許可をオンにし、公衆番号に注目してください。',
  YangshanAreaNovember152021: '洋山地区：2021年11月15日',
  WaigaoqiaoAreaNovember222021: '外高橋地区：2021年11月22日',
  GarbageCargoManifest: 'ゴミ船荷証明書',
  N1ActuallyShippedIfGarbage: '1. ゴミ船荷証明書は海関によって厳禁されています。海関の規定によると、各予約荷証明書は、実際の出荷貨物に対応する必要があります。船荷証明書を送信した後、貨物が出荷されない場合（船に間に合わない、出荷計画が変更されたなどの理由で）、その船荷証明書はゴミ船荷証明書と見なされます！',
  N2ManifestMustBeDeletion: '2. ゴミ船荷証明書の例：船舶配分後、元の予約荷証明書を削除し、新しい予約荷証明書を送信する前に、元の予約荷証明書を削除する必要があります！',
  N3YuanOnTheManifest: '3. ゴミ船荷証明書が削除されなかった場合の結果：荷役に影響を与えるだけでなく、海関は最高で貨物代理店に50000元の罰金を科し、申告資格を取り消すことができます！ゴミ船荷証明書が発生した場合は、お客様サポートに連絡して、ゴミ船荷証明書を削除するようにお願いします。',
  DetailsOfSeaExportGoods: '海上輸出品の詳細',
  PleaseSelectTheSpecifiedData: '指定されたデータを選択してください',
  LicenseOfLadingNumberEmpty: 'ライセンス番号とブール・オブ・レーディング番号は空白にできません',
  NoRelevantInformation: '関連情報はありません',
  EstimatedDeliveryTime: '予想配達時間',
  ActualDeliveryTime: '実際の配達時間',
  ObtainedContainerAndGoodsData: 'The ship name and voyage you entered',
  Sailing: '航海：',
  WithBookingTab: 'Ship name and voyage obtained from the port area',
  InconsistentFromTheBillData: '異なっています。提出された船名、航海日程を入力して、既に取得した船期データをクリアしますか？',
  InconsistentFromTheBillDataTips: 'Attention: If the ship name and voyage are incorrect, it may result in obtaining the corresponding incorrect ship schedule time (planned departure and berthing time, departure and interception time, actual departure and berthing time)',
  TheTicketIsNotImport: 'このチケットのMBL対応状況は開始されていないため、インポートできません。',
  Correction: '訂正',
  ThisItIs1Again: 'このジョブ{0}はEDI予約をすでに送信しました。<br>今回の送信は{1}-{2}です。<br>再度送信する必要があるかどうか確認してください。',
  PleaseOnePieceOfData: 'データを1つ選択してください！',
  BatchImport: 'バッチインポート',
  GoodsInformationImport: '貨物情報のインポート',
  SeaFreight: '海上運賃',
  AirFreight: '航空運賃',
  Freight: '運賃',
  BatchCostScheme: 'バッチ費用プラン',
  Shanghai: '上海',
  Qingdao: '青島',
  SeaguardianSupportsSM2WeighingMethod: 'シーガーディアンはSM2重量方式のみをサポートしています。',
  ContainerNumberSealNumber: 'コンテナ番号-シール番号',
  DueCannotBePrintedNeeded: '信用制限を超えたため、このチケットはロックされました。印刷またはEDIを行うことはできません。必要な場合は上司に連絡してロックを解除してください！',
  LockedContactTheSuperiorUnlock: 'ロックされました。印刷できません。上司に連絡してロックを解除してください！',
  ModificationSuccessful: '変更が成功しました',
  StatusConversionSuccessful: '処理状況の変換に成功しました。',
  NoDeclarationFormCreated: '申告書が作成されていません',
  Cleared: 'クリアされました',
  Uncleared: '未処理',
  SentOut: '送信済み',
  TakenOver: '引き受け済み',
  Filed: 'ファイル済み',
  TaxRefunded: '税金が返還されました',
  ReturnedbyOurCompany: '当社によって返却されました',
  ReturnedtoTheCustomer: 'お客様に返却されました',
  WithdrawalOfDocumentStatus: '書類状態の撤回',
  DocumentStatus: '書類状態',
  SendOut: '送信',
  Archive: 'まとめ',
  RefundTax: '税金取り戻し',
  RetrieveourCompany: '取回(我司)',
  Returncustomer: '退还(客户)',
  StateNotSelected: '状態が選択されていません。',
  DateNotSelected: '日付が選択されていません。',
  WithdrawalSuccessful: '撤回に成功しました。',
  NoDataSelected: 'データが選択されていません。',
  PleaseANewDeclarationForm: '新しい申告書を作成してください。',
  NoDataModified: 'データは変更されていません',
  SavedSuccessfully: '保存成功',
  BatchIsInconsistentPleaseSelect: 'バッチ印刷の状態が一致していません。再度選択してください。',
  NoDataAvailableForPrinting: '印刷可能なデータがありません。',
  Document: '関連書類',
  Date: '日付',
  NoFilesAvailable: 'ファイルがありません',
  Takeover: '引き受け',
  Retrieve: '取り戻',
  FileNotSelected: 'ファイル未選択。',
  NoTemplateFound: '見つかりませんでした',
  ForTheCorrespondingPrint: '印刷用フォマード',
  BookingAPI: '業務API',
  BillOfLadingAPI: 'B/L API',
  PleaseTheBusinessToSend: '送信する項目選択',
  ContainerQuantity: 'Container Num',
  BookingEdiSendingChannel: 'Booking EDI channel',
  BookingEdiSendingTime: 'Booking EDI time',
  EdiStateQuery: 'EDI状態クエリ',
  JiLianStar: 'Ji lian new',
  FullyStored: 'Fully stored',
  CancelFullWarehousing: 'Cancel full warehousing',
  StoredTipOne: 'There are a total of {1} warehouse receipts with business number {0}',
  StoredTipTwo: 'Confirm that the operation is {0}?',
  StoredTipThree: 'Please select data with inbound status [{0}]',
  StoredTipFour: 'The warehouse receipt for this transaction has been fully stocked in!',
  SelectedRightData: 'Please select data that meets the criteria',
  EmptyContainerNotificationTime: 'Empty Container Notification Time',
  WaitBookingVerifyBatch: 'In the batch review, please wait, you will be reminded after the review is successful.',
  BookingVerifyBatch: 'Batch audit business cannot exceed 500!',
  Roles: 'Roles',
  ZipForCountry: 'US,CA required',
  PleaseZipForSend: 'Please select Zip to Send!',
  BL_EDI_SendChannel: 'Bill of Lading EDI sending channel',
  BL_EDI_SendTime: 'Bill of Lading EDI sending time',
  VGM_EDI_SendChannel: 'VGM EDI transmit channel',
  VGM_EDI_EDISendTime: 'VGM EDI send time',
  CleanManifest_EDI_SendChannel: 'Clean the manifest EDI sending channel',
  CleanManifest_EDI_SendTime: 'Clean manifest EDI sending time',
  Way99_EDI_SendChannel: '99-way EDI transmission channel for packing slips',
  Way99_EDI_SendTime: '99-way packing slip EDI sending time',
  AMS_EDI_SendChannel: 'AMS EDI transmit channel',
  AFR_EDI_SendChannel: 'AFR-EDI伝送チャネル',
  ACI_EDI_SendChannel: 'ACI-ED伝送路（CW）',
  ACI_EDI_SendTime: 'ACI-エディ送信時間（CW）',
  AMS_JS_STATE: 'AMS送信状態',
  ACI_JS_STATE: 'ACI送信状態',
  AFR_JS_STATE: 'AFR送信状態',
  AMS_EDI_SendTime: 'AMS EDI send time',
  AHR_EDI_SendTime: 'AHR EDI send time',
  ENS_EDI_SendTime: 'ENS送信時間',
  PreShippingBill_EDI_SendChannel: 'Provision the manifest EDI sending channel',
  PreShippingBill_EDI_SendTime: 'Provision manifest EDI delivery time',
  OverseaAgent_EDI_SendChannel: 'Overseas agent EDI sending channel',
  OverseaAgent_EDI_SendTime: 'Overseas agent EDI sending time',
  PortOfHubSecond: 'Port Of Hub Second',
  PortOfHubThird: 'Port Of Hub Third',
  ProvisioningStatus: 'プロビジョニング・処理状況',
  ArrivalInformation: 'Arrival Information',
  QuantityConsign: '件数（委）',
  QuantityActual: '件数（実績）',
  WeightConsign: 'もうじゅうりょう',
  WeightActual: 'もうじゅうりょう',
  CubageConsign: 'たいせき',
  CubageActual: 'たいせき',
  VolumetricWeightConsign: 'ざいせき',
  VolumetricWeightActual: 'ざいせき',
  ChargeWeightConsign: '課金重量（委）',
  ChargeWeightActual: '実費重量（チャージ）',
  CategoryOfGoodsName: ' 貨物大分類名',
  ShipperLine2: '発送人2行目',
  ConsigneeLine2: '受取人の2行目',
  NotifyPartyLine2: '通知先の2行目',
  ShipperLine3: '発送人3行目',
  ConsigneeLine3: '受取人の3行目',
  NotifyPartyLine3: '通知先の3行目',
  ShipperLine4: '発送人4行目',
  ConsigneeLine4: '受取人の4行目',
  NotifyPartyLine4: '通知先の4行目',
  ShipperLine5: '発送人5行目',
  ConsigneeLine5: '受取人の5行目',
  NotifyPartyLine5: '通知先の5行目',
  ShipperLine6: '発送人6行目',
  ConsigneeLine6: '受取人の6行目',
  NotifyPartyLine6: '通知先の6行目',
  ShipperLine7: '発送人7行目',
  ConsigneeLine7: '受取人の7行目',
  NotifyPartyLine7: '通知先の7行目',
  OperationLog: '操作ログ',
  DimensionLength: '寸法CM（長さ）',
  DimensionWidth: '寸法CM（幅）',
  DimensionHeight: '寸法CM（高さ）',
  SystemAdd: 'Platform Add',
  FreeContainerEndTime: 'Free Container End Time',
  FreeStorageEndTime: 'Free Storage End Time',
  QuantityConsign2: '件数（依頼）',
  QuantityBooking: '件数（船腹予約）',
  QuantityActual2: '件数（実績）',
  QuantityDocumentation: '件数（請求書）',
  WeightConsign2: '毛重KGS（依頼）',
  WeightBooking: '毛重KGS（船室予約）',
  WeightActual2: '毛重KGS（実績）',
  WeightDocumentation: '毛重KGS（請求書）',
  CubageConsign2: 'ボリュームCBM（依頼）',
  CubageBooking: 'ボリュームCBM（船腹予約）',
  CubageActual2: 'ボリュームCBM（実績）',
  CubageDocumentation: 'ボリュームCBM（請求書）',
  ChargeWeightConsign2: '請求重量M/T（依頼）',
  ChargeWeightBooking: '請求重量M/T（船腹予約）',
  ChargeWeightActual2: '請求重量M/T（実績）',
  ChargeWeightDocumentation: '請求重量M/T（請求書）',
  DensityConsign: '密度kg/m³（依頼）',
  DensityBooking: '密度kg/m³（船腹予約）',
  DensityActual: '密度kg/m³（実績）',
  DensityDocumentation: '密度kg/m³（請求書）',
  ConsignationCompany2: '委託先/実績通知者',
  ConsignationCompanyHeader2: '委託先の台頭/実際の通知人の台頭',
  WarehouseSupplier2: '倉庫仕入先/倉庫',
  ShipperDetail: '出荷元詳細',
  ConsigneeDetail: '受取人詳細',
  NotifyDetail: '通知者詳細',
  MasterBillNo2: 'MBL番号/MBL',
  SynchroniseBooking: 'Synchronise Booking',
  HBLNoRepeat: 'Duplicate HB/L NO duplicate exists, order number: "{0}"',
  ConfirmSynchronizeHBL: 'When using Synchronize HBL, it will be cleared and the entered information will be manually added. Do you want to continue?',
  GetFiles: 'Get Files',
  UploadCustomerFiles: 'Upload Customer Files',
  CustomerSelfIssuedFiles: 'Customer Self Issued Files',
  CheckTheBLLog: 'Check The BL Log',
  Surrendered: 'Surrendered',
  InterfaceName: 'Interface Name',
  DataFlowDirection: 'Data Flow Direction',
  CheckTheBLCenterApiLog: 'Check The BL Center Api Log',
  PleaseMaintainTheCorresponding: 'Please maintain the corresponding {0}',
  PleaseMaintainThePhoneNumberOfTheCorrespondingPersonnel: 'Please maintain the phone number of the corresponding personnel',
  XhqCsrMsg: 'XinHaoQi Customer Service Message',
  copyLink: 'Copy Link',
  openLink: 'Open Link',
  BillNotCfm: 'The bill of lading has not been confirmed, please confirm first',
  ATDIsNull: 'Not yet departing, please release the order electronically after departure.',
  BillNotRelease: 'The bill of lading release status is not releasable',
  CfmBillFirst: 'Not yet available, please click on Confirm Bill first',
  IsReleased: 'The order has been released and cannot be operated here before uploading the customer manuscript',
  IsReleased2: 'The order has been released, no need to repeat the operation',
  UnStartOrUnConfirmCanUpload: 'ファイルをアップロードできるのは、船荷証券の「開始していない」または「未確認」処理状況のときです',
  LinkIsNull: 'Link is null',
  OnlySurrenderedSupport: 'Only the "SURRENDERED" bill of lading method supports electronic release of documents',
  SynchronizePackingInfo: 'Synchronize and update packing information',
  ManifestNotConfirmed: 'Manifest not confirmed!',
  AreYouSureSynchronizePackingInfo: 'Are you sure you want to update the packing information synchronously?',
  NoDataSynced: 'データが同期されていません。箱型箱種を確認してください~',
  VirtualBillType: 'Virtual bill of lading type',
  DestinationPortAgentIsNotEqualToDesignatedFreightAgent: 'Destination port agent is not equal to designated freight agent',
  MultipleCustomsDeclarationInaccurate: 'There are multiple customs declaration commissions, and the data may be inaccurate. Please contact the customs broker offline to obtain detailed data.',
  OnlySupportOneCustomsDeclaration: 'This function is only applicable to creating one customs declaration commission scenario.',
  OnlySupportOneCustomsCommission: '申告依頼を1つ選び、原稿の検証を依頼してください.',
  hblRefNo: 'hbl SplitOrder Ref',
  HBLRefNo2: 'HBL Ref No. ',
  BatchPushCharges: 'Batch Push Charges(Consignation)',
  ChargeConfirmed: 'Charge Confirmed',
  ViewReception: 'View Reception',
  ViewSending: 'View Sending',
  branchTransactions: 'branch Transactions',
  OurJobNo: 'Our Job No',
  TheirJobNo: 'Their Job No',
  firstSendTime: 'First Send Time',
  ConfirmReceiveTheseCharges: 'Confirm Receive These Charges?',
  AuditOperator: 'Audit Operator',
  Dimensions: '寸法(L*W*H、単位:M)',
  DoorRemarks: 'その他',
  BillOfLadingDesignatedFreightAgentFeedback: 'Bill-Lading Designated Freight Agent Feedback',
  ChangeValue: 'Change Value',
  AcceptChange: 'Accept Change',
  Rejected: 'Rejected',
  AgentFeedbackRemarks1: 'The online modification suggestions of the designated freight forwarder have been accepted',
  AgentFeedbackRemarks2: 'The online modification suggestions of the designated freight forwarder have been rejected,',
  AgentFeedbackRemarks3: 'Please confirm the final modifications with the shipper and designated freight agent offline',
  AgentEmailSend: 'Agent Bill Confirm Email Send',
  ETAFirstPortOfCall: 'ETA First Port Of Call',
  ETAFirstPortOfCallNotNull: 'In on board mode, "ETA First Port of Call" cannot be empty',
  DocumentOffice: 'Document Office',
  CustomerOffice: 'Customer Office',
  PleaseReferToTheEmailForSpecificErrorInformation: 'Please refer to the email for specific error information',
  AMSDeleteTips: 'The AMS No has not been successfully sent in the system and cannot be deleted',
  MultipleMode: 'Multiple single mode',
  NumberExchange: 'Number exchange',
  ReturnMode: 'Return to single order mode',
  OcrTip: '*Tip: Additional recording fields can be set in "Basic Configuration - Document Recognition Settings".',
  OcrOtherInfo: 'Other recording information:',
  DocumentRecognitionSettings: 'Document recognition settings',
  SeOcr: 'Identification of ocean export consignment notes',
  ocrOtherField: 'Please select additional record fields',
  ocrTextMapper: 'Recognizing Text Mapping',
  IdentifyingText: 'Identifying text',
  mappedValue: 'mapped value',
  addMapper: 'add Mapper',
  editMapper: 'edit Mapper',
  supplierCharge: 'Supplier charge',
  supplierOrderNo: 'Supplier OrderNo',
  supplierName: 'Supplier Name',
  supplierMatchName: 'Supplier Match Name',
  chargeItemLocal: 'Local Charge Name',
  refMsg1: 'Reference Information(one)',
  refMsg2: 'Reference Information(two)',
  supportNo: 'support No',
  pushTime: 'push Time',
  confirmCharge: 'confirm Charge',
  selectBeConfirmedCharge: 'Please select the charge to be confirmed',
  RefreshSuccessfulRows: 'Refresh successful {0} rows',
  SupplierFeesToBeProcessed: ' supplier fees to be processed',
  ReceivingBranch: 'Receiving branch',
  ReceivingMatchBranch: 'Receiving Branch Match Name',
  PleaseRefreshThePage: 'Unable to find mapping code, please maintain the mapping. If maintained, please refresh the page',
  BusinessDateIsNull: 'The business date corresponding to the business is empty',
  NoMatchJob: 'No match job,please refresh',
  ReleaseGoodsJY: 'Release Goods JY',
  ReleaseJY: 'Release JY',
  TakeContainerJY: 'Take Container JY',
  ContainerPreloadJY: 'Container Preload JY',
  CancelContainerPreloadJY: 'Cancel Container Preload JY',
  ReleaseGoodsPhotos: 'Release Goods Photos',
  ReleaseGoodsStatus: 'Release Goods Status',
  NoticeTime: 'Notice Time',
  ReleaseGoods: 'Release Goods',
  warehouseNoNotNull: 'Warehouse No Can Not Be Null',
  warehouseNotNull: 'The warehouse name Can Not be empty. Please select the warehouse or warehouse supplier in the basic tab',
  consignerNotNull: 'The consigner Can Not be Null',
  ReleaseRemarks: 'Release Remarks',
  RequestDate: 'Require Date',
  TakeContRemarks: 'Take Container Remarks',
  ConfirmSendPackingInstructions: 'Are you sure you want to send the packing instructions?',
  AlreadySentReleaseGoods: 'The release goods have been sent, please do not repeat the operation',
  PleaseSelectWarehouseNo: 'Please select the warehouse number',
  TheWarehouseNoHasBeenReleased: 'Has the warehouse entry number been sent before, is it still being sent?',
  ViewReleaseGoodsPhotos: 'View Release Goods Photos',
  JyWarehouseInterfaceLog: 'JY Warehouse Interface Log',
  JyWarehouseApiLog: 'Jy Warehouse Api Log',
  LclDynamic: 'Lcl Dynamic',
  TakeContainerNotice: 'Take Container Notice',
  TakeContainerDone: 'Take Container Done',
  PreloadContainerOrder: 'Preload Container Order',
  PreloadContainerDone: 'Preload Container Done',
  SendPort: 'Send Port',
  SendPortStart: 'Send Port Start',
  ArrivalPort: 'Arrival Port(Warehouse Notice)',
  ExistEmptyContainer: 'Exist Empty Container',
  docLink: 'Doc Link',
  Field: 'フィールド',
  ErrorDescription: 'エラーの説明',
  VerificationPrompt: '検証のヒント',
  InformationSavingOnly: '情報のみ保存',
  Required: '必須',
  InputTwoAbove: '2名以上入力してください',
  SendError: '送信に失敗しました',
  CounterTerrorismManifestConfiguration: '対テロ船荷証券の配置',
  AfrAccount: 'AFRアカウント',
  AfrPassword: 'AFRパスワード',
  ApplicantEORI: '申告者EORI',
  AccountIsNotNull: '送信するアカウントを選択してください',
  PasswordIsNotNull: '送信されたパスワードを維持してください',
  Notification: 'に知らせる',
  Error: 'エラーメッセージ',
  NoSendingRecord: '送信レコードが一時的にありません',
  GetExceptions: '例外の取得',
  WaitingReceipt: '同じ船名航路が存在します同じNvocc SCACは税関領収書を取得していません、発送できません、お待ちください',
  NotOperable: '返信が取得されていない、または送信に成功していない、元の送信、訂正、削除できないものがあります',
  AmsVgm: '船荷証券/VGM',
  AmsReceipt: 'AMS領収書',
  AciReceipt: 'ACI受領書',
  AfrReceipt: 'AFR領収書',
  VgmReceipt: 'VGM領収書',
  EnsReceipt: 'ENS領収書',
  ManifestReceipt: 'プロビジョニング船荷証券受領書',
  UserDefinedRole1: 'カスタムポジション1',
  UserDefinedRole2: 'カスタムポジション2',
  AmsReceiptRemind: '対テロ船荷証券受領通知',
  DangerousCargoCode: '貨物種別-危険物',
  CustomerToOrder: 'Customer to order',
  DesignatedGoodsToBillOfLading: 'Designated goods to bill of lading',
  OverwriteOriginalRemark: '上書き原【遠隔予約船的備考】',
  DownloadPortServiceScope: 'Download Port Service Scope',
  AllowSaleProduct: 'Allow Sale Product',
  FullOrInside: 'Full Or Inside',
  Commissioned: 'Commissioned',
  weightVolumeBillWeightConsolidated: 'Weight/volume/chargeable weight including consolidation',
  weightVolumeBillWeightConsolidatedTip: 'The selected business has merged orders, and the weight/volume/billing weight of the merged orders will be calculated. The default statistics are based on the weight/volume/billing weight of the basic tab.',
  AttentionForSynchronizedContainer: '注意：箱番号を記入すると、今回の設定は有効になります。記入していなければ、有効ではありません。',
  BatchFillGpExplain: '一括記入GP説明です',
  AiDocRecognition: 'AI一発認証です',
  AiRecognition: 'AI認識です',
  SupportMultipleFiles: '貨物代理船荷証券、船荷証券確認書、託書など様々な書類の識別をサポートします!',
  DragOrClick: 'ファイルをここまでドラッグします。または',
  ClickUpload: 'クリックしてアップロード',
  FileSizeLimit: 'アップロードできるファイルは1回につき4MBまでです',
  InvalidFileType: 'ファイルタイプが正しくありません',
  FileTooLarge: 'ファイルサイズは4MBを超えることはできません',
  Reupload: '再アップロード',
  StartRecognition: '認識開始',
  RecognitionInProgress: '識別中です…ちょっと待ってください,約30秒かかります',
  RecognitionTextTip: '内容を直接コピペしてから認識ボタンをクリックしてください。自働的に認識され、該当フィールドに記載されます。',
  EstimatedTime: '予想時間：{time}',
  RecognitionSuccess: '認識成功',
  RecognitionFailed: '認識失敗',
  AiRecognitionWarn: 'AI認識に誤差がある場合がありますので、発送前によく確認してください',
  SupportsShanghaiPortShipAgent: '上海港の対応する船代の閲覧のみをサポート',
  ServiceNotActivated: 'このサービスを利用していません',
  updateOrderContent: '註文内容を更新します',
  CheckCustomsBrokerComfirm: '【通関明細】を選択し、対応する業務の【通関明細】フィールドを一括更新しました。確認しますか？',
  CheckCustomsBrokerComfirm2: '【通関サービス】を選択しましたが、【通関明細】を選択せず、一括消去業務の【通関明細】フィールドを確認しますか？',
  ClearCustomsBrokerComfirm: 'パージ業務ローカルサービス【通関】をチェックし、選択した業務の【通関明細】フィールドを一括してクリアしました。確認しますか？',
  EdiEuBolInfo: '欧州航路運送状補足情報',
  EuroLineENSDeclaration: '欧州航路ENS申告識別子',
  SelectEuroLineENSDeclaration: '「欧州航路ENS申告識別子」を選択してください',
  ManifestType: 'マニフェストタイプ',
  SelectManifestType: 'マニフェストタイプを選択してください',
  SupplementaryDeclarant: '補足申告者',
  ChemicalIdentifier: '化学物質識別子',
  ChemicalProduct: '化学製品',
  NonChemicalProduct: '非化学製品',
  ChemicalCUSCODE: '化学製品CUSコード',
  PostalInformation: '郵便情報',
  PostalInformation2: '郵便情報<br>(街の名前または番号のいずれかを選択)',
  EORICode: 'EORIコード',
  ShipperStreetNumber: '発送者の街の番号',
  ShipperStreetName: '発送者の街の名前',
  ActualShipperStreetNumber: '実際の発送者の街の番号',
  ActualShipperStreetName: '実際の発送者の街の名前',
  ShipperZipCode: '発送者の郵便番号',
  ShipperAddress: '発送者の住所',
  ConsigneeStreetNumber: '受取人の街の番号',
  ConsigneeStreetName: '受取人の街の名前',
  ActualConsigneeStreetNumber: '実際の受取人の街の番号',
  ActualConsigneeStreetName: '実際の受取人の街の名前',
  ConsigneeZipCode: '受取人の郵便番号',
  ConsigneeAddress: '受取人の住所',
  NotifyStreetNumber: '通知先の街の番号',
  NotifyStreetName: '通知先の街の名前',
  NotifyZipCode: '通知先の郵便番号',
  ActualShipper: '実際の発送者',
  ActualShipperName: '実際の発送者の名前',
  ActualConsignee: '実際の受取人',
  ActualConsigneeName: '実際の受取人の名前',
  ByBillingDate: 'By Billing Date',
  ByBusinessDate: 'By Business Date',
  CostRateValue: 'Cost Exchange rate value',
  CopyBusiness: 'ビジネスのコピー',
  CopyActualShipper: '実際の発送者のコピー',
  CopyActualConsignee: '実際の受取人のコピー',
  SelectEORICode: '{0}欄のEORIコード情報を入力してください',
  TOOrderRequired: 'TO Orderが必要です',
  EORICodeExample: 'コードタイプ+コード番号',
  PlsInputParameter: '{0}を入力してください',
  PlsSelectUnLCL: 'Please select a business with a containerLoadType of non LCL container',
  StreetInfo: '市街番号、市街名または郵便情報',
  ImportingLater: 'Importing, please proceed later',
  BusinessSeq: '業務番号',
  Yard: 'フィールドステーション',
  PleaseSelectCarrier: '請求番号に対応する輸送業者を選択してください',
  ModifyStatus: '処理状況の変更',
  ModifyManifestStatusTip: '船荷証券を発送した関数番号の修正状態のみをサポートする',
  AllSoNos: 'All SoNos',
  PlsSelectSoNo: '変更する関数番号を選択してください',
  FclOrderType: 'FCL受注明細',
  LclOrderType: 'BC Order Details',
  ConsoleOrderType: 'Non inbound order details',
  CopyBusinessSendConsigneeNotify: 'Copy business sending and receiving communication',
  DeclarationInformation: 'Declaration information',
  RelatedInformation: '関連者情報です',
  SubstratumDeclarant: '下層届出人',
  PortInformation: '港湾情報です',
  BuyerName: "Buyer's name",
  BuyerAddress: "Buyer's address",
  BuyerEORICode: 'Buyer EORI code',
  BuyerPostalCode: "Buyer's postal code",
  BuyerCountry: "Buyer's country",
  BuyerCity: "Buyer's City",
  SellerName: "Seller's name",
  SellerAddress: "Seller's address",
  SellerEORICode: 'Seller EORI Code',
  SellerPostalCode: "Seller's postal code",
  SellerCountry: "Seller's country",
  SellerCity: "Seller's City",
  UCRNO: 'UCR NO',
  ShipperEORI: 'Shipper EORI',
  ConsigneeEORI: 'Consignee EORI',
  NotifyEORI: 'Notify EORI',
  FactoryEORI: 'Factory EORI',
  WarehouseEORI: 'Warehouse EORI',
  LCLPersonEORI: 'LCL person EORI',
  ActualShipperCountry: 'Shipper country',
  ActualShipperCity: 'Shipper city',
  ActualRecipientCountry: 'Recipient country',
  ActualRecipientCity: 'Recipient city',
  NotifyPhone: "Notify person's phone number",
  NotificationCountry: 'Notification country',
  NotifyPersonCity: 'Notify person city',
  BuyerStreetNumber: "Buyer's street number",
  BuyerStreetName: "Buyer's street name",
  SellerStreetNumber: "Seller's street number",
  SellerStreetName: "Seller's street name",
  CopyActualRecipient: 'Copy the actual recipient',
  CopyActualShip: 'Copy the actual shipper',
  LinkSendAmsError: '送信中は再送信できません',
  DangerousCode: '危険物コード',
  PleaseEnterHeader: 'ヘッダーを入力してください',
  PleaseEnterAddress: '住所1を入力してください',
  PleaseEnterAddress2: '住所2を入力してください',
  PleaseSelectCountry: '国を選択してください',
  PhoneFormat: '数字のみ入力可能',
  PleaseEnterState: '州／県を入力してください',
  PleaseEnterCity: '市を入力してください',
  PleaseEnterPostalCode: '郵便番号を入力してください',
  PleaseEnterMbl: 'SCACコードを除くマスターB/L番号を入力してください',
  VesselCallSignCheck: '大文字英数字1〜9桁のみ',
  MarksFormat: '大文字・小文字英字、数字、ハイフン、スラッシュ、カンマ、スペース、コロン、引用符、プラス、アンダースコアのみ',
  MustBe3: '3文字である必要があります',
  OneCargoInfo: '貨物情報は合計1件のみ追加してください',
  Instructions: '理由を具体的に記入',
  ExplanationRequired: '「その他」を選んだ場合、この項目は必須です',
  ConfirmDeletion: '削除を確定',
  HblCheck: '大文字英数字、ハイフン、スラッシュのみ使用可',
  MustBe2: '2文字である必要があります',
  MustBe11: '11文字で、4文字目は必ずUにしてください',
  MustBeU: '4文字目はUである必要があります',
  MustBe4: '4文字である必要があります',
  VesselNotNull: 'ブッキングタブで船名を入力してください',
  VoyageNotNull: 'ブッキングタブで航海番号を入力してください',
  EtaNotNull: '基本タブでETAを入力してください',
  StreetName: 'Street name',
  ExampleIllustrateEORI: 'Give an example to illustrate EORI12828',
  CycleTwoHundredTimesNotUseMbl: '200回順延され、使用可能な関数番号が見つかりませんでした',
  GenerateMblButLessThan: '[{0}]バーが生成され、使用できる関数番号が残っていません',
  selectedRowCount: '{0} items have been selected',
  specialOperationCode: '特殊操作コード',
  doubleClickToAddSpecialOperationCode: 'ダブルクリックして特殊操作コードを追加します',
  selectSpecialOperationCode: '特殊操作コードをダブルクリックで選択',
  selectOperationRequirement: '操作要件をダブルクリックで選択',
  TransshipmentTransportationMethod: 'トランスファモード',
  specialHandlingCodes: '特殊操作コード',
  AddApproximateSymbolToItemColumn: '品名欄に約号を追加してください',
  BusinessLockedStatus: 'ビジネスロック状態',
  ImportChargeAllBusiness: '1つの業務番号が複数の業務タイプに同時に存在する場合は、すべて処理されます。つまり、番号が海外と海外の両方に存在する場合は、海外と海外の業務に同時に導入されます。',
  OriginBillOfLading: 'Original Bill of Lading',
  ShippingOrder: 'Book Of Documents',
  EmptyOut: 'Empty Out',
  GateIn: 'Gate in',
  VesselDeparturePOL: 'Vessel Departure POL',
  SendAll: 'Send all at once',
  textiles: '繊維製品',
  nonTextiles: '非繊維製品',
  PendingPickingOrder: 'ピッキングオーダー',
  PickingList: 'ピッキングリスト',
  WarehouseReleaseReceipt: '出庫伝票',
  QuickSearchMBL: 'Quick Search: Main Order Number',
  QuickSearchPickingOrderNo: 'Quick Search: Picking Order Number',
  DeliveryStation: '納品ステーション',
  AssemblyPlanNumber: '組立計画オーダー番号',
  FlightDateRange: 'フライト日範囲',
  OutboundInstruction: '出荷命令があるかどうか',
  WarehouseEntryNumber: '入庫伝票番号',
  BoardNumber: '板紙番号',
  GenerateAPickingList: 'ピックシートの生成',
  GenerateAndIssueOrders: '生成および請求',
  PickingOrderNumber: 'ピッキング番号',
  PickingStatus: 'ピッキング処理状況',
  ThisPickingOrderNoIs: 'This picking order no is:',
  SuccessfullyGenerated: 'Successfully generated',
  CloseAndCopyPickingOrderNo: 'Close and copy the picking order number',
  PleaseCheckSameDataWareHouse: '異なる倉庫の貨物は、1つのピッキングリストに載せてはならない',
  DifferentGoodsCannotSamePickingList: '異なる搬送先の貨物は、ピッキングリストに載せてはいけません',
  PickingCompleted: 'ピッキング完了',
  CancelPickingCompleted: 'ピッキング完了のキャンセル',
  OutboundStatus: '出荷処理状況',
  OutboundConfirmation: '出荷確認',
  CancelWarehouseConfirmation: '出荷確認のキャンセル',
  WarehouseConfirmationSuccessful: '出荷確認成功',
  CancelWarehouseConfirmationSuccessfully: 'アウトバウンドのキャンセルの確認に成功しました',
  PleaseSelectCorrespondPickingList: '対応するピックリストを個別にチェックしてください',
  PleaseCheckDataPickingCompletionUnOutBound: 'ピッキングが完了して出荷されていないデータをチェックしてください',
  PleaseCheckDataPickingCompletionOutBound: 'ピッキングが完了して出荷されたデータをチェックしてください',
  NotAllowEditPickingCompletion: 'ピッキング完了データの編集は許可されていません',
  NotAllowDeletePickingCompletion: 'ピッキングが完了したデータは削除できません',
  PleaseCheckDataRemoved: '削除するデータをチェックしてください',
  KeepLeastOneDetail: '少なくとも1つの詳細を保持',
  CargoVehicle: '荷さばき車',
  OutboundRemarks: '出庫コメント',
  DeliveryTime3: '受入時間',
  OutboundUser: '出庫人',
  QueryThreeMonths: '注意：照会データは3ヶ月以内のデータ',
  operationTrajectory: '運行軌跡',
  pickupEmptyContainer: '空コンテナ引き取り',
  arrivalFactory: '工場到着',
  departureFactory: '工場出発',
  enterTerminal: 'ターミナル到着',
  customsRelease: '税関放行',
  terminalRelease: 'ターミナル放行',
  loadedOnVessel: '船積み完了',
  departurePort: '出港',
  arrivalPort: '入港',
  destinationCustomsClearance: '仕向地通関',
  deliveryGoods: '配送',
  returnContainer: 'コンテナ返却',
  driver: '運転者',
  contactInfo: '連絡先',
  licensePlate: 'ナンバープレート',
  jobNumber: '取引番号',
  vesselVoyage: '船名航次',
  customsDeclarationNo: '関税申告番号',
  sailingDate: '出航日',
  closingTime: '税関締切時間',
  WarehouseEntrySerialNumber: '入倉ストリーム番号',
  PreWarehouseNumberOfPackages: '前置き倉庫の荷物数',
  PreWarehouseGrossWeight: '前置き倉庫の総重量',
  PreWarehouseVolume: '前置き倉庫の体積',
  PreWarehouseChargeableWeight: '前置き倉庫の課金重量',
  CargoTerminalNumberOfPackages: '貨物ターミナルの荷物数',
  CargoTerminalGrossWeight: '貨物ターミナルの総重量',
  CargoTerminalVolume: '貨物ターミナルの体積',
  CargoTerminalChargeableWeight: '貨物ターミナルの課金重量',
  DocumentationChargeableWeight: '書類作成の課金重量',
  SignedDocumentNumberOfPackages: '署名済書類の荷物数',
  SignedDocumentGrossWeight: '署名済書類の総重量',
  SignedDocumentVolume: '署名済書類の体積',
  SignedDocumentChargeableWeight: '署名済書類の課金重量',
  IsNeedInvoice: '請求書発行要否',
  DeadlineForDeclaringHazards: '危険申报の締切日',
  BookingManagementListPage: '予約管理リストページ',
  PrintByFleet: '車両グループ別に印刷',
  BoxContents: '箱の内容物',
  BatchAssignMasterOrderNumbers: '一括でマスターオーダー番号を割り当てる',
  PleaseForThePositiveAssign: '正の操作を行う業務を選択して割り当ててください。',
  SuccessfullyItemsFailed1Items: '{0}件が正常に割り当てられました。{1}件は失敗しました！',
  ReasonForFailure: '失敗の原因：',
  MBLNOAlreadyExists: 'MB/L番号は既に存在しています',
  NonOperational: '非稼働',
  UnableTheMainTrackingNumber: 'メイン送付番号が一致しません',
  WarehouseEntryInformation: '倉庫入庫情報',
  NumberOfItemsReceived: '入庫件数',
  GrossWeightUponEntry: '入庫時の総重量',
  WarehouseVolume: '倉庫体積'
}
